var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Fachleistung', ['QMC.Klient', 'QMC.Home']).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProviderr, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('case', {
            url: '/fls/case',
            templateUrl: qmcBase + '/fls/Case',
            controller: 'FlsCaseController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Case List');
                    }]
            }
        })
            .state('companion', {
            url: '/fls/companion',
            templateUrl: qmcBase + '/fls/Companion',
            controller: 'FlsCompanionController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Companion');
                    }]
            }
        })
            .state('documentation', {
            url: '/fls/documentation',
            templateUrl: qmcBase + '/fls/DocumentationList',
            controller: 'FlsDocumentationListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Documentation List');
                    }]
            }
        })
            .state('documentationdetail', {
            url: '/fls/documentation/:id',
            templateUrl: qmcBase + '/fls/Documentation',
            controller: 'FlsDocumentationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Documentation Detail');
                    }]
            }
        })
            .state('documentationnew', {
            url: '/fls/documentation/new/:flsCaseIds?:plannedDocumentationId',
            templateUrl: qmcBase + '/fls/Documentation',
            controller: 'FlsDocumentationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Documentation New');
                    }]
            }
        })
            .state('planedDocumenation', {
            url: '/fls/case/PlanedDocumentation',
            templateUrl: qmcBase + '/fls/PlanedDocumentation',
            controller: 'FlsPlanedRawListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Planed Documentation');
                    }]
            }
        })
            .state('rawDocumentation', {
            url: '/fls/case/RawDocumentation',
            templateUrl: qmcBase + '/fls/RawDocumentation',
            controller: 'FlsPlanedRawListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Raw Documentation');
                    }]
            }
        })
            .state('documentationEndingConfirmation', {
            url: '/fls/documentationEndingConfirmation',
            templateUrl: qmcBase + '/fls/documentationEndingConfirmation',
            controller: 'FlsDocumentationEndingConfirmationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Confirm Documentation Ending');
                    }]
            }
        })
            .state('signature', {
            url: '/fls/signature?:page',
            templateUrl: qmcBase + '/fls/SignatureList',
            controller: 'FlsSignatureListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Signature List');
                    }]
            }
        })
            .state('signaturedetail', {
            url: '/fls/signature/:id',
            templateUrl: qmcBase + '/fls/SignatureList',
            controller: 'FlsSignatureListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Signature List for id');
                    }]
            }
        })
            .state('weekplanner', {
            url: '/fls/weekplanner?:startDay?view',
            templateUrl: qmcBase + '/fls/WeekplannerList',
            controller: 'FlsWeekplannerListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Weekplanner List');
                    }]
            },
            params: {
                startDay: {
                    dynamic: true
                },
                view: {
                    dynamic: true
                }
            }
        })
            .state('summary', {
            url: '/fls/summary',
            templateUrl: qmcBase + '/fls/Summary',
            controller: 'FlsSummaryController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: FLS Summary');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Fachleistung.HttpProvider = HttpProvider;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Fachleistung')
        .config(['$httpProvider', QMC.Fachleistung.HttpProvider.configureHttpProvider]);
})();
// namespace FullCalendar {
//     // ReSharper disable once InconsistentNaming
//     export interface EventObject {
//         type: string;
//     }
// }
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsService_1;
        let FlsService = FlsService_1 = class FlsService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Fachleistung';
            }
            static getEditorSettingsCacheKey(caseIds, docuId, date, carerId) {
                const dateMs = date && typeof date.getTime === 'function' ? date.getTime() : String(date);
                return 'editorSettings:' + JSON.stringify([caseIds, docuId, dateMs, carerId]);
            }
            static getWvModelCacheKey(flsCaseIds, flsDocumentationId, carersIds, date) {
                const dateMs = date && typeof date.getTime === 'function' ? date.getTime() : String(date);
                return 'docWvModel:' + JSON.stringify([flsCaseIds, flsDocumentationId, carersIds, dateMs]);
            }
            /***** Case *****/
            getCarerList() {
                return super.get('/Person/Carer', {}, (data) => {
                    return data;
                });
            }
            getCarerListForCase(caseId = QMC.Common.Constants.GUID_EMPTY, addTheLoggedUser = false) {
                return super.get(this.modulePath + '/Case/Carer/' + caseId, { addTheLoggedUser: addTheLoggedUser }, (data) => {
                    return data;
                });
            }
            getCasesListByViewPermission(currentOnly = false, onlyActive = true) {
                return super.get(this.modulePath + '/Case/Viewable', { currentOnly, onlyActive }, (data) => {
                    return data;
                });
            }
            getCasesList(carerTypeFilterId, currentOnly = false, carerId = undefined, onlyForDisplay = false) {
                var additionalParams = "?currentOnly=" + currentOnly;
                if (carerTypeFilterId !== undefined && carerTypeFilterId !== null && carerTypeFilterId !== "")
                    additionalParams += "&carerTypeFilterId=" + carerTypeFilterId;
                additionalParams += "&onlyForDisplay=" + onlyForDisplay;
                return super.getPagination(this.modulePath + '/Case' + additionalParams, { page: -1, pageSize: -1, carerId }).then(data => data.items);
            }
            getCasesListPaginated(carerTypeFilterId, page = -1, pageSize = -1, currentOnly = false, listSearch = "", carerId = null, searchProperties = [], sortBy = '', sortDescending = false) {
                let additionalParams = "?currentOnly=" + currentOnly;
                if (carerTypeFilterId !== undefined && carerTypeFilterId !== null && carerTypeFilterId !== "")
                    additionalParams += "&carerTypeFilterId=" + carerTypeFilterId;
                return super.getItem(this.modulePath + '/Case' + additionalParams, { page: page, pageSize: pageSize, listSearch: listSearch, carerId, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            getFlsCase(id) {
                const key = 'flsCase:' + id;
                return this.getCached(key, () => super.getItem(this.modulePath + '/Case/' + id, {}, (data) => data));
            }
            getFlsCases(ids) {
                const key = 'flsCases:' + JSON.stringify(ids);
                return this.getCached(key, () => super.getItem(this.modulePath + '/Case/Multiple', { ids: ids }, (data) => data));
            }
            getFlsCaseWv() {
                const key = 'flsCaseWv';
                return this.getCached(key, () => super.getItem(this.modulePath + '/Case/WvModel', {}, (data) => data));
            }
            getFlsCasePaused(caseIds) {
                return super.get(this.modulePath + '/Case/Paused', { caseIds }, (data) => {
                    return data;
                });
            }
            getPlannedDocumentations(days, daysFuture) {
                return super.get(this.modulePath + '/Documentation/PlanedDocumentations', { days: days, daysFuture: daysFuture }, (data) => {
                    return data;
                });
            }
            getRawDocumentations(days) {
                return super.get(this.modulePath + '/Documentation/RawDocumentations', { days: days }, (data) => {
                    return data;
                });
            }
            /***** Contingent *****/
            getContingent(flsCaseId, targetDate) {
                return super.get(this.modulePath + '/Contingent/' + flsCaseId, { targetDate: targetDate }, (data) => {
                    for (let conti of data) {
                        for (let item of conti.contingentItems) {
                            if (item.highlightColor && item.highlightColor.length > 0) {
                                const color = item.highlightColor.substring(1, 7);
                                item.highlightText = (((parseInt(color.substring(0, 2), 16) * 0.299)
                                    + (parseInt(color.substring(2, 4), 16) * 0.587) + (parseInt(color.substring(4, 6), 16) * 0.114)) > 186) ?
                                    "#000000" : "#FFFFFF";
                            }
                        }
                    }
                    return data;
                });
            }
            /***** Config *****/
            getUserConfig() {
                return super.getItem(this.modulePath + '/Documentation/UserConfig', {}, (data) => {
                    return data;
                });
            }
            getCatalogSettings(caseIds, docuId, date, carerId = null) {
                date = moment(date).startOf('day').toDate();
                const key = FlsService_1.getEditorSettingsCacheKey(caseIds, docuId, date, carerId);
                return this.getCached(key, () => super.post(this.modulePath + '/Documentation/EditorSettings', { flsCaseIds: caseIds, flsDocumentationId: docuId, carerId, date }).then((data) => data));
            }
            /***** Report Template *****/
            getReportTemplates() {
                return super.get(this.modulePath + '/ReportTemplate', {}, (data) => {
                    return data;
                });
            }
            getReportTemplateItems(id) {
                return super.get(this.modulePath + '/ReportTemplate/' + id, {}, (data) => {
                    return data;
                });
            }
            /***** SupportPlanTarget Template *****/
            getSupportPlanTargetTemplates(clientId) {
                return super.get('/SupportPlan/Template/' + clientId, {}, (data) => {
                    return data;
                });
            }
            getSupportPlanTargetTemplateItems(id) {
                return super.get('/SupportPlan/Template/item/' + id, {}, (data) => {
                    return data;
                });
            }
            /***** SupportPlanPhase *****/
            getSupportPlanActivePhase(supportPlanId) {
                return super.getItem('/SupportPlan/' + supportPlanId + '/ActivePhase/', {}, (data) => {
                    return data;
                }, { silentOnClientError: true });
            }
            /***** Signature *****/
            getSignature(id) {
                return super.get(this.modulePath + '/Signature/' + id, {}, (data) => {
                    return data;
                });
            }
            getSignatureWv() {
                return super.cachedGet(this.modulePath + '/Signature/WvModel', {}, (data) => {
                    return data;
                });
            }
            postSignature(data) {
                return super.post(this.modulePath + '/Signature', data).then((data) => { return data; });
            }
            /***** Week Planning *****/
            getWeekPlanningList(personId, dateFrom, dateTo) {
                return super.get(this.modulePath + '/WeekPlanning', { personId, dateFrom: dateFrom, dateTo: dateTo }, (data) => {
                    return data;
                });
            }
            postWeekPlanningPlannedDoc(data) {
                return super.post(this.modulePath + '/WeekPlanning', data).then((e) => {
                    return e;
                });
            }
            putWeekPlanningPlannedDoc(id, data) {
                return super.put(this.modulePath + '/WeekPlanning/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteWeekPlanningPlannedDoc(id) {
                return super.delete(this.modulePath + '/WeekPlanning/' + id).then((data) => { return data; });
            }
            getAllPossibleCarer() {
                return super.get(this.modulePath + '/WeekPlanning/Carer', {}, (data) => { return data; });
            }
            /***** Fls Documentation *****/
            getFlsDocumentationList(page, pageSize, dateFrom, dateTo, flsCaseId, showOnlyOwnCreated, onlyCurrentCases = false, onlyOwnCases = false, listSearch = '', searchProperties = [], sortBy = '', sortDescending = false) {
                return super.get(this.modulePath + '/Documentation', { dateFrom: dateFrom, dateTo: dateTo, flsCaseId: flsCaseId, showOnlyOwnCreated: showOnlyOwnCreated, page: page, pageSize: pageSize, onlyCurrentCases: onlyCurrentCases, onlyOwnCases: onlyOwnCases, listSearch, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            getUnsignedFlsDocumentationList(page, pageSize, dateFrom, dateTo, onlyOwn = false, listSearch = '', onlyCurrentCases = false) {
                return super.get(this.modulePath + '/Documentation/Unsigned', { page: page, pageSize: pageSize, dateFrom: dateFrom, dateTo: dateTo, onlyOwn: onlyOwn, listSearch: listSearch, onlyCurrentCases: onlyCurrentCases }, (data) => {
                    return data;
                });
            }
            getFlsDocumentation(id) {
                return super.getItem(this.modulePath + '/Documentation/' + id, {}, (data) => {
                    return data;
                });
            }
            getFlsDocumentationWvModel(flsCaseIds, flsDocumentationId, carersIds, date) {
                const key = FlsService_1.getWvModelCacheKey(flsCaseIds !== null && flsCaseIds !== void 0 ? flsCaseIds : [], flsDocumentationId !== null && flsDocumentationId !== void 0 ? flsDocumentationId : null, carersIds !== null && carersIds !== void 0 ? carersIds : [], date !== null && date !== void 0 ? date : null);
                return this.getCached(key, () => super.post(this.modulePath + '/Documentation/WvModel', { flsCaseIds: flsCaseIds, flsDocumentationId: flsDocumentationId, carersIds: carersIds, date }).then((data) => data));
            }
            checkForWarningsAndErrors(data, isPlanned = false) {
                return super.post(this.modulePath + '/Documentation/WarningsAndErrors' + '?isPlanned=' + isPlanned, data).then((data) => {
                    return data;
                });
            }
            postFlsDocumentation(data, distributeHours = false, carerId = null, multiple = false) {
                const postString = this.modulePath + '/Documentation?distributeHours=' + distributeHours + '&carerId=' + carerId + '&multiple=' + multiple;
                return super.post(postString, data).then((data) => {
                    return data;
                });
            }
            putFlsDocumentation(id, data, carerId = null, onlyModifyDescription = false) {
                return super.put(this.modulePath + '/Documentation/' + id + '?carerId=' + carerId + '&onlyModifyDescription=' + onlyModifyDescription, data).then((data) => {
                    return data;
                });
            }
            deleteFlsDocumentation(id, data) {
                return super.put(this.modulePath + '/Documentation/Delete/' + id, data).then((data) => {
                    return data;
                });
            }
            /***** Fls Documentation Summary *****/
            getFlsDocumentationSummary(filter) {
                return super.post(`${this.modulePath}/Documentation/Summary/${filter.id}?page=${filter.pagination.page}&pageSize=${filter.pagination.pageSize}`, filter).then((data) => {
                    return data;
                });
            }
            /***** Fls Group *****/
            getFlsGroupList(page, pageSize) {
                return super.get(this.modulePath + '/Group', { page: page, pageSize: pageSize }, (data) => {
                    return data;
                });
            }
            getFlsGroupDetail(id) {
                return super.getItem(this.modulePath + '/Group/' + id, {}, (data) => {
                    return data;
                });
            }
            /***** Required Fields *****/
            getFlsRequiredFields() {
                return super.get(this.modulePath + "/Documentation/RequiredFields", {}, (data) => {
                    return data;
                });
            }
            /***** Confirm Documentation Ending *****/
            getDocEndingConfirmList() {
                return super.get(this.modulePath + "/FlsConfirmDocumentationEnding", {}, (data) => {
                    return data;
                });
            }
            getDocEndingConfirmForFlsCase(flsCaseId) {
                return super.getItem(this.modulePath + "/FlsConfirmDocumentationEnding/ForFlsCase/" + flsCaseId, {}, (data) => {
                    return data;
                });
            }
            postDocEndingConfirm(data) {
                return super.post(this.modulePath + "/FlsConfirmDocumentationEnding", data).then((data) => {
                    return data;
                });
            }
            putDocEndingConfirm(id, data) {
                return super.put(this.modulePath + "/FlsConfirmDocumentationEnding/" + id, data).then((data) => {
                    return data;
                });
            }
            /***** other *****/
            getMileage(id) {
                return super.getItem('/Resource/Vehicle/Mileage/' + id, {}, (data) => {
                    return data;
                });
            }
        };
        FlsService = FlsService_1 = __decorate([
            QMC.Service('QMC.Fachleistung', 'FachleistungService'),
            QMC.Inject('$http', '$q')
        ], FlsService);
        Fachleistung.FlsService = FlsService;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsCaseListController = class FlsCaseListController {
            constructor($location, $qui) {
                this.$location = $location;
                this.$qui = $qui;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
            }
        };
        FlsCaseListController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsCaseController'),
            QMC.Inject('$location', '$qui')
        ], FlsCaseListController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let CaseListDirective = class CaseListDirective {
            constructor(flsService, $qui, $state, userService, permissionService, lng) {
                this.flsService = flsService;
                this.$qui = $qui;
                this.$state = $state;
                this.userService = userService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.restrict = 'E';
                this.templateUrl = './fls/CaseList/';
                this.replace = true;
                this.scope = {};
                this.permissionCersovsky = false;
                this.allowTableExport = false;
                this.ui = new QMC.Fachleistung.UserInterface();
                this.filter = '';
                this.page = 0;
                this.paginationInfo = { totalItemsCount: 0, totalPages: 0 };
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.isFirstLoad = true;
                this.daysToHighlightCases = 0;
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.lastPersistedCaseFilterJson = null;
                this.loading = false;
                this.sortBy = '';
                this.sortDescending = false;
                this.checkedCases = [];
                this.checkedCasesCount = 0;
                this.carerTypesMap = [];
                this.tableData = { cards: [], items: [] };
                this.link = (scope) => {
                    this.checkedCases = [];
                    this.checkedCasesCount = 0;
                    this.isFirstLoad = true;
                    scope.vm = this;
                    QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: this.$state.$current.name,
                        params: {}
                    }));
                    this.permissionService.getPermissionsByObjectTypes([230000, 230017]).then((data) => {
                        this.allowTableExport = data[0].print;
                        this.userService.getUserSettings(["FACHLSDOKU.ERFASSUNGENDE.AKTIV"], false).then((dataSetting) => {
                            this.permissionCersovsky = dataSetting[0].value.toLowerCase() === "true" && data[1].moduleAccess;
                            this.$qui.scopeApply(scope);
                        });
                    });
                    this.userService.getUserSettings([QMC.Common.UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA_KEY, "FLS.CASE.DAYSTOHIGHLIGHT", QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY]).then((data) => {
                        this.shouldLoadTableData = data[0].value === "" ? this.shouldLoadTableData : data[0].value.toLowerCase() === 'true';
                        this.daysToHighlightCases = data[1].value === "" ? this.daysToHighlightCases : parseInt(data[1].value);
                        this.caseFilter = data[2].value === '' ? this.caseFilter : JSON.parse(data[2].value);
                        this.lastPersistedCaseFilterJson = JSON.stringify(this.caseFilter);
                        if (this.shouldLoadTableData) {
                            this.getCases();
                            scope.$watch('vm.caseFilter', (newValue, oldValue) => {
                                if (newValue === oldValue || !newValue)
                                    return;
                                this.page = 0;
                                this.getCases();
                            }, true);
                        }
                    });
                    this.getWv();
                    scope.$watch('vm.filter', (newValue, oldValue) => {
                        if (newValue != oldValue) {
                            if (this.isFirstLoad) {
                                setTimeout(() => {
                                    this.isFirstLoad = false;
                                }, 5);
                            }
                            else if (this.shouldLoadTableData) {
                                let lastValue = this.filter;
                                setTimeout(() => {
                                    if (this.filter == lastValue && (newValue.length < oldValue.length || this.filter.length >= 3)) {
                                        this.page = 0;
                                        this.getCases();
                                    }
                                }, 1500);
                            }
                        }
                    });
                    scope.$watch('vm.page', (newValue, oldValue) => {
                        if (newValue != oldValue)
                            if (this.isFirstLoad) {
                                setTimeout(() => {
                                    this.isFirstLoad = false;
                                });
                            }
                            else {
                                this.getCases();
                            }
                    });
                    $("#docEndConBtn").show();
                };
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
            }
            /////////////// UI FUNCTIONS ///////////////
            getData() {
                this.getCases();
            }
            currentfilter(entry) {
                const filterActive = $('#filterActive').val();
                if (filterActive === 'true') {
                    return entry.isCurrent;
                }
                else
                    return true;
            }
            async persistCaseFilter() {
                const caseFilterJson = JSON.stringify(this.caseFilter);
                if (caseFilterJson === this.lastPersistedCaseFilterJson)
                    return;
                await this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: caseFilterJson }] });
                this.lastPersistedCaseFilterJson = caseFilterJson;
            }
            toggleContingentModal(data) {
                this.currentCase = data;
                setTimeout(() => {
                    this.openContingent();
                });
            }
            toggleCommentModal(data) {
                this.currentCase = data;
                $('#caseComment').modal('toggle');
            }
            countCheckedCases() {
                this.checkedCasesCount = this.checkedCases.length;
            }
            toggleChecked(isChecked, caseObj) {
                // check if case is allowed to be selected (fix accountability and report templates)
                if (isChecked) {
                    const selectedCases = this.cases.filter(x => this.checkedCases.some(y => y === x.objectId));
                    const fixAccRule = selectedCases.filter(x => x.isAccountableRuleFix)[0];
                    const fixRepTemp = selectedCases.filter(x => x.isReportTemplateFix)[0];
                    const getEmphString = (str) => `<em>${str}</em>`;
                    const createErrorString = (conflict, oldV, newV, displayTitle) => `<strong style="font-size: 2rem">${conflict}.</strong><br />
					(${this.$qui.formatString(this.lng.translate(20016237, 'Bereits gewählt: {0}, aktuell: {1}'), getEmphString(oldV), getEmphString(newV))}) <br />
					(${this.lng.translate(20016238, 'Ursprung')}: ${getEmphString(displayTitle)})`;
                    const errors = [];
                    if (fixAccRule && caseObj.isAccountableRuleFix && (caseObj.defaultAccountableRuleId !== fixAccRule.defaultAccountableRuleId))
                        errors.push(createErrorString(this.lng.translate(20016235, 'Ein bereits gewählter Fall hat eine abweichende fixe Abrechenbarkeitsregel'), fixAccRule.accountableRule, caseObj.accountableRule, fixAccRule.displayTitle));
                    if (fixRepTemp && caseObj.isReportTemplateFix && (caseObj.reportTemplateId !== fixRepTemp.reportTemplateId))
                        errors.push(createErrorString(this.lng.translate(20016236, 'Ein bereits gewählter Fall hat eine abweichende fixe Berichtsvorlage'), fixRepTemp.reportTemplate, caseObj.reportTemplate, fixRepTemp.displayTitle));
                    if (errors.length) {
                        isChecked = false;
                        errors.forEach(err => this.$qui.notify({
                            message: err,
                            title: `${this.lng.translate(20000331, 'Auswahl nicht möglich')}: ${getEmphString(caseObj.displayTitle)}`,
                            icon: "qm-icon-error",
                            status: "warning",
                            timer: 8000
                        }));
                    }
                }
                for (const curCase of this.cases) {
                    if (curCase.objectId === caseObj.objectId) {
                        curCase.isChecked = isChecked;
                    }
                }
                if (isChecked)
                    this.checkedCases.push(caseObj.objectId);
                else
                    this.checkedCases = this.checkedCases.filter(item => item !== caseObj.objectId);
                this.countCheckedCases();
                this.tableData.items.forEach((item) => {
                    item.Avatar.selected = this.checkedCases.some(x => x === item.objectId.value);
                });
                this.tableData.cards.forEach((item) => {
                    item.avatar.selected = this.checkedCases.some(x => x === item.id);
                });
            }
            openMultipleDocumentation() {
                let caseIds = "";
                for (const caseId of this.checkedCases) {
                    caseIds += caseId + ",";
                }
                caseIds = caseIds.substring(0, caseIds.length - 1);
                $(".modal-backdrop").hide();
                $("body").removeClass("modal-open");
                this.$state.go('documentationnew', { "flsCaseIds": caseIds });
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getWv() {
                this.flsService.getFlsCaseWv().then((data) => {
                    this.flsCaseWv = data;
                    this.carerTypesMap = this.flsCaseWv.carerTypeWv.map(x => ({ text: x.name, value: x.objectId }));
                    // Set carer type filter from local storage, or if not present, from the first wv item
                    if (!this.flsCaseWv.carerTypeWv.some(x => x.objectId === this.caseFilter.carerTypeFilterId) || !this.caseFilter.carerTypeFilterId || this.caseFilter.carerTypeFilterId === QMC.Common.Constants.GUID_EMPTY)
                        this.caseFilter.carerTypeFilterId = this.flsCaseWv.carerTypeWv[0].id;
                });
            }
            getCases() {
                var _a, _b, _c;
                this.persistCaseFilter();
                if (!this.flsCaseWv) {
                    setTimeout(() => { this.getCases(); }, 100);
                    return;
                }
                this.loading = true;
                const days = this.daysToHighlightCases;
                let searchProperties = this.ui.getDisplayedPropertiesFromSchema(this.ui.caseTable);
                if (!((_c = (_b = (_a = this.ui) === null || _a === void 0 ? void 0 : _a.caseTable) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.some(y => y.isReportTemplateFix)))
                    searchProperties = searchProperties.filter(x => x !== 'reportTemplate' && x !== 'isReportTemplateFix');
                this.flsService.getCasesListPaginated(this.caseFilter.carerTypeFilterId, this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.caseFilter.onlyCurrentCases, this.filter, null, [...searchProperties, 'personNr', 'personShortCaption'], this.sortBy, this.sortDescending).then((data) => {
                    var _a;
                    this.paginationInfo = data.paginationInfo;
                    for (const caseId of this.checkedCases) {
                        for (const item of data.items) {
                            if (item.objectId == caseId)
                                item.isChecked = true;
                        }
                    }
                    this.cases = data.items;
                    data.items = data.items.map(function (obj) {
                        if (obj.dateTo && Math.abs(moment().startOf('day').diff(moment(obj.dateTo).startOf('day'), 'days')) <= days)
                            obj.highlightDate = { 'background-color': 'orange', 'color': 'white' };
                        if (!obj.isCurrent)
                            obj.highlightDate = { 'background-color': 'orangered', 'color': 'white' };
                        if (obj.dateTo !== null && obj.dateTo !== undefined) {
                            obj.date = moment(obj.dateFrom).format('DD.MM.YYYY') + " - " + moment(obj.dateTo).format('DD.MM.YYYY');
                        }
                        else if (obj.dateFrom !== null && obj.dateFrom !== undefined) {
                            obj.date = moment(obj.dateFrom).format('DD.MM.YYYY');
                        }
                        else {
                            obj.date = "";
                        }
                        return obj;
                    });
                    data.items = data.items.map(item => {
                        item.fullName = this.$qui.createPersonDisplay(item.name, item.forename, item.personShortCaption, item.personNr);
                        return item;
                    });
                    this.loading = false;
                    this.isFirstLoad = false;
                    this.ui.caseTable.data = (_a = data.items) !== null && _a !== void 0 ? _a : [];
                    this.$qui.functionWaiter("ui.createTable", this);
                });
            }
        };
        CaseListDirective = __decorate([
            QMC.Directive('QMC.Fachleistung', 'qmCaseList', ['FachleistungService', '$qui', '$state', 'UserService', 'QmcPermissionService', 'QmcLanguageService'])
        ], CaseListDirective);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsCompanionController = class FlsCompanionController {
            constructor($location, flsService, $qui, $scope, $stateParams, $state, userService, permissionService, terminService, lng) {
                this.$location = $location;
                this.flsService = flsService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.permissionService = permissionService;
                this.terminService = terminService;
                this.lng = lng;
                this.loading = {
                    permission: true,
                    carer: false,
                    cases: false,
                    report: false,
                    plannings: false,
                    settings: false,
                    wv: false,
                    editorSettings: false,
                    requiredFields: false,
                    save: false,
                    allLoaded: () => { return !(this.loading.permission || this.loading.carer || this.loading.cases || this.loading.report || this.loading.plannings || this.loading.settings || this.loading.wv || this.loading.editorSettings || this.loading.requiredFields || this.loading.save); }
                };
                this.title = '';
                this.formWatcherList = [];
                this.editLockType = 'errors';
                this.wvsByDate = {};
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                this.title = `${this.lng.translate(20016003, "Dokumentation vom")} ${moment().format('DD.MM.YYYY')} (WebClient)`;
                permissionService.getPermissionsByObjectTypes([230000, 230021]).then((data) => {
                    this.new = data[0].new && data[0].moduleAccess;
                    this.editLockType = data[1].openFile ? 'warnings' : 'errors';
                    this.init();
                    this.loading.requiredFields = true;
                    this.flsService.getFlsRequiredFields().then((rdata) => {
                        this.loading.settings = true;
                        this.userService.getUserSettings(["FLS.DEFAULTCARETYPE", "FLS.DEFAULTCONTACTTYPE", "FLS.DEFAULTACTIVITYTYPE", "FLS.DOKU.BERICHTTITELVORGABE", "FLS.DOKU.BERICHTTITEL", "FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT", "FLS.DEFAULTVALUE_MANUAL", "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER", "FLS.DEFAULTACCOUNTABILITY"], false).then((data) => {
                            this.settings.flsDefaultCareType = $.grep(data, function (e) { return e.key === "FLS.DEFAULTCARETYPE"; })[0].value;
                            this.settings.flsDefaultContactType = $.grep(data, function (e) { return e.key === "FLS.DEFAULTCONTACTTYPE"; })[0].value;
                            this.settings.flsDefaultActivityType = $.grep(data, function (e) { return e.key === "FLS.DEFAULTACTIVITYTYPE"; })[0].value;
                            this.defaultAccountabilityRule = $.grep(data, function (e) { return e.key === "FLS.DEFAULTACCOUNTABILITY"; })[0].value;
                            if (data[3].value === "1")
                                this.title = "";
                            if (data[3].value === "2")
                                this.title = data[4].value;
                            if (data[7].value.length > 0)
                                this.settings.isManuelTimeVisible = data[7].value.toLowerCase() === "true";
                            if (data[5].value.length > 0)
                                this.settings.allowManual = data[5].value.toLowerCase() === "true" && this.settings.isManuelTimeVisible;
                            if (data[6].value.length > 0 && this.settings.allowManual && this.settings.isManuelTimeVisible)
                                this.settings.manualDefault = data[6].value.toLowerCase() === "true";
                            this.flsService.getUserConfig().then((dataUserConfig) => {
                                this.settings.allowEmptyReports = dataUserConfig.allowEmptyReports;
                                this.showTime = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : dataUserConfig.allowEmptyReports;
                                this.settings.requiredFields = rdata;
                                this.planForm.workingHours.isMiscontactEnabled = rdata.workingHours.miscontactWvId;
                                this.loading.requiredFields = false;
                                this.loading.settings = false;
                                this.loading.permission = false;
                                this.events();
                                this.getCarer();
                                this.getCases();
                                this.getReportTemplates();
                            });
                        });
                    });
                });
            }
            init() {
                var _a, _b;
                this.planForm = {
                    caseId: null,
                    carerId: $('#session').data().personId,
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    freedays: {
                        holiday: false, vacation: false
                    },
                    report: {
                        templateId: QMC.Common.Constants.GUID_EMPTY, itemId: QMC.Common.Constants.GUID_EMPTY, isTemplateFix: false
                    },
                    timeFrom: new Date(),
                    timeTo: new Date(),
                    weekdays: {
                        mo: true, tu: true, we: true, th: true, fr: true, sa: false, su: false
                    },
                    workingHours: {
                        abrechenbarkeitId: QMC.Common.Constants.GUID_EMPTY,
                        activityWvId: QMC.Common.Constants.GUID_EMPTY,
                        careTypeWvId: QMC.Common.Constants.GUID_EMPTY,
                        contactTypeWvId: QMC.Common.Constants.GUID_EMPTY,
                        durationInHours: 0,
                        isManualDuration: false,
                        carerObjectId: $("#session").data().personId,
                        miscontactWvId: QMC.Common.Constants.FLS_NO_MISCONTACT,
                        isMiscontactEnabled: (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.requiredFields) === null || _b === void 0 ? void 0 : _b.workingHours.miscontactWvId
                    }
                };
                if (QMC.Common.personalLocalStorage.getItem(this.cacheName) && QMC.Common.personalLocalStorage.getItem(this.cacheName).length > 0) {
                    this.planForm.caseId = QMC.Common.personalLocalStorage.getItem(this.cacheName);
                }
                this.planForm.dateFrom.setDate(1);
                this.planForm.dateTo = moment().endOf('month').toDate();
                this.planForm.timeFrom.setHours(8, 0, 0, 0);
                this.planForm.timeTo.setHours(12, 0, 0, 0);
                this.createForm = {
                    caseId: null,
                    documentations: null,
                    reportTemplateId: null,
                    reportTemplateItemId: null
                };
                this.settings = {
                    isAccountableRuleFix: false,
                    flsDefaultActivityType: null,
                    flsDefaultCareType: null,
                    flsDefaultContactType: null,
                    editor: null,
                    requiredFields: null,
                    allowEmptyReports: false,
                    manualDefault: false,
                    allowManual: true,
                    isManuelTimeVisible: true
                };
                this.selectLists = {
                    accountability: [],
                    activity: [],
                    careType: [],
                    carer: [],
                    cases: [],
                    contactType: [],
                    miscontact: []
                };
            }
            events() {
                this.$scope.$watch('vm.planForm.report.templateId', (newVal, oldVal) => { if (newVal !== oldVal)
                    this.getReportTemplateItems(); });
                this.$scope.$watch('vm.planForm.carerId', (newVal, oldVal) => {
                    if (newVal !== oldVal) {
                        this.getCases();
                    }
                });
                this.$scope.$watch('vm.planForm.caseId', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal && newVal !== QMC.Common.Constants.GUID_EMPTY) {
                        this.createForm.documentations = [];
                        this.getWvForCase();
                        this.getEditorSetting();
                        QMC.Common.personalLocalStorage.setItem(this.cacheName, this.planForm.caseId);
                        this.setFixedTemplate(newVal);
                        this.checkCasePaused();
                    }
                });
                this.$scope.$watch('vm.planForm.dateTo', (newVal, oldVal) => {
                    if (newVal === oldVal || !this.planForm.caseId || this.planForm.caseId === QMC.Common.Constants.GUID_EMPTY)
                        return;
                    this.getWvForCase();
                    this.getEditorSetting();
                });
                this.$scope.$watch('vm.planForm.report', (newVal, oldVal) => {
                    if (newVal !== oldVal && this.createForm) {
                        this.createForm.reportTemplateItemId = this.planForm.report.itemId;
                        this.createForm.reportTemplateId = this.planForm.report.templateId;
                    }
                }, true);
                this.$scope.$watch('vm.planForm.workingHours', (newVal, oldVal) => {
                    // if activity, caretype, ... are changed revalidate all items
                    if (newVal !== oldVal && this.createForm.documentations)
                        this.validatePlannings();
                }, true);
            }
            /////////////// DISPLAY LOGIC ///////////////
            setFixedTemplate(caseId) {
                this.planForm.report.isTemplateFix = false;
                const cCase = this.cases.filter(x => x.objectId === caseId)[0];
                if (cCase.reportTemplateId && cCase.reportTemplateId != QMC.Common.Constants.GUID_EMPTY) {
                    this.planForm.report.templateId = cCase.reportTemplateId;
                    this.planForm.report.isTemplateFix = cCase.isReportTemplateFix;
                }
            }
            checkCasePaused() {
                // Check if any case is paused
                this.pausedCases = [];
                if (!this.planForm.caseId || this.planForm.caseId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.flsService.getFlsCasePaused([this.planForm.caseId]).then((pauseData) => {
                    for (const curCase of this.cases) {
                        if (pauseData[curCase.objectId]) {
                            this.pausedCases.push(curCase);
                        }
                    }
                    if (this.pausedCases.length > 0) {
                        $('#casePausedModal').modal('show');
                    }
                });
            }
            createPlanning() {
                this.loading.plannings = true;
                this.createForm = null;
                // destroy all current validation watchers
                for (const watcher of this.formWatcherList)
                    watcher();
                this.formWatcherList = [];
                const dates = this.getDatesInTimeFrame(this.planForm.dateFrom, this.planForm.dateTo);
                // load editor config for each day
                this.wvsByDate = {};
                dates.forEach(date => {
                    this.wvsByDate[date.toISOString()] = 'LOADING';
                    this.flsService.getFlsDocumentationWvModel([this.planForm.caseId], QMC.Common.Constants.GUID_EMPTY, [this.planForm.carerId], date)
                        .then(data => this.wvsByDate[date.toISOString()] = data[0])
                        .catch(() => this.wvsByDate[date.toISOString()] = 'ERROR');
                });
                this.terminService.getHolidaysSpecific(this.planForm.dateFrom.getFullYear(), !this.planForm.freedays.holiday, !this.planForm.freedays.vacation).then((holidays) => {
                    this.createForm = {
                        caseId: this.planForm.caseId,
                        documentations: [],
                        reportTemplateId: this.planForm.report.templateId,
                        reportTemplateItemId: this.planForm.report.itemId,
                    };
                    for (let i = 0; i < dates.length; i++) {
                        const item = {
                            documentationId: this.$qui.generateGuid(),
                            active: this.checkIfShouldActivate(dates[i], holidays, this.planForm.weekdays),
                            date: dates[i],
                            timeFrom: this.planForm.timeFrom,
                            timeTo: this.planForm.timeTo,
                            comment: '',
                            validation: { errors: [], warnings: [] },
                            isHoliday: this.checkIfDateIsInHoliday(dates[i], holidays),
                            style: this.checkIfDateIsInHoliday(dates[i], holidays) ? "{'color':'indianred'}" : "{'color': 'inherit'}",
                            isManual: this.settings.manualDefault,
                            duration: 0,
                            durationM: 0,
                            durationH: 0
                        };
                        if (item.isManual) {
                            item.duration = Math.abs(item.timeTo.getTime() - item.timeFrom.getTime()) / 3600000;
                            const conv = this.$qui.convertDec(item.duration);
                            item.durationH = conv[0];
                            item.durationM = conv[1];
                        }
                        //initializie validation for item
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].timeFrom', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            this.validatePlannings();
                        }, true));
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].timeTo', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            this.validatePlannings();
                        }, true));
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].active', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            this.validatePlannings();
                        }, true));
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].isManual', () => {
                            const conv = this.$qui.convertDec(item.duration);
                            item.durationH = conv[0];
                            item.durationM = conv[1];
                            this.validatePlannings();
                        }, true));
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].duration', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            this.validatePlannings();
                        }, true));
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].durationH', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            this.validatePlannings();
                        }, true));
                        this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].durationM', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            if (item.durationM && item.durationM > 59) {
                                item.durationH++;
                                item.durationM = item.durationM - 60;
                            }
                            this.validatePlannings();
                        }, true));
                        if (!this.settings.allowEmptyReports) {
                            this.formWatcherList.push(this.$scope.$watch('vm.createForm.documentations[' + this.createForm.documentations.length + '].comment', (newVal, oldVal) => {
                                setTimeout(() => {
                                    if (newVal === oldVal || !item.validation)
                                        return;
                                    this.addOrRemoveError(this.lng.translate(20016207, "Der Bericht enthält noch keinen Text."), !this.settings.allowEmptyReports && this.createForm.documentations[i].comment.length === 0, this.createForm.documentations[i].validation);
                                }, 1500);
                            }, true));
                        }
                        this.createForm.documentations.push(item);
                    }
                    this.loading.plannings = false;
                    this.validatePlannings();
                });
            }
            checkIfShouldActivate(date, holidays, weekdays) {
                // iterate through holidays to see if the current date is one
                for (const holiday of holidays) {
                    const dateFrom = this.$qui.createDateFromString(holiday.dateFrom);
                    const dateTo = holiday.dateTo ? this.$qui.createDateFromString(holiday.dateTo) : null;
                    if ((!dateTo && dateFrom >= date && dateFrom <= date) || (dateTo && dateTo >= date && dateFrom <= date))
                        return false;
                }
                const currentDay = date.getDay();
                // first check weekdays
                if ((currentDay === 0 && weekdays.su) || (currentDay === 1 && weekdays.mo) || (currentDay === 2 && weekdays.tu) || (currentDay === 3 && weekdays.we) ||
                    (currentDay === 4 && weekdays.th) || (currentDay === 5 && weekdays.fr) || (currentDay === 6 && weekdays.sa))
                    return true;
                return false;
            }
            checkIfDateIsInHoliday(dateToCheck, holidays) {
                for (const holiday of holidays) {
                    const dateFrom = this.$qui.createDateFromString(holiday.dateFrom);
                    const dateTo = holiday.dateTo ? this.$qui.createDateFromString(holiday.dateTo) : null;
                    if ((!dateTo && dateFrom >= dateToCheck && dateFrom <= dateToCheck) || (dateTo && dateTo >= dateToCheck && dateFrom <= dateToCheck))
                        return true;
                }
                return false;
            }
            getDatesInTimeFrame(startDate, endDate) {
                const dates = [];
                let currentDate = startDate;
                const addDays = function (days) {
                    const date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
                while (currentDate <= endDate) {
                    dates.push(currentDate);
                    currentDate = addDays.call(currentDate, 1);
                }
                for (const date of dates)
                    date.setHours(0, 0, 0, 0);
                return dates;
            }
            ;
            getWeekdayName(date) {
                switch (date.getDay()) {
                    case 0: return this.lng.translate(20000188, "Sonntag");
                    case 1: return this.lng.translate(20000182, "Montag");
                    case 2: return this.lng.translate(20000183, "Dienstag");
                    case 3: return this.lng.translate(20000184, "Mittwoch");
                    case 4: return this.lng.translate(20000185, "Donnerstag");
                    case 5: return this.lng.translate(20000186, "Freitag");
                    case 6: return this.lng.translate(20000187, "Samstag");
                }
                return "";
            }
            getValidationButtonState(item) {
                if (!(item === null || item === void 0 ? void 0 : item.validation))
                    return 2;
                if (item.validation.errors.length > 0)
                    return 2;
                if (item.validation.warnings.length > 0)
                    return 1;
                return 0;
            }
            showValidation(item) {
                this.currentItem = item;
                $('#validationModal').modal('show');
            }
            savingEnabled() {
                if (!this.loading.allLoaded() || !this.new || !this.createForm || !this.createForm.documentations || this.createForm.documentations.length === 0 || !this.title || this.title.length === 0)
                    return false;
                let oneIsActive = false;
                for (const docu of this.createForm.documentations) {
                    if (docu.active)
                        oneIsActive = true;
                    // dont allow saving if at least one activated item is unvalidated or validated with errors
                    if (docu.active && (!docu.validation || docu.validation.errors.length > 0))
                        return false;
                }
                return oneIsActive;
            }
            saveFls() {
                $('#validationModal').modal('hide');
                const templateItem = this.getTemplateItem(this.completeTemplateItems);
                const flsList = [];
                for (const docu of this.createForm.documentations) {
                    if (!this.isRowEnabled(docu))
                        continue;
                    if (!docu.validation || docu.validation.errors.length > 0)
                        return;
                    const item = {
                        title: this.title,
                        additionalCost: null,
                        dateFrom: this.$qui.addTimeToDate(docu.date, docu.timeFrom),
                        dateTo: this.$qui.addTimeToDate(docu.date, docu.timeTo),
                        documentationId: null,
                        drivingCost: [],
                        durationInHours: docu.isManual && docu.duration ? docu.duration : 0,
                        flsCaseId: this.createForm.caseId,
                        isManualDuration: docu.isManual,
                        isSupportPlanDocu: false,
                        participantCount: 0,
                        participants: [],
                        plannedDocumentationId: null,
                        reports: [{
                                caption: templateItem.caption,
                                comment: docu.comment,
                                wvChildId: templateItem.reportItemId,
                                templateReferenceId: templateItem.objectId,
                                children: []
                            }],
                        workingHours: this.planForm.workingHours,
                        additionalFls: false,
                        additionalFlsText: '',
                        referencedPersonId: this.getCase(this.planForm.caseId).clientObjectId,
                        warning: false,
                        warningReasons: {},
                        reportTemplateId: this.planForm.report.templateId,
                        isReportTemplateFix: this.planForm.report.isTemplateFix
                    };
                    if (!item.workingHours.isMiscontactEnabled)
                        item.workingHours.miscontactWvId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    delete item.workingHours.isMiscontactEnabled;
                    flsList.push(item);
                }
                console.log(flsList);
                this.postFls(flsList);
            }
            getTemplateItem(items = this.completeTemplateItems) {
                let result;
                for (const item of items) {
                    if (item.objectId === this.createForm.reportTemplateItemId) {
                        result = item;
                        break;
                    }
                    if (item.children && item.children.length > 0) {
                        const temp = this.getTemplateItem(item.children);
                        if (temp) {
                            result = temp;
                            break;
                        }
                    }
                }
                ;
                return result;
            }
            getCase(caseId) {
                for (const element of this.cases)
                    if (element.objectId === caseId)
                        return element;
            }
            isValidGuid(guid) {
                return guid !== null && guid !== undefined && guid !== QMC.Common.Constants.GUID_EMPTY;
            }
            resolveDefaultAbrechenbarkeitId(caseDefaultAccountableRuleId) {
                if (this.isValidGuid(caseDefaultAccountableRuleId))
                    return caseDefaultAccountableRuleId;
                return this.defaultAccountabilityRule;
            }
            setDefaultValues() {
                var _a;
                this.planForm.workingHours.activityWvId = this.settings.flsDefaultActivityType;
                this.planForm.workingHours.careTypeWvId = this.settings.flsDefaultCareType;
                this.planForm.workingHours.contactTypeWvId = this.settings.flsDefaultContactType;
                const cuCase = this.getCase(this.planForm.caseId);
                this.planForm.workingHours.abrechenbarkeitId = (_a = this.resolveDefaultAbrechenbarkeitId(cuCase.defaultAccountableRuleId)) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY;
                this.settings.isAccountableRuleFix = cuCase.isAccountableRuleFix;
            }
            createDisabled() {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                return !((_a = this.planForm) === null || _a === void 0 ? void 0 : _a.caseId) || this.planForm.caseId == '00000000-0000-0000-0000-000000000000' || !this.title || this.title.length == 0
                    || (((_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.requiredFields) === null || _c === void 0 ? void 0 : _c.workingHours.activityWvId) && (!((_e = (_d = this.planForm) === null || _d === void 0 ? void 0 : _d.workingHours) === null || _e === void 0 ? void 0 : _e.activityWvId) || this.planForm.workingHours.activityWvId === QMC.Common.Constants.GUID_EMPTY))
                    || ((((_g = (_f = this.settings) === null || _f === void 0 ? void 0 : _f.requiredFields) === null || _g === void 0 ? void 0 : _g.workingHours.contactTypeWvId) || ((_j = (_h = this.settings) === null || _h === void 0 ? void 0 : _h.editor) === null || _j === void 0 ? void 0 : _j.isContactTypeRequiered)) && (!this.planForm.workingHours.contactTypeWvId || this.planForm.workingHours.contactTypeWvId === QMC.Common.Constants.GUID_EMPTY))
                    || ((((_l = (_k = this.settings) === null || _k === void 0 ? void 0 : _k.requiredFields) === null || _l === void 0 ? void 0 : _l.workingHours.careTypeWvId) || ((_o = (_m = this.settings) === null || _m === void 0 ? void 0 : _m.editor) === null || _o === void 0 ? void 0 : _o.isCareTypeRequiered)) && (!this.planForm.workingHours.careTypeWvId || this.planForm.workingHours.careTypeWvId === QMC.Common.Constants.GUID_EMPTY))
                    || (((_q = (_p = this.planForm) === null || _p === void 0 ? void 0 : _p.workingHours) === null || _q === void 0 ? void 0 : _q.isMiscontactEnabled) && (!((_s = (_r = this.planForm) === null || _r === void 0 ? void 0 : _r.workingHours) === null || _s === void 0 ? void 0 : _s.miscontactWvId) || this.planForm.workingHours.miscontactWvId === QMC.Common.Constants.GUID_EMPTY || this.planForm.workingHours.miscontactWvId === QMC.Common.Constants.FLS_NO_MISCONTACT));
            }
            getConfigErrors(docu) {
                const wv = this.wvsByDate[docu.date.toISOString()];
                if (wv === 'ERROR')
                    return [this.lng.translate(20016239, 'Die Konfiguration zu diesem Datum konnte nicht überprüft werden')];
                if (wv === 'LOADING')
                    return [this.lng.translate(20016240, 'Die Konfiguration zu diesem Datum wird noch geprüft')];
                const errors = [];
                const checkIfIdIsPresentInWv = (id, wv) => (!id || id === QMC.Common.Constants.GUID_EMPTY || id === this.defaultAccountabilityRule || wv.some(x => x.objectId === id));
                const createErrorString = (id, wv, area) => {
                    var _a;
                    const entry = (_a = wv.filter(x => x.objectId === id)[0]) !== null && _a !== void 0 ? _a : { caption: '' };
                    const caption = 'name' in entry ? entry.name : entry.caption;
                    return this.$qui.formatString(this.lng.translate(20016241, 'Die {0} {1} ist an dem Dokumentationsdatum ungültig'), area, caption);
                };
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.abrechenbarkeitId, wv.documentationCarerWvModel.abrechenbarkeitWv))
                    errors.push(createErrorString(this.planForm.workingHours.abrechenbarkeitId, this.wv.abrechenbarkeitWv, this.lng.translate(20016036, 'An-/Abrechenbarkeitsregel')));
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.activityWvId, wv.documentationCarerWvModel.activityWv))
                    errors.push(createErrorString(this.planForm.workingHours.activityWvId, this.wv.activityWv, this.lng.translate(20016046, 'Tätigkeit')));
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.contactTypeWvId, wv.documentationCarerWvModel.contactTypeWv))
                    errors.push(createErrorString(this.planForm.workingHours.contactTypeWvId, this.wv.contactTypeWv, this.lng.translate(20016049, 'Kontaktart')));
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.careTypeWvId, wv.documentationCarerWvModel.careTypeWv))
                    errors.push(createErrorString(this.planForm.workingHours.careTypeWvId, this.wv.careTypeWv, this.lng.translate(20016051, 'Betreuungsart')));
                return errors;
            }
            isRowEnabled(docu) {
                return docu.active && this.getConfigErrors(docu).length === 0;
            }
            showForbiddenNotification(docu) {
                this.$qui.notify({
                    message: this.getConfigErrors(docu).join('<br />'),
                    title: `${this.lng.translate(20000331, 'Auswahl nicht möglich')}: ${docu.date.toLocaleDateString()}`,
                    icon: "qm-icon-information",
                    status: "info",
                    timer: 8000
                });
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getCarer() {
                this.loading.carer = true;
                this.flsService.getCarerList().then((data) => {
                    this.loading.carer = false;
                    this.selectLists.carer = this.$qui.select(data, {
                        value: 'objectId',
                        text: 'displayTitle'
                    });
                });
            }
            getCases() {
                this.loading.cases = true;
                this.flsService.getCasesList(undefined, true, this.planForm.carerId).then((data) => {
                    this.cases = data;
                    this.loading.cases = false;
                    this.selectLists.cases = this.cases.map(x => this.$qui.createCaseDisplayObject(x));
                    if (!this.selectLists.cases.some(x => x.value === this.planForm.caseId))
                        this.planForm.caseId = QMC.Common.Constants.GUID_EMPTY;
                    if (this.planForm.caseId && this.planForm.caseId !== QMC.Common.Constants.GUID_EMPTY) {
                        this.getWvForCase();
                        this.getEditorSetting();
                        this.setFixedTemplate(this.planForm.caseId);
                    }
                    this.checkCasePaused();
                });
            }
            getEditorSetting() {
                this.loading.editorSettings = true;
                this.flsService.getCatalogSettings([this.planForm.caseId], QMC.Common.Constants.GUID_EMPTY, this.planForm.dateTo, this.planForm.carerId).then((data) => {
                    this.loading.editorSettings = false;
                    this.settings.editor = data;
                    this.setDefaultValues();
                });
            }
            getWvForCase() {
                this.loading.wv = true;
                this.flsService.getFlsDocumentationWvModel([this.planForm.caseId], QMC.Common.Constants.GUID_EMPTY, [this.planForm.carerId], this.planForm.dateTo).then((data) => {
                    this.loading.wv = false;
                    this.wv = data[0].documentationCarerWvModel;
                    this.selectLists.accountability = this.$qui.select(this.wv.abrechenbarkeitWv, {
                        value: 'objectId',
                        text: 'caption'
                    });
                    this.selectLists.activity = this.$qui.select(this.wv.activityWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    this.selectLists.careType = this.$qui.select(this.wv.careTypeWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    this.selectLists.contactType = this.$qui.select(this.wv.contactTypeWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    this.selectLists.miscontact = this.$qui.select(this.wv.miscontactWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    this.setDefaultValues();
                });
            }
            getReportTemplates() {
                this.loading.report = true;
                this.flsService.getReportTemplates().then((data) => {
                    if (data.length === 0) {
                        this.planForm.report.templateId = QMC.Common.Constants.GUID_EMPTY;
                        return;
                    }
                    for (const element of data)
                        if (element.isDefault)
                            this.planForm.report.templateId = element.objectId;
                    this.reportTemplates = this.$qui.select(data, {
                        value: 'objectId',
                        text: 'caption'
                    });
                    this.loading.report = false;
                });
            }
            getReportTemplateItems() {
                this.flsService.getReportTemplateItems(this.planForm.report.templateId).then((data) => {
                    this.reportTemplateItems = [];
                    if (data.length === 0) {
                        this.planForm.report.itemId = QMC.Common.Constants.GUID_EMPTY;
                        return;
                    }
                    this.planForm.report.itemId = data[0].objectId;
                    this.reportTemplateItems = this.createTemplateList(data);
                    this.completeTemplateItems = data;
                });
            }
            createTemplateList(list, level = 0) {
                let result = [];
                for (const element of list) {
                    let text = element.caption;
                    if (level > 0) {
                        text = ' ' + text;
                        for (let j = 0; j < level; j++) {
                            text = '-' + text;
                        }
                    }
                    result.push({ text: text, value: element.objectId });
                    if (element.children && element.children.length > 0)
                        result = result.concat(this.createTemplateList(element.children, level + 1));
                }
                return result;
            }
            validatePlannings() {
                const validationObjects = [];
                const curCase = this.getCase(this.planForm.caseId);
                this.createForm.documentations.forEach(item => {
                    if (this.isRowEnabled(item)) {
                        if (!item.isManual) {
                            item.duration = Math.abs(item.timeTo.getTime() - item.timeFrom.getTime()) / 3600000;
                            const conv = this.$qui.convertDec(item.duration);
                            item.durationH = conv[0];
                            item.durationM = conv[1];
                        }
                        else if (this.showTime) {
                            const hours = item.durationH ? item.durationH : 0;
                            const minutes = item.durationM ? item.durationM : 0;
                            item.duration = +hours + +(minutes / 60);
                        }
                        validationObjects.push({
                            carer: [{
                                    activityTypeId: this.planForm.workingHours.activityWvId,
                                    carerId: this.planForm.carerId,
                                    careTypeId: this.planForm.workingHours.careTypeWvId,
                                    contactTypeId: this.planForm.workingHours.contactTypeWvId,
                                    miscontactId: this.planForm.workingHours.isMiscontactEnabled ? this.planForm.workingHours.miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT
                                }],
                            dateFrom: this.$qui.addTimeToDate(item.date, item.timeFrom),
                            dateTo: this.$qui.addTimeToDate(item.date, item.timeTo),
                            hasManualDuration: item.isManual,
                            ignoreConfigRoundInterval: false,
                            manualDuration: item.isManual && item.duration ? item.duration : 0,
                            references: [{
                                    referenceId: curCase.clientObjectId,
                                    caseId: curCase.objectId,
                                    accountabilityId: this.planForm.workingHours.abrechenbarkeitId
                                }],
                            documentationId: QMC.Common.Constants.GUID_EMPTY,
                            requestId: item.documentationId
                        });
                    }
                });
                if (this.lastValidation === JSON.stringify(validationObjects))
                    return;
                // clear validations to indicate loading
                this.createForm.documentations.forEach(plan => {
                    if (this.isRowEnabled(plan)) {
                        plan.validation = null;
                    }
                });
                this.lastValidation = JSON.stringify(validationObjects);
                this.flsService.checkForWarningsAndErrors(validationObjects, false).then((data) => {
                    if (this.lastValidation !== JSON.stringify(validationObjects))
                        return; // we only care for the last validation
                    data.forEach(result => {
                        const docu = this.createForm.documentations.filter(x => x.documentationId === result.requestId)[0];
                        if (!docu)
                            return;
                        docu.validation = result.validation[this.planForm.carerId];
                        this.addOrRemoveError(this.lng.translate(20016207, "Der Bericht enthält noch keinen Text."), !this.settings.allowEmptyReports && docu.comment.length === 0, docu.validation);
                    });
                }).catch(() => {
                    this.createForm.documentations.forEach(plan => {
                        if (this.isRowEnabled(plan)) {
                            plan.validation = { warnings: [], errors: [this.lng.translate(21003033, 'Die Leistung konnte nicht validiert werden.')] };
                        }
                    });
                });
            }
            formatTimeString(duration = 0) {
                let timeString = "";
                if (this.showTime) {
                    const conv = this.$qui.convertDec(duration);
                    let minutes = conv[1].toString();
                    if (conv[1] < 10)
                        minutes = "0" + minutes;
                    timeString = conv[0] + ":" + minutes;
                }
                else {
                    timeString = parseFloat(duration + "").toFixed(2).toString().replace('.', ',');
                }
                return timeString;
            }
            GuidIsNullOrEmptyOrGuidEmpty(guid) {
                return guid === null || guid === undefined || guid === "" || guid === QMC.Common.Constants.GUID_EMPTY;
            }
            postFls(list) {
                window.scrollTo(null, 0);
                this.loading.save = true;
                this.flsService.postFlsDocumentation(list, false, this.planForm.carerId).then(() => {
                    QMC.Common.personalLocalStorage.setItem('flsDocuListCache', this.planForm.caseId);
                    this.$state.go('documentation');
                });
            }
            addOrRemoveError(error, add, validation) {
                if (!validation)
                    return;
                if (add)
                    this.addValidationError(error, validation);
                else
                    this.removeValidationError(error, validation);
                this.$qui.scopeApply(this.$scope);
                return add;
            }
            addValidationError(error, validation) {
                for (const presentError of validation.errors)
                    if (presentError === error)
                        return;
                validation.errors.push(error);
            }
            removeValidationError(error, validation) {
                for (let i = 0; i < validation.errors.length; i++) {
                    if (validation.errors[i] === error) {
                        validation.errors.splice(i, 1);
                        return;
                    }
                }
            }
        };
        FlsCompanionController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsCompanionController'),
            QMC.Inject('$location', 'FachleistungService', '$qui', '$scope', '$stateParams', '$state', 'UserService', 'QmcPermissionService', 'TerminService', 'QmcLanguageService')
        ], FlsCompanionController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsDocumentationListController = class FlsDocumentationListController {
            /**
             * Creates an instance of FlsDocumentationListController.
             * @param {FlsService} flsService
             * @param {Klient.KlientService} clientService
             * @param {any} $scope
             * @param {any} $qui
             * @param {any} $stateParams
             * @param {any} $timeout
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf FlsDocumentationListController
             */
            constructor($location, flsService, $scope, $qui, $state, $stateParams, $timeout, userService, permissionService, lng) {
                var _a, _b, _c;
                this.$location = $location;
                this.flsService = flsService;
                this.$scope = $scope;
                this.$qui = $qui;
                this.$state = $state;
                this.$timeout = $timeout;
                this.userService = userService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.ui = new QMC.Fachleistung.UserInterface();
                this.page = 0;
                this.isFirstLoad = true;
                this.allowTableExport = false;
                this.pagination = [];
                this.loadingCases = true;
                this.showOnlyOwnCreated = false;
                this.showOnlyOwnCases = false;
                this.deleteReasons = [];
                this.casesMap = [];
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.isLoadingDeleteModal = false;
                this.isDeleteAllowed = false;
                this.showTime = false;
                this.sortBy = '';
                this.sortDescending = false;
                this.localStorageCacheName = "flsDocuListCache";
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                this.filter = {
                    dateFrom: moment().startOf('month').toDate(),
                    dateTo: moment().endOf('month').toDate(),
                };
                const previousStateCache = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE);
                if (previousStateCache !== null) {
                    const cachedParams = JSON.parse(previousStateCache);
                    const isBackFromDocumentation = (_a = cachedParams.isBackFromDocumentationDetail) !== null && _a !== void 0 ? _a : false;
                    QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: this.$state.$current.name,
                        params: cachedParams.params
                    }));
                    if (isBackFromDocumentation) {
                        this.filter = {
                            dateFrom: moment((_b = cachedParams.params.dateFrom) !== null && _b !== void 0 ? _b : this.filter.dateFrom).toDate(),
                            dateTo: moment((_c = cachedParams.params.dateTo) !== null && _c !== void 0 ? _c : this.filter.dateTo).toDate(),
                        };
                    }
                }
                else {
                    QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: this.$state.$current.name,
                        params: {}
                    }));
                }
                /* Signature Permissions */
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectTypes([230009, 230003, 230000]).then((data) => {
                    this.signaturePermission = {
                        moduleAccess: data[0].moduleAccess,
                        view: data[0].view
                    };
                    this.delete = data[1].delete;
                    this.new = data[1].new;
                    this.modify = data[1].modify;
                    this.allowTableExport = data[2].print;
                    this.init();
                    this.getCases();
                    this.permissionLoading = false;
                });
                this.userService.getUserSettings(["FLS.SHOWMONTHFILTER", "SHOWTIMEINSTEADOFDECIMAL"]).then((data) => {
                    this.ui.showMonthFilter = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS : data[0].value.toLowerCase() === "true";
                    this.showTime = data[1].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[1].value.toLowerCase() === "true";
                });
                this.ui.documentationTable.filter.model = this.tableFilter;
                this.page = 0;
                $scope.$watch('vm.tableFilter', (newValue, oldValue) => {
                    if (newValue != oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(() => {
                                this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            let lastValue = this.tableFilter;
                            setTimeout(() => {
                                if (this.tableFilter == lastValue) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 500);
                        }
                    }
                });
                $scope.$watch('vm.page', (newValue, oldValue) => {
                    if (newValue != oldValue)
                        if (this.isFirstLoad) {
                            setTimeout(() => {
                                this.isFirstLoad = false;
                            });
                        }
                        else {
                            this.getData();
                        }
                });
                this.deleteId = QMC.Common.Constants.DELETE_REASON_ID;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.events();
            }
            openNewDocu() {
                if (this.loadingCases)
                    return;
                if (this.casesMap.length > 0 && this.filter.selectedCaseId && this.filter.selectedCaseId != '' && this.filter.selectedCaseId != QMC.Common.Constants.GUID_EMPTY)
                    this.$state.go("documentationnew", { flsCaseIds: [this.filter.selectedCaseId] });
                else
                    this.$state.go("case");
            }
            /**
             * init the Filter an the signature permissions
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            init() {
                //set filter to last parameters
                if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE) !== null && this.signaturePermission.view) {
                    this.hideSignature = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE) === 'true';
                }
                else {
                    this.hideSignature = true;
                }
                if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED) !== null)
                    this.showOnlyOwnCreated = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED) === "true";
                else
                    this.showOnlyOwnCreated = false;
                if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES) !== null)
                    this.showOnlyOwnCases = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES) === "true";
                else
                    this.showOnlyOwnCases = false;
            }
            /**
             * Register view events
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            events() {
                if (this.loading || this.loadingCases) {
                    setTimeout(() => { this.events(); }, 250);
                    return;
                }
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: this.$state.$current.name,
                        params: this.filter
                    }));
                    this.getData();
                });
                this.filterWatcher = this.$scope.$watch('vm.filter.selectedCaseId ', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    QMC.Common.personalLocalStorage.setItem(this.localStorageCacheName, this.filter.selectedCaseId);
                });
            }
            /**
             * Set the filter values to localStorage and get documentations
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            getData() {
                this.getDocumenations();
            }
            getDocumenations() {
                const currentRequest = { dateFrom: this.filter.dateFrom, dateTo: this.filter.dateTo, caseId: this.filter.selectedCaseId, onlySelf: this.showOnlyOwnCreated, onlyCurrent: this.caseFilter.onlyCurrentCases, onlyOwnCases: this.showOnlyOwnCases, tableFilter: this.tableFilter, page: this.page, sortBy: this.sortBy, sortDescending: this.sortDescending };
                currentRequest.dateFrom = moment(this.filter.dateFrom).startOf('day').toDate();
                currentRequest.dateTo = moment(this.filter.dateTo).endOf('day').toDate();
                if (!this.cases || this.cases.length <= 0 || (JSON.stringify(this.lastRequest) === JSON.stringify(currentRequest))) {
                    return;
                }
                this.lastRequest = currentRequest;
                this.loading = true;
                this.flsService.getFlsDocumentationList(this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, currentRequest.dateFrom, currentRequest.dateTo, currentRequest.caseId, currentRequest.onlySelf, currentRequest.onlyCurrent, currentRequest.onlyOwnCases, currentRequest.tableFilter, this.ui.getDisplayedPropertiesFromSchema(this.ui.documentationTable), this.sortBy, this.sortDescending).then((data) => {
                    this.paginationInfo = data.paginationInfo;
                    this.ui.documentationTable.totalSums.data = data.additionalData;
                    data.items = data.items.map(function (obj) {
                        if (obj.warning)
                            obj.style = { 'background-color': '#f0ad4e', 'color': 'white' };
                        return obj;
                    }.bind(this));
                    this.docs = data;
                    this.filteredList = angular.copy(data.items);
                    this.ui.documentationTable.table.Signiert.invisible = this.hideSignature;
                    this.ui.documentationTable.data = this.filteredList;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.isFirstLoad = false;
                    this.loading = false;
                });
            }
            /**
             * Toggle the visibility of the signature col
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            toggleShowSignature() {
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE, this.hideSignature.toString());
                this.ui.documentationTable.table.Signiert.invisible = this.hideSignature;
                this.$qui.functionWaiter("ui.createTable", this);
            }
            /**
             * Toggle the visibility of the own created col
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            toggleShowOnlyOwnCreated() {
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED, this.showOnlyOwnCreated.toString());
                this.getDocumenations();
            }
            /**
             * Toggle the visibility of my own cases col
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            toggleShowOnlyOwnCases() {
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES, this.showOnlyOwnCases.toString());
                this.getDocumenations();
            }
            /**
             * Show only the current cases
             *
             * @memberOf FlsDocumentationListController
             */
            async toggleShowOnlyCurrentCases() {
                this.getCases();
                this.getDocumenations();
                await this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] });
            }
            getCases() {
                let lastCaseIDFound = false;
                let lastCaseId = QMC.Common.personalLocalStorage.getItem(this.localStorageCacheName);
                this.loadingCases = true;
                this.flsService.getCasesList('', this.caseFilter.onlyCurrentCases).then((data) => {
                    if (data.length > 0) {
                        if (lastCaseId == undefined) {
                            this.filter.selectedCaseId = data[0].objectId;
                        }
                        else if (lastCaseId == '') {
                            this.filter.selectedCaseId = '';
                        }
                        else if (lastCaseId != (null || undefined) && this.$qui.isGuid(lastCaseId)) {
                            for (let i = 0; i <= data.length - 1; i++) {
                                if (data[i].objectId == lastCaseId) {
                                    lastCaseId = data[i].objectId;
                                    lastCaseIDFound = true;
                                    break;
                                }
                            }
                            if (!lastCaseIDFound) {
                                this.filter.selectedCaseId = data[0].objectId;
                            }
                            else {
                                this.filter.selectedCaseId = lastCaseId;
                            }
                        }
                    }
                    else
                        return;
                    this.cases = data;
                    this.casesMap = this.createCasesMap();
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        if (this.shouldLoadTableData) {
                            this.getData();
                        }
                    });
                    this.loadingCases = false;
                    this.$qui.waitForEl('#newClickButton', () => {
                        document.getElementById('newClickButton').style.visibility = 'unset';
                    });
                });
            }
            createCasesMap() {
                if (!this.cases)
                    return [];
                let casesMap = this.cases.map(x => this.$qui.createCaseDisplayObject(x));
                casesMap.unshift({ value: '', text: this.lng.translate(20000212, '- Alle -') });
                return casesMap;
            }
        };
        FlsDocumentationListController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsDocumentationListController'),
            QMC.Inject('$location', 'FachleistungService', '$scope', '$qui', '$state', '$stateParams', '$timeout', 'UserService', 'QmcPermissionService', 'QmcLanguageService')
        ], FlsDocumentationListController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsDocumentationCacheService_1;
        /**
         * Service for FLS documentation form cache (session storage + restore confirm dialog).
         * Handles load/save of cache snapshot and showing the "restore unsaved changes?" prompt.
         */
        let FlsDocumentationCacheService = FlsDocumentationCacheService_1 = class FlsDocumentationCacheService {
            constructor() { }
            getKey(personId) {
                return FlsDocumentationCacheService_1.CACHE_KEY_PREFIX + personId;
            }
            load(key) {
                const raw = QMC.Common.personalLocalStorage.getItem(key);
                if (raw === null || raw === undefined)
                    return null;
                try {
                    return JSON.parse(raw);
                }
                catch (_a) {
                    return null;
                }
            }
            save(key, data) {
                QMC.Common.personalLocalStorage.setItem(key, JSON.stringify(data));
            }
            /**
             * Shows the restore-cache confirm dialog. Calls onConfirm() when the user confirms.
             * @param promptOptions - dialog title, text, icon
             * @param onConfirm - callback when user confirms restore
             * @param modalSelector - optional selector for modal container (default '#promptCache')
             */
            showRestoreConfirm(promptOptions, onConfirm, modalSelector = '#promptCache') {
                QMC.Common.Utilities.confirm(promptOptions, (dataCache) => {
                    if (dataCache)
                        onConfirm();
                }, modalSelector);
            }
        };
        FlsDocumentationCacheService.CACHE_KEY_PREFIX = 'flsCache-';
        FlsDocumentationCacheService = FlsDocumentationCacheService_1 = __decorate([
            QMC.Service('QMC.Fachleistung', 'FlsDocumentationCacheService'),
            QMC.Inject()
        ], FlsDocumentationCacheService);
        Fachleistung.FlsDocumentationCacheService = FlsDocumentationCacheService;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        /**
         * Service for FLS documentation validation: building validation payloads, processing server results,
         * and client-side rules (driving cost, title, full web client validation).
         */
        let FlsDocumentationValidationService = class FlsDocumentationValidationService {
            constructor() { }
            buildValidationReferences(ctx) {
                if (!ctx.cases || ctx.cases.length === 0)
                    return null;
                return ctx.cases.map(curCase => ({
                    caseId: curCase.objectId,
                    referenceId: curCase.clientObjectId,
                    accountabilityId: curCase.isAccountableRuleFix ? curCase.defaultAccountableRuleId : ctx.form.workingHours.abrechenbarkeitId
                }));
            }
            buildValidationCarers(ctx) {
                if (ctx.carerActivityForm && ctx.carerActivityForm.length > 0) {
                    return ctx.carerActivityForm.map(curCarer => ({
                        carerId: curCarer.carerId,
                        activityTypeId: curCarer.activityWvId,
                        contactTypeId: curCarer.contactTypeWvId,
                        careTypeId: curCarer.careTypeWvId,
                        miscontactId: curCarer.miscontactWvId
                    }));
                }
                if (ctx.isGroup || !ctx.isNewDocumentation) {
                    return [{
                            carerId: ctx.isGroup ? $("#session").data().personId : ctx.form.workingHours.carerObjectId,
                            activityTypeId: ctx.activityForm.activityWvId,
                            careTypeId: ctx.activityForm.careTypeWvId,
                            contactTypeId: ctx.activityForm.contactTypeWvId,
                            miscontactId: ctx.activityForm.miscontactWvId
                        }];
                }
                return null;
            }
            buildValidationObject(ctx) {
                let duration = ctx.timeForm.durationInHours;
                if (ctx.timeForm.isManualDuration) {
                    duration = ctx.form.durationInHours = ctx.hoursMinutesToDecimal(ctx.timeForm.hours, ctx.timeForm.minutes);
                }
                const baseValidationObject = {
                    dateFrom: ctx.timeForm.dateFrom,
                    dateTo: ctx.timeForm.dateTo,
                    documentationId: ctx.formState === 'new' ? QMC.Common.Constants.GUID_EMPTY : ctx.documentationIds[0],
                    references: ctx.references,
                    carer: ctx.carer,
                    requestId: ctx.generateGuid(),
                    ignoreConfigRoundInterval: (ctx.ignoreConfigRoundInterval || ctx.roundInterval === 0)
                };
                if (ctx.isNewDocumentation && !ctx.isGroup) {
                    const isManual = ctx.timeForm.isManualDuration || (ctx.timeForm.distributeHours && ctx.cases.length > 1);
                    return {
                        ...baseValidationObject,
                        hasManualDuration: isManual,
                        manualDuration: isManual ? (ctx.timeForm.distributeHours ? duration / ctx.references.length : duration) : 0
                    };
                }
                return {
                    ...baseValidationObject,
                    hasManualDuration: ctx.timeForm.isManualDuration,
                    manualDuration: ctx.timeForm.isManualDuration ? (ctx.timeForm.distributeHours ? duration / ctx.references.length : duration) : 0
                };
            }
            addDrivingCostsToValidation(validationObject, ctx) {
                var _a;
                if (!((_a = ctx.form) === null || _a === void 0 ? void 0 : _a.drivingCost))
                    return;
                validationObject.drivingCost = ctx.form.drivingCost
                    .filter((cost) => {
                    const duration = ctx.convertHours(cost.hours, cost.minutes >= 0 ? cost.minutes : 0);
                    return duration > 0 || cost.drivingDistance > 0 || cost.isCarPool || cost.isPrivate;
                })
                    .map((cost) => ({
                    objectId: cost.objectId,
                    dateOfArrival: cost.isPrivate || cost.isCarPool ? ctx.addTimeToDate(cost.dateOfArrival, cost.timeOfArrival) : null,
                    dateOfDeparture: cost.isPrivate || cost.isCarPool ? ctx.addTimeToDate(cost.dateOfDeparture, cost.timeOfDeparture) : null,
                    drivingDistance: cost.drivingDistance,
                    duration: ctx.convertHours(cost.hours, cost.minutes >= 0 ? cost.minutes : 0),
                    chargingMethodId: cost.chargingMethodId,
                    drivingCostCategoryId: cost.drivingCostCategoryId
                }));
            }
            processValidationResults(data, ctx, addValidation) {
                if (ctx.isGroup || !ctx.isNewDocumentation) {
                    data.forEach(result => {
                        for (const key in result.validation) {
                            result.validation[key].errors.forEach((msg) => addValidation(msg, "errors"));
                            result.validation[key].warnings.forEach((msg) => addValidation(msg, "warnings"));
                        }
                    });
                }
                else {
                    data.forEach(result => {
                        ctx.carerActivityForm.forEach(form => {
                            var _a, _b, _c, _d;
                            form.warnings = form.warnings.concat((_b = (_a = result.validation[form.carerId]) === null || _a === void 0 ? void 0 : _a.warnings) !== null && _b !== void 0 ? _b : []);
                            form.errors = form.errors.concat((_d = (_c = result.validation[form.carerId]) === null || _c === void 0 ? void 0 : _c.errors) !== null && _d !== void 0 ? _d : []);
                        });
                    });
                }
            }
            /**
             * Validates that each driving cost entry with data has a category selected.
             * Returns true if an error was added.
             */
            validateDrivingCostCategory(ctx, translate, addOrRemoveError) {
                var _a;
                if (!((_a = ctx.form.drivingCost) === null || _a === void 0 ? void 0 : _a.length))
                    return false;
                const hasError = ctx.form.drivingCost.some((cost) => {
                    const isEmpty = !cost.drivingCostCategoryId || cost.drivingCostCategoryId === QMC.Common.Constants.GUID_EMPTY;
                    const hasData = ctx.validateEmptyDrivingCost ||
                        parseFloat(cost.drivingDistance + '') > 0 ||
                        parseFloat(cost.hours + '') > 0 ||
                        parseFloat(cost.minutes + '') > 0;
                    return isEmpty && hasData;
                });
                return addOrRemoveError(translate(21003035, "Für jeden Fahrtkostensatz muss eine Fahrtkostenart ausgewählt sein."), hasError);
            }
            /**
             * Validates that each driving cost entry with other fields filled has duration or distance.
             * Returns true if an error was added.
             */
            validateDrivingCostDuration(ctx, translate, addOrRemoveError) {
                var _a;
                if (!((_a = ctx.form.drivingCost) === null || _a === void 0 ? void 0 : _a.length))
                    return false;
                const hasError = ctx.form.drivingCost.some((cost) => {
                    const hasOtherFields = !!(cost.comment || cost.departure || cost.destination ||
                        cost.drivingCostCategoryId || cost.isPrivate || cost.isCarPool);
                    const hasDurationOrDistance = !!(parseFloat(cost.drivingDistance + '') > 0 ||
                        parseFloat(cost.hours + '') > 0 || parseFloat(cost.minutes + '') > 0);
                    return hasOtherFields && !hasDurationOrDistance;
                });
                return addOrRemoveError(translate(21003045, "Mindestens ein Fahrtkostensatz hat keine Angaben über Dauer oder Strecke."), hasError);
            }
            /**
             * Validates that car pool driving cost entries have a vehicle selected.
             * Returns true if an error was added.
             */
            validateDrivingCostVehicle(ctx, translate, addOrRemoveError) {
                var _a;
                if (!((_a = ctx.form.drivingCost) === null || _a === void 0 ? void 0 : _a.length))
                    return false;
                const hasError = ctx.form.drivingCost.some((cost) => cost.isCarPool && (!cost.vehicleId || cost.vehicleId === QMC.Common.Constants.GUID_EMPTY));
                return addOrRemoveError(translate(20016180, "Mindestens ein Fahrtkostensatz mit Fuhrparkbezug hat kein ausgewähltes Fahrzeug"), hasError);
            }
            /**
             * Validates that a report title is present when required.
             * Returns true if an error was added.
             */
            checkTitle(ctx, translate, addOrRemoveError) {
                var _a;
                if (!ctx.requiredFields)
                    return false;
                if ((_a = ctx.requiredFields.fls) === null || _a === void 0 ? void 0 : _a.title) {
                    return addOrRemoveError(translate(20016196, "Es muss ein Berichttitel angegeben werden."), !ctx.form.title || ctx.form.title.length === 0);
                }
                return false;
            }
            /**
             * Runs all web client validation rules. Mutates ctx.timeForm (dateFrom/dateTo when resetHoursOnManualDuration)
             * and ctx.carerActivityForm items (warnings, errors, miscontactWvId). Returns true if any error was added.
             */
            runWebClientValidation(ctx, callbacks) {
                var _a, _b, _c, _d, _e, _f;
                const { addOrRemoveError, addOrRemoveWarning, hasPrevMonthLock, hasReportEntryWithComment, scopeApply, translate, mergeCarerValidationToGlobal } = callbacks;
                if (ctx.timeForm.isManualDuration && ctx.resetHoursOnManualDuration) {
                    ctx.timeForm.dateFrom = moment(ctx.timeForm.dateFrom).startOf('day').toDate();
                    ctx.timeForm.dateTo = moment(ctx.timeForm.dateTo).startOf('day').toDate();
                }
                let result = hasPrevMonthLock();
                result = addOrRemoveError(translate(20016228, 'Bitte geben Sie einen validen Wert für Pflichtfeld \'Gültig von\' ein'), (!ctx.dateFromNotRequired && isNaN(ctx.timeForm.dateFrom.valueOf()))) || result;
                result = addOrRemoveError(translate(20016209, 'Mindestens ein Erbringer muss ausgewählt werden.'), (ctx.selectedCarerList != undefined && ctx.selectedCarerList.length === 0 && !ctx.isGroup && ctx.isNewDocumentation)) || result;
                result = addOrRemoveError(translate(20016226, 'Markierungen sind Pflicht. Bitte mindestens eine Markierung markieren.'), ((ctx.selectedMarkings === null || ctx.selectedMarkings.length === 0) && ctx.isMarkingRequired)) || result;
                result = addOrRemoveError(translate(21003034, 'Bitte einen gültigen Zeitraum angeben.'), (!ctx.timeForm.dateFrom || !ctx.timeForm.dateTo ||
                    (!ctx.timeForm.isManualDuration && isNaN(ctx.timeForm.dateFrom.getTime())) ||
                    (!ctx.timeForm.isManualDuration && isNaN(ctx.timeForm.dateTo.getTime())) ||
                    ctx.timeForm.dateFrom > ctx.timeForm.dateTo)) || result;
                const hasZeroDuration = !ctx.timeForm.isManualDuration
                    && !Number.isNaN(ctx.timeForm.dateFrom.getTime())
                    && !Number.isNaN(ctx.timeForm.dateTo.getTime())
                    && ctx.timeForm.dateFrom.getTime() === ctx.timeForm.dateTo.getTime();
                addOrRemoveWarning(translate(20016271, 'Sie erfassen eine Dokumentation ohne Dauer'), hasZeroDuration);
                const noReports = !hasReportEntryWithComment();
                result = addOrRemoveError(translate(20016207, "Der Bericht enthält noch keinen Text."), ((!ctx.allowEmptyReports && noReports) && ctx.reportForm.templates.length > 0)) || result;
                const actFormArr = ((_a = ctx.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length) ? ctx.carerActivityForm : [ctx.activityForm];
                for (const actFormToCheck of actFormArr) {
                    actFormToCheck.warnings = [];
                    actFormToCheck.errors = [];
                    if (!actFormToCheck.isMiscontactEnabled)
                        actFormToCheck.miscontactWvId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    const requiredFields = (_b = actFormToCheck.requiredFields) !== null && _b !== void 0 ? _b : ctx.requiredFields;
                    result = addOrRemoveError(translate(20016190, 'Standard ist keine gültige Tätigkeit'), !ctx.standardActivityAllowedIfRequired && actFormToCheck.activityWvId === "bcafd3ce-f25c-410a-a623-75c77eb15d5c", actFormToCheck) || result;
                    if (requiredFields) {
                        if ((_c = requiredFields.workingHours) === null || _c === void 0 ? void 0 : _c.activityWvId)
                            result = addOrRemoveError(translate(21003030, "Die Tätigkeit muss ausgewählt werden"), (!actFormToCheck.activityWvId || actFormToCheck.activityWvId === QMC.Common.Constants.GUID_EMPTY), actFormToCheck) || result;
                        if ((_d = requiredFields.workingHours) === null || _d === void 0 ? void 0 : _d.careTypeWvId)
                            result = addOrRemoveError(translate(21003031, "Die Betreuungsart muss ausgewählt werden"), (!actFormToCheck.careTypeWvId || actFormToCheck.careTypeWvId === QMC.Common.Constants.GUID_EMPTY), actFormToCheck) || result;
                        if ((_e = requiredFields.workingHours) === null || _e === void 0 ? void 0 : _e.contactTypeWvId)
                            result = addOrRemoveError(translate(21003032, "Die Kontaktart muss ausgewählt werden"), (!actFormToCheck.contactTypeWvId || actFormToCheck.contactTypeWvId === QMC.Common.Constants.GUID_EMPTY), actFormToCheck) || result;
                        result = addOrRemoveError(translate(20016243, "Die Fehlkontaktart muss ausgewählt werden"), actFormToCheck.isMiscontactEnabled && (!actFormToCheck.miscontactWvId || actFormToCheck.miscontactWvId === QMC.Common.Constants.FLS_NO_MISCONTACT), actFormToCheck) || result;
                        result = this.checkTitle({ requiredFields: ctx.requiredFields, form: ctx.form }, translate, addOrRemoveError) || result;
                        if ((_f = requiredFields.drivingCost) === null || _f === void 0 ? void 0 : _f.drivingCostCategoryId) {
                            result = this.validateDrivingCostCategory({ form: ctx.form, validateEmptyDrivingCost: ctx.validateEmptyDrivingCost }, translate, addOrRemoveError) || result;
                        }
                        if (!ctx.validateEmptyDrivingCost) {
                            result = this.validateDrivingCostDuration({ form: ctx.form, validateEmptyDrivingCost: ctx.validateEmptyDrivingCost }, translate, addOrRemoveError) || result;
                        }
                    }
                    if (!ctx.isNewDocumentation || ctx.isGroup) {
                        mergeCarerValidationToGlobal(actFormToCheck);
                    }
                }
                result = this.validateDrivingCostVehicle({ form: ctx.form }, translate, addOrRemoveError) || result;
                result = addOrRemoveError(translate(20016216, "Die manuelle Dauer muss größer 0 sein."), ctx.timeForm.isManualDuration && (ctx.timeForm.isManualTimeRequired && ctx.timeForm.hours <= 0 && ctx.timeForm.minutes <= 0)) || result;
                ctx.udfs.forEach(udf => {
                    result = addOrRemoveError(`${translate(20002065, 'In diesem Tab sind nicht alle Pflichtfelder ausgefüllt')}: ${udf.caption}`, !udf.isValid) || result;
                });
                scopeApply();
                return result;
            }
        };
        FlsDocumentationValidationService = __decorate([
            QMC.Service('QMC.Fachleistung', 'FlsDocumentationValidationService'),
            QMC.Inject()
        ], FlsDocumentationValidationService);
        Fachleistung.FlsDocumentationValidationService = FlsDocumentationValidationService;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsDocumentationController_1;
        let FlsDocumentationController = FlsDocumentationController_1 = class FlsDocumentationController {
            /**
             * Creates an instance of FlsDocumentationController.
             * @param {FlsService} fachleistungService
             * @param {any} $qui
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {QMC.Klient.KlientService} clientService
             * @param {*} userService
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberof FlsDocumentationController
             */
            constructor($location, fachleistungService, cacheService, validationService, $qui, $stateParams, $scope, $state, $timeout, clientService, userService, lng, permissionService, markItemService, udfService) {
                this.$location = $location;
                this.fachleistungService = fachleistungService;
                this.cacheService = cacheService;
                this.validationService = validationService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.$timeout = $timeout;
                this.clientService = clientService;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.markItemService = markItemService;
                // ---- UI & view state ----
                this.ui = new Fachleistung.UserInterface();
                this.formState = 'new';
                this.loading = {
                    documentation: false,
                    case: false,
                    group: false,
                    save: false,
                    validate: false,
                    settings: false,
                    wv: true,
                    wvFirst: true,
                    requieredFields: true,
                    editorSettings: true,
                    templates: false,
                    allLoaded: () => { return !(this.loading.documentation && this.loading.case || this.loading.group); },
                    allLoadersFinished: () => {
                        return !this.loading.requieredFields && !this.loading.documentation && !this.loading.case && !this.loading.group && !this.loading.save && !this.loading.wv && !this.loading.settings;
                    }
                };
                this.validation = {
                    errors: [],
                    warnings: []
                };
                this.isSaving = false;
                /** After successful create-save: hide save button to prevent duplicate POST (DA-5997). */
                this.documentationSaveSucceeded = false;
                // ---- Case / documentation context ----
                this.documentationIds = [];
                this.cases = [];
                this.isNewDocumentation = false;
                this.isSupportPlanDocu = false;
                this.isGroup = false;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                // ---- Permissions & config ----
                this.permissions = {};
                this.requiredFields = null;
                // ---- Form models ----
                this.form = {
                    workingHours: {
                        abrechenbarkeitId: QMC.Common.Constants.GUID_EMPTY,
                        carerObjectId: QMC.Common.Constants.GUID_EMPTY
                    }
                };
                this.timeForm = {
                    dateFrom: new Date(),
                    originalTimeFrom: new Date(),
                    dateTo: new Date(),
                    originalTimeTo: new Date(),
                    hours: 0,
                    minutes: 0,
                    distributeHours: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN,
                    distributeHoursFix: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX,
                    isManualDuration: false,
                    isManualTimeAllowed: true,
                    isManualTimeRequired: false,
                    isManuelTimeVisible: true,
                    timeString: "",
                    splitString: "",
                    disableTime: false,
                    createDate: new Date(),
                };
                this.reportForm = {
                    templateId: null,
                    items: [],
                    templates: [],
                    activeReport: null,
                    isReportViewAllowed: true,
                    isReportUpdateAllowed: true,
                    reports: [],
                    normalReportTemplates: [],
                    supportPlanTemplates: []
                };
                this.activityForm = {
                    carerId: null,
                    activityWvId: QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                    contactTypeWvId: null,
                    careTypeWvId: null,
                    miscontactWvId: QMC.Common.Constants.FLS_NO_MISCONTACT,
                    isActivityFix: false,
                    isMiscontactEnabled: false,
                    isMiscontactRequired: false
                };
                this.createForm = {
                    timeForm: null,
                    activityForm: null,
                    drivingCostsForm: [],
                    participantsForm: null,
                    additionnalCosts: [],
                };
                // ---- Report templates & lists ----
                this.reportTemplates = {
                    normal: [],
                    supportPlan: []
                };
                this.vehiclesMap = [];
                this.udfs = [];
                this.participantsList = [];
                // ---- Feature flags / visibility ----
                this.showAdditionalCosts = true;
                this.hideQuickDrivingCost = false;
                this.enableWarningReason = false;
                this.additionalFlsEnabled = false;
                this.modifiyDescription = false;
                this.isReportTemplateFix = false;
                this.fkSourceSystem = 0;
                // ---- Selection, support plan & warning ----
                this.selectedMarkings = [];
                this.activeSupportPlanPhase = null;
                this.elaborativeWarning = false;
                this.elaborativeWarningData = {};
                // ---- Smart action & create ----
                this.smartAction = new QMC.Common.SmartAction(this.permissionService, this.userService, this.clientService, this.lng, this.$scope);
                this.flushSummernote = null;
                this.focusSummernote = null;
                this.flsCaseIds = [];
                this.isPlaned = false;
                /** Deregister functions for deep $watch handlers used by localStorage form cache (see initCacheWatcher). */
                this.cacheFormWatcherDeregisters = [];
                this.cacheWatcherInitTimeoutId = null;
                /** Set when cleanupRuntimeBindings runs so deferred callbacks stop scheduling work. */
                this.flsDocDestroyed = false;
                this.udfsDeepWatchUnwatch = null;
                this.drivingCostOverlapListUnwatch = null;
                this.postLoadInitTimeoutId = null;
                this.loadDocuWaiterTimeoutId = null;
                this.initFormEventsTimeoutId = null;
                this.addDrivingCostRetryTimeoutId = null;
                // ---- Private: time & validation config ----
                this.maxFutureDays = -1;
                this.hasMaxFutureDays = false;
                this.validateEmptyDrivingCost = false;
                this.ignoreConfigRoundInterval = false;
                this.accountabilityBoxState = 'close';
                this.standardActivityAllowedIfRequired = false;
                this.editAdditionalCosts = false;
                this.newAdditionalCosts = false;
                this.deleteAdditionalCosts = false;
                this.showDrivingCosts = true;
                this.isMarkingRequired = false;
                this.allowEmptyReports = true;
                this.isManuelTimeVisible = false;
                this.defaultTimesSet = false;
                // ---- Private: user & wv data ----
                this.userSettings = {};
                this.wvCarerDocumentationList = [];
                this.wvlivingAreaList = [];
                this.wvsubLivingAreaList = [];
                this.drivingAddresses = [];
                this.allpossibleClientParticipants = [];
                this.carers = [];
                this.carersIds = [];
                this.selectedCarerList = [];
                this.zIndexCarerForm = 9999;
                this.showActivityForFirstCarerOpen = true;
                // ---- Private: additional fls & report config ----
                this.additionalFls = false;
                this.additionalFlsText = "";
                this.emptyDescription = "";
                this.summaryEntryDays = 0;
                this.editLockType = 'errors';
                this.resetHoursOnManualDuration = false;
                // ---- Private: modals & forms ----
                this.commentModalState = 'close';
                this.group = {
                    onlyNumberOfParticipants: false,
                    allowAdditionalExternalParticipants: false,
                    allowAdditionalInternalParticipants: false,
                    members: {
                        employee: [],
                        client: []
                    },
                    data: null,
                };
                this.participantsForm = {
                    participants: [],
                    participantCount: 0,
                    participantEmployees: []
                };
                this.disableForm = false;
                // ---- Private: prompts & state ----
                this.deleteDocu = {
                    deleteItemId: null,
                    deleteReason: null,
                    deleteText: ""
                };
                this.promptOptionsCache = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-arrow_circle",
                    text: this.lng.translate(20000228, 'Es gibt nicht gespeicherte Änderungen, wollen Sie diese wiederherstellen?'),
                };
                this.promptOptionsTemplateChange = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-ballpen",
                    text: this.lng.translate(20016175, 'Wenn Sie die Vorlage ändern gehen alle Änderungen verloren, wollen Sie fortfahren?'),
                };
                this.promptOptiondsDeleteDokuWithText = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-garbage_can",
                    text: this.lng.translate(20016198, 'Achtung: die FLS enthält inhaltliche Dokumentationen im Berichttext. Sind Sie sicher, dass sie die FLS inkl. deren Inhalt unwiderruflich löschen möchten?'),
                };
                this.promptDateTemplateChange = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-ballpen",
                    text: this.lng.translate(20016267, 'Die ausgewählte Betreuungsplanung ist zum Zeitpunkt der FLS nicht gültig. Der eingegebener Berichtstext geht verloren. Trotzdem fortfahren und Datum übernehmen?'),
                };
                this.defaultActivities = null;
                /**
                 * handel view events.
                 *
                 * @private
                 *
                 * @memberof FlsDocumentationController
                 */
                this.ignoreManualTimeOverwrite = false;
                this.areEventsInit = false;
                this.dontTriggerReportPrompt = false;
                this.templatePromptOpen = false;
                /** When true, programmatic `templateId` changes must not trigger the user watch (avoids overwriting edit payload). */
                this.suppressReportTemplateIdWatch = false;
                /** Cache-restore report snapshot that must be applied after potential late template-item reloads. */
                this.pendingCacheReportRestore = null;
                /** Incremented on each template-items fetch so only the latest HTTP response is applied (parallel / out-of-order). */
                this.reportTemplateItemsRequestSeq = 0;
                this.isValidating = false;
                this.webClientValidationDebouncePromise = null;
                this.validationFailCounter = 0;
                /////////////// Driving COST ///////////////
                this.isDcInit = false;
                this.isNewDocumentation = $state.current.name !== "documentationdetail";
                if (!this.isNewDocumentation)
                    this.documentationIds = [$state.params.id];
                else {
                    this.flsCaseIds = $stateParams.flsCaseIds.split(',');
                    if ($stateParams.plannedDocumentationId !== undefined && $stateParams !== null)
                        this.documentationIds.push($stateParams.plannedDocumentationId);
                    else
                        this.flsCaseIds.forEach(() => { this.documentationIds.push(this.ui.getNewGuid()); });
                }
                //this.validation.errors.push("Es wurde noch keine Validierung durchgeführt");
                this.getSmartActionClientAndEmployeeList();
                this.permissions.forbidden = document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true";
                permissionService.getPermissionsByObjectTypes([230000, 230006, 230020, 230021, 230005]).then((data) => {
                    this.permissions.delete = data[0].delete && data[0].moduleAccess;
                    this.permissions.new = data[0].new && data[0].moduleAccess;
                    this.permissions.modify = data[0].modify && data[0].moduleAccess;
                    this.permissions.drivingCostModuleAccess = data[1].moduleAccess;
                    this.handleReportPermission(data[2]);
                    this.editLockType = data[3].openFile ? 'warnings' : 'errors';
                    if (!this.isNewDocumentation) {
                        permissionService.getPermissionsForDataset(this.documentationIds[0], 230020).then((dataDS) => {
                            this.handleReportPermission(dataDS[0]);
                        });
                    }
                    this.showAdditionalCosts = this.showAdditionalCosts && (data[4].view || data[0].moduleAccess);
                    this.editAdditionalCosts = data[4].modify;
                    this.deleteAdditionalCosts = data[4].delete;
                    this.newAdditionalCosts = data[4].new;
                    this.tryAddInitialDrivingCostForNewDoc();
                });
                this.getReportTemplates();
                this.fachleistungService.getFlsRequiredFields().then(data => {
                    this.requiredFields = data;
                    this.loading.requieredFields = false;
                    const previousStateCache = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE);
                    if (previousStateCache !== null) {
                        this.returnState = JSON.parse(previousStateCache);
                        QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                            state: this.returnState.state,
                            params: this.returnState.params,
                            isBackFromDocumentationDetail: true
                        }));
                    }
                    else {
                        this.returnState = {
                            state: "documentation",
                            params: {},
                            isBackFromDocumentationDetail: true
                        };
                    }
                    this.form.title = `${this.lng.translate(20016003, "Dokumentation vom")} ${moment().format('DD.MM.YYYY')} (WebClient)`;
                    this.init();
                    if (this.isNewDocumentation) {
                        this.isInit = false;
                        this.form.drivingCost = [];
                        this.tryAddInitialDrivingCostForNewDoc();
                        this.getUserConfig(this.flsCaseIds);
                        this.getCases(this.flsCaseIds);
                        this.carerActivityForm = [];
                        this.form.carers = [];
                        this.getCarers();
                        this.events();
                    }
                    else {
                        this.isInit = true;
                        this.loadDocuWaiter();
                        this.form.isUpdateAllowed = true;
                        udfService.getUserDefinedFields(230003).then((data) => {
                            this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                            if (this.udfsDeepWatchUnwatch) {
                                this.udfsDeepWatchUnwatch();
                                this.udfsDeepWatchUnwatch = null;
                            }
                            this.udfsDeepWatchUnwatch = this.$scope.$watch('vm.udfs', (newVal, oldVal) => {
                                if (this.equal(newVal, oldVal))
                                    return;
                                this.scheduleWebClientValidation();
                            }, true);
                        });
                    }
                });
                $qui.init($qui.getSectionColor("/fls/documentation"), () => {
                    //$qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.bindEvents();
                    const floatingMenuButton = $('ul.floating-menu>li>button.floating-menu-open');
                    if ((floatingMenuButton === null || floatingMenuButton === void 0 ? void 0 : floatingMenuButton.off) && (floatingMenuButton === null || floatingMenuButton === void 0 ? void 0 : floatingMenuButton.on)) {
                        floatingMenuButton
                            .off(`click${FlsDocumentationController_1.JQUERY_EVENT_NS}`)
                            .on(`click${FlsDocumentationController_1.JQUERY_EVENT_NS}`, function () {
                            if ($(this).find('i').attr('class') === "fa fa-bars")
                                $(this).find('i').attr('class', "fa fa-times");
                            else
                                $(this).find('i').attr('class', "fa fa-bars");
                            $(' ul.floating-menu>li>ul').toggle('display');
                        });
                    }
                });
                setTimeout(() => {
                    $('#prompt').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }, 300);
                // wait for all loader having finished to make sure form is initialized
                const loadWatcher = this.$scope.$watch('vm.loading', () => {
                    if (this.loading.allLoadersFinished() && this.defaultTimesSet && this.flsDocumentationEditorSettings && (!this.isNewDocumentation || (this.isNewDocumentation && !this.loading.documentation))) {
                        loadWatcher(); // clear watcher after all things are loaded for the first time
                        if (this.postLoadInitTimeoutId != null) {
                            clearTimeout(this.postLoadInitTimeoutId);
                            this.postLoadInitTimeoutId = null;
                        }
                        this.postLoadInitTimeoutId = setTimeout(() => {
                            this.postLoadInitTimeoutId = null;
                            if (this.flsDocDestroyed)
                                return;
                            this.isInit = false;
                            this.events();
                            this.ignoreManualTimeOverwrite = false;
                            this.initCache();
                            this.scheduleWebClientValidation();
                        }, 50);
                    }
                }, true);
                // handle save/delete button visibility for mobile view
                if (this.isMobile) {
                    const documentElement = $(document);
                    if ((documentElement === null || documentElement === void 0 ? void 0 : documentElement.off) && (documentElement === null || documentElement === void 0 ? void 0 : documentElement.on)) {
                        documentElement
                            .off(`scroll${FlsDocumentationController_1.JQUERY_EVENT_NS}`)
                            .on(`scroll${FlsDocumentationController_1.JQUERY_EVENT_NS}`, function () {
                            let floatingButtons = true;
                            //only switch button visablity if bottumButtons enter/leave viewport
                            if ((document.getElementById('mobileBottomButtons').getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight)) && floatingButtons) {
                                $('#mobileFloatingButtons').fadeOut();
                                floatingButtons = false;
                            }
                            else {
                                $('#mobileFloatingButtons').fadeIn();
                                floatingButtons = true;
                            }
                        });
                    }
                }
                this.$scope.$on('$destroy', () => this.cleanupRuntimeBindings());
                if (this.isGroup) {
                    this.allpossibleClientParticipants = this.group.members.client;
                }
            }
            // ---- Private: caching & case ids ----
            get cachingObjectName() { return this.cacheService.getKey($("#session").data().personId); }
            loadDocuWaiter() {
                if (this.flsDocDestroyed)
                    return;
                if (this.ui.documentationTimeForm.form[0] && !this.loading.templates) {
                    if (this.loadDocuWaiterTimeoutId != null) {
                        clearTimeout(this.loadDocuWaiterTimeoutId);
                        this.loadDocuWaiterTimeoutId = null;
                    }
                    this.getDocumentation(this.documentationIds[0] != undefined && this.documentationIds[0] != QMC.Common.Constants.GUID_EMPTY ? this.documentationIds[0] : this.documentationIds[1]);
                }
                else {
                    if (this.loadDocuWaiterTimeoutId != null) {
                        clearTimeout(this.loadDocuWaiterTimeoutId);
                    }
                    this.loadDocuWaiterTimeoutId = setTimeout(() => {
                        this.loadDocuWaiterTimeoutId = null;
                        this.loadDocuWaiter();
                    }, 250);
                }
            }
            handleReportPermission(permission) {
                if (!permission.modify) {
                    this.allowEmptyReports = true;
                }
                this.reportForm.isReportUpdateAllowed = permission.modify;
                this.reportForm.isReportViewAllowed = permission.view;
            }
            /**
             * Init of the local storage form cache. This method is to be called after all other initialization is done (including loading existing data)
             *
             * @memberof FlsDocumentationController
             * */
            initCache() {
                const formObject = this.cacheService.load(this.cachingObjectName);
                //check also if the form can be edited, if not there is no reason to show the cache info or to restore the cache info
                //if the form is disabled you cannot save it so no reason for showing the cache
                const t1 = angular.copy(formObject);
                const t2 = this.createCacheObject();
                if (t1)
                    delete t1.documentationIds;
                if (t2)
                    delete t2.documentationIds;
                const cacheEqual = JSON.stringify(t1) === JSON.stringify(t2);
                if (formObject && !cacheEqual && (!this.shouldDisable())
                    && ((this.isNewDocumentation && formObject.isNew) || QMC.Common.Utilities.arraysEqual(this.documentationIds, formObject.documentationIds))
                    && QMC.Common.Utilities.arraysEqual(this.flsCaseIds, formObject.caseIds) && this.$stateParams.plannedDocumentationId === formObject.planningId) {
                    this.cacheService.showRestoreConfirm(this.promptOptionsCache, () => {
                        var _a;
                        this.ignoreManualTimeOverwrite = true;
                        this.dontTriggerReportPrompt = true;
                        this.suppressReportTemplateIdWatch = true;
                        // form
                        this.form.title = formObject.form.title;
                        this.form.additionalCost = formObject.form.additionalCost;
                        this.form.description = formObject.form.description;
                        if (formObject.form.drivingCost) {
                            this.form.drivingCost.forEach(x => this.deleteDrivingCost(x));
                            this.form.drivingCost = [];
                            formObject.form.drivingCost.forEach((dc) => {
                                this.convertDrivingCostDates(dc);
                                this.addDrivingCost(dc, false);
                            });
                        }
                        this.form.workingHours = { ...this.form.workingHours, ...formObject.form.workingHours };
                        this.form.warning = formObject.form.warning;
                        this.form.plannedDocumentationId = formObject.form.plannedDocumentationId;
                        // time
                        if (formObject.time.dateFrom)
                            formObject.time.dateFrom = this.$qui.createDateFromString(formObject.time.dateFrom);
                        if (formObject.time.dateTo)
                            formObject.time.dateTo = this.$qui.createDateFromString(formObject.time.dateTo);
                        formObject.time.isManualDuration = this.timeForm.isManualTimeAllowed ? formObject.time.isManualDuration || this.timeForm.isManualTimeRequired : false;
                        this.timeForm = { ...this.timeForm, ...formObject.time };
                        // report — keep dropdown and save payload in sync (previously only templateId was set).
                        this.syncReportTemplateIdsToUiAndForm(formObject.report.templateId && formObject.report.templateId !== QMC.Common.Constants.GUID_EMPTY ? formObject.report.templateId : null);
                        // carerActivityForm
                        this.selectedCarerList = formObject.selectedCarerList;
                        // misc
                        this.isPlaned = formObject.form.plannedDocumentationId ? true : false;
                        this.form.plannedDocumentationId = formObject.form.plannedDocumentationId;
                        if (this.isNewDocumentation) {
                            this.documentationIds = formObject.documentationIds;
                            this.createCarerActivityForm(this.selectedCarerList);
                        }
                        this.activityForm = formObject.activity;
                        this.participantsForm = formObject.participants;
                        this.elaborativeWarning = formObject.elaborativeWarning;
                        this.elaborativeWarningData = { ...this.elaborativeWarningData, ...formObject.elaborativeWarningData };
                        this.isSupportPlanDocu = formObject.isSupportPlanDocu;
                        this.pendingCacheReportRestore = angular.copy((_a = formObject.report.reports) !== null && _a !== void 0 ? _a : []);
                        setTimeout(() => {
                            var _a, _b, _c, _d;
                            this.ignoreManualTimeOverwrite = false;
                            this.dontTriggerReportPrompt = false;
                            this.suppressReportTemplateIdWatch = false;
                            // Drop possibly stale object reference before replacing the report tree from cache.
                            // Otherwise the old active node can overwrite the restored comment during comment sync.
                            this.reportForm.activeReport = null;
                            this.reportForm.reports = angular.copy((_a = this.pendingCacheReportRestore) !== null && _a !== void 0 ? _a : []);
                            this.pendingCacheReportRestore = null;
                            this.isReportEntryCommented(this.reportForm.reports);
                            if (this.isNewDocumentation && this.reportForm.reports[0]) {
                                this.selectReport(this.reportForm.reports[0]);
                                for (const carerId of this.selectedCarerList) {
                                    const cachedActivity = formObject.carerActivity.find(y => y.carerId === carerId);
                                    const activity = this.carerActivityForm.filter(y => y.carerId === carerId)[0];
                                    if (activity && cachedActivity) {
                                        activity.careTypeWvId = (_b = cachedActivity === null || cachedActivity === void 0 ? void 0 : cachedActivity.careTypeWvId) !== null && _b !== void 0 ? _b : activity.careTypeWvId;
                                        activity.contactTypeWvId = (_c = cachedActivity === null || cachedActivity === void 0 ? void 0 : cachedActivity.contactTypeWvId) !== null && _c !== void 0 ? _c : activity.contactTypeWvId;
                                        activity.activityWvId = (_d = cachedActivity === null || cachedActivity === void 0 ? void 0 : cachedActivity.activityWvId) !== null && _d !== void 0 ? _d : activity.activityWvId;
                                    }
                                }
                            }
                            this.formatTimeString();
                        }, 1000);
                        this.scheduleWebClientValidation();
                    });
                }
                this.initCacheWatcher();
            }
            setReportContentFromCache(targetArray, sourceArray) {
                sourceArray.forEach(source => {
                    const target = targetArray.find(x => x.objectId === source.objectId ||
                        (!!x.templateReferenceId && !!source.templateReferenceId && x.templateReferenceId === source.templateReferenceId) ||
                        (!!x.templateReferenceId && x.templateReferenceId === source.objectId) ||
                        (!!source.templateReferenceId && x.objectId === source.templateReferenceId));
                    if (!target)
                        return;
                    target.comment = source.comment;
                    if (target.children && target.children.length && source.children && source.children.length) {
                        this.setReportContentFromCache(target.children, source.children);
                    }
                });
            }
            disposeCacheFormWatchers() {
                this.disposeWatchers(this.cacheFormWatcherDeregisters);
            }
            /**
             * Registers deep watches that persist form state to session storage. Idempotent: clears any previous
             * watchers and pending schedule so restore-confirm cannot double-register with the trailing initCache() call.
             */
            initCacheWatcher() {
                if (this.cacheWatcherInitTimeoutId != null) {
                    clearTimeout(this.cacheWatcherInitTimeoutId);
                    this.cacheWatcherInitTimeoutId = null;
                }
                this.disposeCacheFormWatchers();
                this.cacheWatcherInitTimeoutId = setTimeout(() => {
                    this.cacheWatcherInitTimeoutId = null;
                    this.cacheFormWatcherDeregisters.push(this.$scope.$watch('vm.reportForm', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.form', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.timeForm', (newValue, oldValue) => {
                        const oldCopy = angular.copy(oldValue);
                        const newCopy = angular.copy(newValue);
                        // remove calculated display values
                        delete newCopy.durationInHours;
                        delete oldCopy.durationInHours;
                        delete newCopy.timeString;
                        delete newCopy.timeString;
                        delete newCopy.splitString;
                        this.cacheForm(newCopy, oldCopy);
                    }, true), this.$scope.$watch('vm.activityForm', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.participantsForm', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.selectedCarerList', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.elaborativeWarning', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.elaborativeWarningData', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true), this.$scope.$watch('vm.carerActivityForm', (newValue, oldValue) => { this.cacheForm(newValue, oldValue); }, true));
                }, 500);
            }
            cacheForm(newVal, oldVal) {
                // only update cache if something has changed
                if (!this.defaultTimesSet || newVal === oldVal || this.equal(newVal, oldVal) || !this.timeForm.dateFrom || !this.timeForm.dateTo || Number.isNaN(this.timeForm.dateFrom.getTime()) || Number.isNaN(this.timeForm.dateFrom.getTime()))
                    return;
                // Create new object containing all relevant forms then serialize it into sessionstorage
                this.cacheService.save(this.cachingObjectName, this.createCacheObject());
            }
            createCacheObject() {
                const obj = {
                    form: {
                        title: this.form.title,
                        additionalCost: this.form.additionalCost,
                        description: this.form.description,
                        drivingCost: this.form.drivingCost,
                        workingHours: this.form.workingHours,
                        warning: this.form.warning,
                        plannedDocumentationId: this.form.plannedDocumentationId
                    },
                    report: {
                        reports: this.reportForm.reports,
                        templateId: this.reportForm.templateId
                    },
                    time: {
                        dateFrom: this.timeForm.dateFrom,
                        dateTo: this.timeForm.dateTo,
                        durationInHours: this.timeForm.isManualDuration ? this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes) : 0,
                        isManualDuration: this.timeForm.isManualDuration,
                        hours: this.timeForm.hours,
                        minutes: this.timeForm.minutes,
                        distributeHours: this.timeForm.distributeHours
                    },
                    activity: this.activityForm,
                    participants: this.participantsForm,
                    documentationIds: this.documentationIds,
                    caseIds: this.flsCaseIds,
                    isNew: this.isNewDocumentation,
                    selectedCarerList: this.selectedCarerList,
                    elaborativeWarning: this.elaborativeWarning,
                    elaborativeWarningData: this.elaborativeWarningData,
                    carerActivity: [],
                    isSupportPlanDocu: this.isSupportPlanDocu,
                    planningId: this.$stateParams.plannedDocumentationId
                };
                if (this.isNewDocumentation)
                    this.carerActivityForm.forEach(x => obj.carerActivity.push({ carerId: x.carerId, activityWvId: x.activityWvId, contactTypeWvId: x.contactTypeWvId, careTypeWvId: x.careTypeWvId }));
                obj.form.drivingCost.forEach(dc => { delete dc.watcherList; delete dc.$$hashKey; });
                obj.report.reports.forEach(dc => { delete dc.$$hashKey; });
                return obj;
            }
            /**
            * Init default values, check for data in the localStorage.
            *
            * @private
            *
            * @memberof FlsDocumentationController
            */
            init() {
                var _a;
                this.isInit = true;
                if (this.$stateParams.plannedDocumentationId !== undefined)
                    this.form.plannedDocumentationId = this.$stateParams.plannedDocumentationId;
                let flsObject = QMC.Common.personalLocalStorage.getItem('flsObject') ? JSON.parse(QMC.Common.personalLocalStorage.getItem('flsObject')) : undefined;
                if (flsObject && this.form.plannedDocumentationId !== undefined) {
                    this.isPlaned = true;
                    if (this.$stateParams.flsCaseIds === flsObject.flsCaseId) {
                        this.timeForm.dateFrom = this.$qui.createDateFromString(flsObject.dateFrom);
                        this.timeForm.dateTo = this.$qui.createDateFromString(flsObject.dateTo);
                    }
                    else {
                        this.timeForm.dateFrom = new Date();
                        this.timeForm.dateTo = moment().add(2, 'hours').toDate();
                    }
                    this.timeForm.originalTimeFrom = angular.copy(this.timeForm.dateFrom);
                    this.timeForm.originalTimeTo = angular.copy(this.timeForm.dateTo);
                    this.form.description = flsObject.description;
                    this.form.dateFrom = angular.copy(this.timeForm.dateFrom);
                    this.form.dateTo = angular.copy(this.timeForm.dateTo);
                    this.selectedCarerList = [(_a = flsObject.carerId) !== null && _a !== void 0 ? _a : $('#session').data().personId];
                }
                if (this.isGroup)
                    this.form.participantCount = 0;
            }
            /**
             * Create the forms, create events
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            initForm() {
                if (this.requiredFields) {
                    this.ui.documentationActivityForm.form[0].required = this.requiredFields.workingHours.activityWvId;
                    this.ui.documentationActivityForm.form[1].required = this.requiredFields.workingHours.activityWvId;
                    this.ui.documentationActivityForm.form[2].required = this.requiredFields.workingHours.contactTypeWvId;
                    this.ui.documentationActivityForm.form[3].required = this.requiredFields.workingHours.careTypeWvId;
                    this.ui.documentationActivityForm.form[5].required = this.requiredFields.workingHours.miscontactWvId;
                    this.ui.documentationActivityForm.form[6].required = this.requiredFields.workingHours.miscontactWvId;
                }
                this.$qui.functionWaiter("createForm.activityForm", this);
                this.$qui.functionWaiter("createForm.timeForm", this);
                if (this.isNewDocumentation)
                    this.isInit = false;
                if (this.initFormEventsTimeoutId != null) {
                    clearTimeout(this.initFormEventsTimeoutId);
                    this.initFormEventsTimeoutId = null;
                }
                this.initFormEventsTimeoutId = setTimeout(() => {
                    this.initFormEventsTimeoutId = null;
                    if (this.flsDocDestroyed)
                        return;
                    this.events();
                }, 1000);
            }
            events() {
                if (this.areEventsInit)
                    return;
                this.areEventsInit = true;
                this.$scope.$watch('vm.reportForm.templateId', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    if (this.suppressReportTemplateIdWatch)
                        return;
                    this.getReportTemplateItems(this.reportForm.templateId);
                });
                this.$scope.$watch('vm.timeForm.dateFrom', (newVal, oldVal) => {
                    if (this.equal(newVal, oldVal))
                        return;
                    //this setting should be applied only for new entries and in case of saved entries after the user changes the date from/to
                    this.ui.documentationTimeForm.form[0].config.roundInterval = this.configRoundInterval;
                    this.ui.documentationTimeForm.form[0].config.startRoundType = this.configStartRoundType;
                    this.ui.documentationTimeForm.form[0].config.endRoundType = this.configEndRoundType;
                    this.ignoreConfigRoundInterval = false;
                    if ((moment(this.timeForm.dateFrom).toDate().getTime() === moment(this.timeForm.originalTimeFrom).toDate().getTime()) &&
                        (moment(this.timeForm.dateTo).toDate().getTime() === moment(this.timeForm.originalTimeTo).toDate().getTime())) {
                        this.ignoreConfigRoundInterval = true;
                    }
                    this.getWv(this.flsCaseIds, this.documentationIds[0]);
                    this.getCatalogSettings();
                    if (this.ignoreManualTimeOverwrite || this.equal(newVal, oldVal))
                        return;
                    if (!this.isInit) {
                        this.scheduleWebClientValidation();
                        if (this.form.drivingCost) {
                            for (const cost of this.form.drivingCost) {
                                if (!isNaN(this.timeForm.dateFrom.valueOf())) {
                                    if (!cost.dateOfDeparture)
                                        cost.dateOfDeparture = angular.copy(this.timeForm.dateFrom);
                                }
                            }
                        }
                    }
                    //load SupportPlan items again
                    if (this.cases.length > 0) {
                        this.getSupportPlanTargetTemplates(this.cases[0].clientObjectId, moment(oldVal).toDate());
                    }
                    if (this.isGroup)
                        this.$qui.functionWaiter("createForm.participantsForm", this);
                });
                this.$scope.$watch('vm.timeForm.dateTo', (newVal, oldVal) => {
                    if (this.equal(newVal, oldVal) || this.isInit)
                        return;
                    //this setting should be applied only for new entries and in case of saved entries after the user changes the date from/to
                    this.ui.documentationTimeForm.form[0].config.roundInterval = this.configRoundInterval;
                    this.ui.documentationTimeForm.form[0].config.startRoundType = this.configStartRoundType;
                    this.ui.documentationTimeForm.form[0].config.endRoundType = this.configEndRoundType;
                    this.ignoreConfigRoundInterval = false;
                    if ((moment(this.timeForm.dateFrom).toDate().getTime() === moment(this.timeForm.originalTimeFrom).toDate().getTime()) &&
                        (moment(this.timeForm.dateTo).toDate().getTime() === moment(this.timeForm.originalTimeTo).toDate().getTime())) {
                        this.ignoreConfigRoundInterval = true;
                    }
                    if (this.ignoreManualTimeOverwrite || this.equal(newVal, oldVal))
                        return;
                    this.scheduleWebClientValidation();
                });
                this.$scope.$watch('vm.timeForm.isManualDuration', (newVal, oldVal) => {
                    if (this.ignoreManualTimeOverwrite || this.equal(newVal, oldVal) || this.isInit)
                        return;
                    if (newVal)
                        this.prevTimeFormDateFrom = angular.copy(this.timeForm.dateFrom);
                    if (this.resetHoursOnManualDuration && this.timeForm.isManualDuration) {
                        this.timeForm.disableTime = true;
                        this.timeForm.dateFrom = moment(this.timeForm.dateFrom).startOf('day').toDate();
                        this.timeForm.dateTo = moment(this.timeForm.dateTo).startOf('day').toDate();
                    }
                    else {
                        this.timeForm.disableTime = false;
                        if (this.resetHoursOnManualDuration) {
                            const hours = this.prevTimeFormDateFrom ? moment(this.prevTimeFormDateFrom).hours() : this.flsDocumentationEditorSettings.defaultHour;
                            const minutes = this.prevTimeFormDateFrom ? moment(this.prevTimeFormDateFrom).minutes() : 0;
                            this.timeForm.dateFrom = moment(this.timeForm.dateFrom).startOf('day').add(hours, 'h').add(minutes, 'm').toDate();
                            this.timeForm.dateTo = moment(this.timeForm.dateFrom).add(this.ui.convertHours(this.timeForm.hours, this.timeForm.minutes), 'h').toDate();
                        }
                    }
                    this.scheduleWebClientValidation();
                    if (this.timeForm.isManualDuration && !this.ignoreManualTimeOverwrite) {
                        const conv = this.$qui.convertDec(this.timeForm.durationInHours);
                        setTimeout(() => {
                            this.timeForm.hours = conv[0];
                            this.timeForm.minutes = conv[1];
                        }, 250);
                    }
                });
                this.$scope.$watch('vm.timeForm.distributeHours', (newVal, oldVal) => {
                    this.formatTimeString();
                    if (this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    if (this.timeForm.distributeHours && this.timeForm.isManualTimeAllowed)
                        this.timeForm.isManualDuration = false;
                    this.scheduleWebClientValidation();
                });
                this.$scope.$watch('vm.timeForm.hours', (newVal, oldVal) => {
                    if (this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    this.manualTimeWatch();
                    this.formatTimeString();
                    this.timeForm.durationInHours = this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes);
                    this.$qui.scopeApply(this.$scope);
                    this.scheduleWebClientValidation();
                }, true);
                this.$scope.$watch('vm.timeForm.minutes', (newVal, oldVal) => {
                    if (this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    this.manualTimeWatch();
                    this.formatTimeString();
                    this.timeForm.durationInHours = this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes);
                    this.$qui.scopeApply(this.$scope);
                    this.scheduleWebClientValidation();
                }, true);
                this.$scope.$watch('vm.timeForm.durationInHours', (newVal, oldVal) => {
                    if (this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    this.formatTimeString();
                    if (this.timeForm.isManualDuration && !this.ignoreManualTimeOverwrite) {
                        const conv = this.$qui.convertDec(this.timeForm.durationInHours);
                        this.timeForm.hours = conv[0];
                        this.timeForm.minutes = conv[1];
                    }
                    this.$qui.scopeApply(this.$scope);
                    this.scheduleWebClientValidation();
                }, true);
                this.$scope.$watch('vm.form.title', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.form.workingHours.abrechenbarkeitId', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.activityForm.careTypeWvId', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.activityForm.activityWvId', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.activityForm.contactTypeWvId', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.activityForm.miscontactWvId', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.activityForm.isMiscontactEnabled', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.participantsForm.participantsCount', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.reportForm.templateId', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.selectedMarkings', () => { this.scheduleWebClientValidation(); });
                this.$scope.$watch('vm.selectedCarerList', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    //make sure list entries are unique!
                    if (this.selectedCarerList && this.selectedCarerList.length > 0) {
                        const seen = {};
                        const withoutDubs = this.selectedCarerList.filter(function (item) {
                            return seen.hasOwnProperty(item) ? false : (seen[item] = true);
                        });
                        if (withoutDubs.length !== this.selectedCarerList.length) {
                            this.selectedCarerList = withoutDubs;
                            return;
                        }
                    }
                    if (!this.isInit && this.selectedCarerList.length > 0) {
                        this.getWv(this.flsCaseIds, this.documentationIds[0]);
                    }
                    else if (!this.isInit && this.selectedCarerList.length === 0) {
                        //when the last carer is removed, remove also his activity form
                        this.createCarerActivityForm(this.selectedCarerList);
                        this.lastWvGetRequest = "";
                    }
                    //always validate for getting also the error when no carer is selected
                    this.scheduleWebClientValidation();
                });
                if (!this.allowEmptyReports) {
                    this.$scope.$watch('vm.reportForm.activeReport.comment', (newValue, oldValue) => {
                        if (newValue === oldValue)
                            return;
                        this.scheduleWebClientValidation();
                    });
                }
                this.createTypeAhead();
            }
            manualTimeWatch() {
                if (!this.timeForm.isManualDuration)
                    return;
                let hours = this.cleanInputNumber(this.timeForm.hours);
                let minutes = this.cleanInputNumber(this.timeForm.minutes);
                while (minutes >= 60) {
                    minutes = minutes - 60;
                    hours = hours + 1;
                }
                if (this.restrictDaysOnManualDuration) {
                    const dayCount = Math.max(1, Math.ceil(Math.abs(this.timeForm.dateFrom.getTime() - this.timeForm.dateTo.getTime()) / 8.64e7));
                    if (hours >= dayCount * 24) {
                        hours = dayCount * 24;
                        minutes = 0;
                    }
                }
                this.timeForm.hours = hours;
                this.timeForm.minutes = minutes;
                this.scheduleWebClientValidation();
            }
            formatTimeString() {
                var _a;
                let time = (_a = (this.timeForm.isManualDuration ? this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes) : this.timeForm.durationInHours)) !== null && _a !== void 0 ? _a : 0;
                let splittedTime = time / (this.cases.length > 0 ? this.cases.length : 1);
                if (this.showTime) {
                    this.timeForm.timeString = this.getTimeStringFromDecimal(time);
                    this.timeForm.splitString = this.lng.translate(20016194, 'Entspricht pro Fall') + ': ' + this.getTimeStringFromDecimal(splittedTime);
                }
                else {
                    this.timeForm.timeString = time.toFixed(2).toString().replace('.', ',');
                    this.timeForm.splitString = this.lng.translate(20016194, 'Entspricht pro Fall') + ': ' + splittedTime.toFixed(2).toString().replace('.', ',');
                }
                if (this.flsCaseIds.length < 2 || !this.timeForm.distributeHours) {
                    this.timeForm.splitString = "";
                }
            }
            /**
             * Convert decimal hours to time string (HH:mm)
             * @private
             */
            getTimeStringFromDecimal(time) {
                const conv = this.$qui.convertDec(time);
                const minutes = conv[1] < 10 ? `0${conv[1]}` : conv[1].toString();
                return `${conv[0]}:${minutes}`;
            }
            cleanInputNumber(inputNumber) {
                //remove commas and leading minus characters and
                //possibility to remove content of input box completely
                if (isNaN(inputNumber)) {
                    inputNumber = 0;
                }
                //kill leading zeros
                inputNumber = +inputNumber;
                return Math.round(inputNumber);
            }
            hoursMinutesToDecimal(hours, minutes) {
                return (hours !== null && hours !== void 0 ? hours : 0) + ((minutes !== null && minutes !== void 0 ? minutes : 0) / 60);
            }
            /**
             * Normalize date by removing seconds and milliseconds
             * @private
             */
            normalizeDate(date) {
                if (date.getSeconds())
                    date.setSeconds(0);
                if (date.getMilliseconds())
                    date.setMilliseconds(0);
            }
            /**
             * Convert date strings in driving cost object to Date objects
             * @private
             */
            convertDrivingCostDates(cost) {
                if (cost.dateOfArrival)
                    cost.dateOfArrival = this.$qui.createDateFromString(cost.dateOfArrival);
                if (cost.dateOfDeparture)
                    cost.dateOfDeparture = this.$qui.createDateFromString(cost.dateOfDeparture);
                if (cost.timeOfArrival)
                    cost.timeOfArrival = this.$qui.createDateFromString(cost.timeOfArrival);
                if (cost.timeOfDeparture)
                    cost.timeOfDeparture = this.$qui.createDateFromString(cost.timeOfDeparture);
            }
            /**
             * Adds the first driving-cost row for new documentation only when module permission is granted and
             * required fields are loaded (avoids DOM/plugins under #drivingCostTab when the tab is hidden by ng-show).
             */
            tryAddInitialDrivingCostForNewDoc() {
                var _a, _b;
                if (!this.isNewDocumentation || this.flsDocDestroyed)
                    return;
                if (!((_a = this.requiredFields) === null || _a === void 0 ? void 0 : _a.drivingCost))
                    return;
                if (!this.permissions.drivingCostModuleAccess)
                    return;
                if ((_b = this.form.drivingCost) === null || _b === void 0 ? void 0 : _b.length)
                    return;
                this.addDrivingCost(null, false);
            }
            /**
             * Binds bootstrap-typeahead on departure/destination inputs. Rows use duplicate #departure / #destination ids;
             * scope to #drivingCostTab and skip inputs that already have a plugin instance.
             */
            createTypeAhead() {
                if (this.flsDocDestroyed)
                    return;
                if (!this.permissions.drivingCostModuleAccess)
                    return;
                const vm = this;
                const $tab = $('#drivingCostTab');
                if (!$tab.length)
                    return;
                const $inputs = $tab.find('input.typeahead.form-control');
                if (!$inputs.length)
                    return;
                $inputs.each(function () {
                    const $input = $(this);
                    if ($input.data('typeahead'))
                        return;
                    $input.typeahead({
                        minLength: 3,
                        source: function (query, process) {
                            const list = vm.drivingAddresses || [];
                            process(list.map(function (obj) {
                                return obj.value;
                            }));
                        },
                        updater: function (item) {
                            return item;
                        }
                    });
                });
            }
            getUserConfig(caseIds) {
                if (this.userConfig || this.loading.settings) {
                    return;
                }
                let load = 0;
                this.loading.settings = true;
                this.fachleistungService.getDocEndingConfirmForFlsCase(caseIds[0]).then((data) => {
                    const lockDate = this.$qui.createDateFromString(data.lockDate);
                    if (data.hasLockDate) {
                        this.userSettings.isLockedByDate = true;
                        this.userSettings.lockDate = moment(lockDate).add(1, 'days').toDate();
                        this.ui.documentationTimeForm.form[0].startDate = moment(lockDate).add(1, 'days').toDate();
                    }
                    load++;
                    this.loading.settings = load < 4;
                });
                this.userService.getUserSettings(["FLS.SHOWDATETO", "SHOWTIMEINSTEADOFDECIMAL", "FLS.ADDITIONAL_TIMELESS_ENTRY", "FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT", "FLS.DOCUSUMMARYITEMS", "FLS.HIDE_QUICK_DRIVINGCOST", "FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT", "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"]).then((data) => {
                    this.userSettings.dateToEnabled = $.grep(data, function (e) { return e.key === "FLS.SHOWDATETO"; })[0].value === "true";
                    this.ui.documentationTimeForm.form[0].config.displayDateTo = this.userSettings.dateToEnabled;
                    this.showTime = $.grep(data, function (e) { return e.key === "SHOWTIMEINSTEADOFDECIMAL"; })[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : $.grep(data, function (e) { return e.key === "SHOWTIMEINSTEADOFDECIMAL"; })[0].value.toLowerCase() === "true";
                    this.additionalFlsEnabled = $.grep(data, function (e) { return e.key === "FLS.ADDITIONAL_TIMELESS_ENTRY"; })[0].value === "true";
                    this.additionalFlsText = this.additionalFlsEnabled ? $.grep(data, function (e) { return e.key === "FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT"; })[0].value : "";
                    this.additionalFls = this.additionalFlsEnabled;
                    this.summaryEntryDays = $.grep(data, function (e) { return e.key === "FLS.DOCUSUMMARYITEMS"; })[0].value === "" ? 0 : parseInt(data[4].value);
                    this.hideQuickDrivingCost = $.grep(data, function (e) { return e.key === "FLS.HIDE_QUICK_DRIVINGCOST"; })[0].value.toLowerCase() === "true";
                    load++;
                    this.loading.settings = load < 4;
                });
                this.userService.getUserSettings(["FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT", "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER", "FLS.DEFAULTACCOUNTABILITY"], false).then((data) => {
                    this.isManuelTimeVisible = $.grep(data, function (e) { return e.key === "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"; })[0].value.toLowerCase() === "true";
                    const allowManual = $.grep(data, function (e) { return e.key === "FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT"; })[0].value.toLowerCase() === "true";
                    this.timeForm.isManuelTimeVisible = this.isManuelTimeVisible;
                    this.timeForm.isManualTimeAllowed = this.isManuelTimeVisible && allowManual;
                    // apply default rule, if no rule has yet been selected
                    this.defaultAccountabilityRule = $.grep(data, function (e) { return e.key === "FLS.DEFAULTACCOUNTABILITY"; })[0].value;
                    if (!this.form.workingHours.abrechenbarkeitId || this.form.workingHours.abrechenbarkeitId === QMC.Common.Constants.GUID_EMPTY) {
                        this.form.workingHours.abrechenbarkeitId = this.defaultAccountabilityRule;
                    }
                    load++;
                    this.loading.settings = load < 4;
                });
                this.fachleistungService.getUserConfig().then((data) => {
                    var _a;
                    this.userConfig = data;
                    if (this.flsCaseIds.length > 1 && data.multipleCasesDistributeTime) {
                        this.timeForm.distributeHours = true;
                        this.timeForm.isManualDuration = true;
                    }
                    else
                        this.timeForm.distributeHours = false;
                    this.timeForm.distributeHoursFix = data.multipleCasesDistributeTimeFix;
                    this.resetHoursOnManualDuration = data.multipleCasesResetOnDistributeTime;
                    this.restrictDaysOnManualDuration = data.restrictDaysOnManualDuration;
                    this.validateEmptyDrivingCost = data.allowEmptyDrivingCost;
                    if (data.defaultReportTitleType === 1 && this.isNewDocumentation)
                        this.form.title = "";
                    if (data.defaultReportTitleType === 2 && this.isNewDocumentation)
                        this.form.title = data.defaultReportTitle;
                    this.defaultActivities = {
                        careType: data.defaultCareType,
                        contactType: data.defaultContactType,
                        activityType: data.defaultActivityType
                    };
                    if (this.drivingCostOverlapListUnwatch) {
                        this.drivingCostOverlapListUnwatch();
                        this.drivingCostOverlapListUnwatch = null;
                    }
                    if (data.drivingCostOverlapCheck !== 'fe55229f-b052-4d3a-b2d1-e127b0d08879') {
                        this.drivingCostOverlapListUnwatch = this.$scope.$watch('vm.form.drivingCost', (newValue, oldValue) => {
                            if (newValue === oldValue || !newValue)
                                return;
                            this.scheduleWebClientValidation();
                        }, true);
                    }
                    this.enableWarningReason = data.enableWarningReason;
                    const endDate = moment().add(data.daysAllowedCreatingReportsForFuture, 'days').toDate();
                    let startDate = moment().subtract(data.daysAllowedCreatingReportsForPast, 'days').toDate();
                    if (!this.isNewDocumentation) {
                        startDate = moment(this.timeForm.createDate).subtract(data.daysAllowedCreatingReportsForPast, 'days').toDate();
                    }
                    this.hasMaxFutureDays = data.isLockedCreatingForFuture;
                    this.maxFutureDays = data.daysAllowedCreatingReportsForFuture;
                    if ((data.isLockedCreatingForPast && this.editLockType === 'errors') && (this.ui.documentationTimeForm.form[0].startDate < startDate || this.ui.documentationTimeForm.form[0].startDate === null)) {
                        this.ui.documentationTimeForm.form[0].startDate = moment(startDate).startOf('day').toDate();
                    }
                    if (data.isLockedCreatingForFuture && this.editLockType === 'errors')
                        this.ui.documentationTimeForm.form[0].endDate = moment(endDate).endOf('day').toDate();
                    this.timeForm.isManualTimeRequired = data.isManualTimeRequired;
                    this.timeForm.isManualTimeAllowed = data.allowManualTimes || data.isManualTimeRequired;
                    if (!this.timeForm.isManualTimeAllowed) {
                        if (!this.isNewDocumentation && this.timeForm.isManualDuration) {
                            const prevDur = this.timeForm.durationInHours;
                            setTimeout(() => {
                                this.timeForm.durationInHours = prevDur;
                            }, 250);
                        }
                        this.timeForm.isManualDuration = false;
                    }
                    else if (this.isNewDocumentation) {
                        this.timeForm.isManualDuration = data.manualTimeDefault;
                    }
                    if (this.resetHoursOnManualDuration && this.timeForm.isManualDuration) {
                        this.timeForm.dateFrom = moment(this.timeForm.dateFrom).startOf('day').toDate();
                        this.timeForm.dateTo = moment(this.timeForm.dateTo).startOf('day').toDate();
                    }
                    this.showAdditionalCosts = this.showAdditionalCosts && data.showAdditionalCosts;
                    this.showDrivingCosts = data.showDrivingCosts;
                    this.isMarkingRequired = data.isMarkingRequired;
                    this.allowEmptyReports = data.allowEmptyReports;
                    this.form.warning = (_a = this.form.warning) !== null && _a !== void 0 ? _a : false;
                    this.initForm();
                    this.formatTimeString();
                    load++;
                    this.loading.settings = load < 4;
                });
            }
            getCurrentGenericWvList() {
                var _a;
                return this.wvList ? this.wvList : (_a = this.wvCarerDocumentationList[0]) === null || _a === void 0 ? void 0 : _a.documentationCarerWvModel;
            }
            setUpdateAllowedOnDescriptionChange() {
                this.modifiyDescription = true;
            }
            isCommentEditAllowed() {
                return this.isNewDocumentation || this.form.isUpdateAllowed || this.editLockType === 'warnings';
            }
            /**
             * Get a single documentation by id
             *
             * @private
             * @param {Guid} id
             *
             * @memberof FlsDocumentationController
             */
            getDocumentation(id) {
                this.loading.documentation = true;
                this.fachleistungService.getFlsDocumentation(id).then((data) => {
                    var _a, _b;
                    this.carersIds = [];
                    this.carersIds.push(data.isGroupDocumentation ? $('#session').data().personId : data.workingHours.carerObjectId);
                    this.flsCaseIds = [data.flsCaseId];
                    this.getCases(this.flsCaseIds);
                    this.getUserConfig(this.flsCaseIds);
                    this.formState = "detail";
                    this.form = data;
                    this.form.warning = (_a = data.warning) !== null && _a !== void 0 ? _a : false;
                    this.fkSourceSystem = data.fkSourceSystem;
                    this.isSupportPlanDocu = data.isSupportPlanDocu;
                    this.form.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    this.form.dateTo = this.$qui.createDateFromString(data.dateTo);
                    this.form.isUpdateAllowed = data.isUpdateAllowed;
                    if (this.form.description != null && this.strip(this.form.description).length > 0)
                        this.commentModalState = 'open';
                    // Must run before report handling so downstream logic reads the *current* documentation's flags.
                    this.isReportTemplateFix = data.isReportTemplateFix;
                    this.defaultReportTemplateId = data.reportTemplateId && data.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY ? data.reportTemplateId : this.defaultReportTemplateId;
                    if (this.form.dateFrom.getDay() !== this.form.dateTo.getDay())
                        this.ui.documentationTimeForm.form[0].config.dateToEnabled = true;
                    let hours = 0, minutes = 0;
                    if (data.workingHours.isManualDuration) {
                        hours = parseInt(data.workingHours.durationInHours.toString().split('.')[0]);
                        minutes = Math.round((data.workingHours.durationInHours - hours) * 60);
                    }
                    this.ignoreManualTimeOverwrite = true;
                    this.timeForm = {
                        dateFrom: this.$qui.createDateFromString(data.dateFrom),
                        dateTo: this.$qui.createDateFromString(data.dateTo),
                        originalTimeFrom: this.$qui.createDateFromString(data.dateFrom),
                        originalTimeTo: this.$qui.createDateFromString(data.dateTo),
                        hours: hours,
                        minutes: minutes,
                        distributeHours: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN,
                        distributeHoursFix: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX,
                        isManualDuration: data.workingHours.isManualDuration,
                        isManualTimeAllowed: this.timeForm.isManualTimeAllowed || this.timeForm.isManualTimeRequired,
                        isManuelTimeVisible: this.timeForm.isManuelTimeVisible,
                        timeString: "",
                        splitString: "",
                        durationInHours: data.workingHours.durationInHours,
                        disableTime: false,
                        createDate: this.$qui.createDateFromString(data.createDate),
                        isManualTimeRequired: this.timeForm.isManualTimeRequired
                    };
                    this.formatTimeString();
                    this.getCatalogSettings();
                    this.getWv(this.flsCaseIds, id);
                    if (this.form.reports) {
                        this.dontTriggerReportPrompt = true;
                        this.suppressReportTemplateIdWatch = true;
                        this.reportForm.isReportViewAllowed = data.isReportViewAllowed;
                        this.reportForm.isReportUpdateAllowed = data.isReportUpdateAllowed;
                        // Invalidate in-flight template-item responses from a previous navigation before binding this documentation.
                        this.reportTemplateItemsRequestSeq++;
                        const activeReportTemplateId = data.reportTemplateId && data.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY ? data.reportTemplateId : null;
                        this.syncReportTemplateIdsToUiAndForm(activeReportTemplateId);
                        // Edit spec: always show persisted report rows from the documentation, even if they do not match the template.
                        this.reportForm.reports = angular.copy(data.reports) || [];
                        this.isReportEntryCommented(this.reportForm.reports);
                        const hasPersistedRows = this.reportForm.reports.length > 0;
                        const hasEntityTemplate = this.form.reportTemplateId && this.form.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY;
                        if (!hasPersistedRows && hasEntityTemplate)
                            this.getReportTemplateItems(this.form.reportTemplateId, data.isSupportPlanDocu, true, false);
                        else if (!hasPersistedRows && !hasEntityTemplate && ((_b = this.reportForm.templates) === null || _b === void 0 ? void 0 : _b.length)) {
                            const fb = this.pickCatalogFallbackTemplateId();
                            if (fb) {
                                this.syncReportTemplateIdsToUiAndForm(fb);
                                this.getReportTemplateItems(fb, data.isSupportPlanDocu, true, false);
                            }
                        }
                        setTimeout(() => {
                            this.dontTriggerReportPrompt = false;
                            this.suppressReportTemplateIdWatch = false;
                        }, 1000);
                    }
                    if (!data.isReportUpdateAllowed) {
                        $('#changeTemplate').attr('disabled', 'disabled');
                    }
                    if (!data.isReportViewAllowed) {
                        $('#reportBox').remove();
                    }
                    if (this.form.workingHours) {
                        this.activityForm = {
                            carerId: data.authorPersonObjectId,
                            activityWvId: data.workingHours.activityWvId,
                            careTypeWvId: data.workingHours.careTypeWvId,
                            contactTypeWvId: data.workingHours.contactTypeWvId,
                            miscontactWvId: data.workingHours.miscontactWvId,
                            isActivityFix: this.activityForm.isActivityFix,
                            isMiscontactEnabled: this.requiredFields.workingHours.miscontactWvId || data.workingHours.miscontactWvId && data.workingHours.miscontactWvId !== QMC.Common.Constants.FLS_NO_MISCONTACT,
                            isMiscontactRequired: this.requiredFields.workingHours.miscontactWvId
                        };
                    }
                    ;
                    if (this.form.drivingCost === null)
                        this.form.drivingCost = [];
                    for (const element of this.form.drivingCost) {
                        let hours, minutes;
                        [hours, minutes] = this.$qui.convertDec(element.duration);
                        element.hours = hours;
                        element.minutes = minutes;
                        element.dateOfDeparture = element.dateOfDeparture != null ?
                            this.$qui.createDateFromString(element.dateOfDeparture) :
                            this.$qui.createDateFromString(this.timeForm.dateFrom);
                        element.timeOfDeparture = element.dateOfDeparture != null ?
                            this.$qui.createDateFromString(element.dateOfDeparture) :
                            this.$qui.createDateFromString(this.timeForm.dateFrom);
                        element.dateOfArrival = element.dateOfArrival != null ?
                            this.$qui.createDateFromString(element.dateOfArrival) :
                            this.$qui.createDateFromString(this.timeForm.dateTo);
                        element.timeOfArrival = element.dateOfArrival != null ?
                            this.$qui.createDateFromString(element.dateOfArrival) :
                            this.$qui.createDateFromString(this.timeForm.dateFrom);
                        let arrivalTime = this.$qui.createDateFromString(element.dateOfDeparture);
                        arrivalTime.setHours(arrivalTime.getHours() + hours);
                        if (this.$qui.createDateFromString(arrivalTime.getTime() + minutes * 60000) != element.timeOfArrival) {
                            element.timeOfArrival = this.$qui.createDateFromString(arrivalTime.getTime() + minutes * 60000);
                        }
                        element.isCarPool = element.drivingCostType === 1;
                        element.isPrivate = element.drivingCostType === 0;
                        element.synchronize = false;
                        element.isBlocked = element.isCarPool;
                    }
                    this.addDrivingCost(null, this.form.drivingCost.length > 0);
                    if (this.form.drivingCost[0] && this.form.drivingCost[0].mileageArrival === 0) {
                        this.updateMileage(this.form.drivingCost[0], 'distance');
                    }
                    if (data.isGroupDocumentation) {
                        if (data.participants)
                            this.participantsForm.participants = data.participants.filter(x => !x.isEmployee).map(x => (x.objectId));
                        if (data.participants)
                            this.participantsForm.participantEmployees = data.participants.filter(x => x.isEmployee).map(x => (x.objectId));
                        this.participantsForm.participantCount = data.participantCount;
                        this.isGroup = true;
                    }
                    this.elaborativeWarning = data.warning && Object.keys(data.warningReasons).length > 0;
                    this.elaborativeWarningData = this.getInternalElobaritveWarningObject(data.warningReasons);
                    setTimeout(() => {
                        this.loading.documentation = false;
                        this.timeForm.hours = hours;
                        this.timeForm.minutes = minutes;
                    }, 500);
                });
            }
            /**
             * get the current fls cases
             *
             * @private
             * @param {Guid[]} caseIds
             *
             * @memberof FlsDocumentationController
             */
            getCases(caseIds) {
                this.loading.case = true;
                this.fachleistungService.getFlsCases(caseIds).then((data) => {
                    var _a, _b, _c;
                    this.cases = data;
                    for (const element of data) {
                        this.allpossibleClientParticipants.push(element.clientObjectId);
                    }
                    if (this.flsCaseIds.length === 1) {
                        if (this.formState === 'new') {
                            this.form.workingHours.abrechenbarkeitId = this.resolveDefaultAbrechenbarkeitId(data[0].defaultAccountableRuleId);
                            this.form.referencedPersonId = data[0].clientObjectId;
                        }
                        this.permissions.isAccountableRuleFix = data[0].isAccountableRuleFix;
                    }
                    else {
                        this.permissions.isAccountableRuleFix = true;
                        for (const element of data) {
                            this.permissions.isAccountableRuleFix = this.permissions.isAccountableRuleFix && element.isAccountableRuleFix;
                        }
                        if (this.formState === 'new') {
                            let caseDefaultAccountableRuleId;
                            for (const element of data) {
                                if (!element.isAccountableRuleFix && this.isValidGuid(element.defaultAccountableRuleId))
                                    caseDefaultAccountableRuleId = element.defaultAccountableRuleId;
                            }
                            this.form.workingHours.abrechenbarkeitId = (_a = this.resolveDefaultAbrechenbarkeitId(caseDefaultAccountableRuleId)) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY;
                        }
                    }
                    // open accountability box if no rule is selected, DA-2941
                    if (this.isNewDocumentation && (!this.form.workingHours.abrechenbarkeitId || this.form.workingHours.abrechenbarkeitId === QMC.Common.Constants.GUID_EMPTY)) {
                        this.$qui.waitForEl('#accountabilityBox', () => {
                            this.accountabilityBoxState = 'open';
                        });
                    }
                    // Group Stuff.
                    this.isGroup = data[0].isGroup && data[0].isServiceBaseTypeGroup;
                    if (this.isGroup) {
                        this.getGroup(data[0].clientObjectId);
                        this.getCatalogSettings();
                    }
                    if (caseIds.length === 1)
                        this.getSupportPlanTargetTemplates(data[0].clientObjectId, null);
                    this.loading.case = false;
                    // Check if any case is paused
                    this.pausedCases = [];
                    this.fachleistungService.getFlsCasePaused(caseIds).then((pauseData) => {
                        for (const curCase of this.cases) {
                            if (pauseData[curCase.objectId]) {
                                this.pausedCases.push(curCase);
                            }
                        }
                        if (this.pausedCases.length > 0) {
                            $('#casePausedModal').modal('show');
                        }
                    });
                    // Default report template from case (new documentation) — final selection + items once templates list is available
                    if (this.isNewDocumentation) {
                        this.isReportTemplateFix = data.some(x => x.isReportTemplateFix);
                        if (this.isReportTemplateFix)
                            this.defaultReportTemplateId = (_b = data.filter(x => x.reportTemplateId && x.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY && x.isReportTemplateFix)[0]) === null || _b === void 0 ? void 0 : _b.reportTemplateId;
                        else
                            this.defaultReportTemplateId = (_c = data.filter(x => x.reportTemplateId && x.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY)[0]) === null || _c === void 0 ? void 0 : _c.reportTemplateId;
                        this.tryApplyNewDocumentationReportTemplate();
                    }
                }).catch(() => {
                    this.$qui.notify({
                        message: this.lng.translate(20002066, "Der gewählte Fall steht nicht mehr zur Verfügung, die Planung kann nicht editiert oder dokumentiert werden!"),
                        title: this.lng.translate(20002067, "Editieren nicht möglich"),
                        icon: "qm-icon-information",
                        status: "info",
                        timer: 8000
                    });
                    this.loading.case = false;
                    this.disableForm = true;
                });
            }
            /**
             * get the fls group details
             *
             * @private
             * @param {Guid} id
             *
             * @memberof FlsDocumentationController
             */
            getGroup(id) {
                this.loading.group = true;
                this.fachleistungService.getFlsGroupDetail(id).then((data) => {
                    this.group = {
                        onlyNumberOfParticipants: data.onlyNumberOfParticipants,
                        allowAdditionalExternalParticipants: data.allowAdditionalExternalParticipants,
                        allowAdditionalInternalParticipants: data.allowAdditionalInternalParticipants,
                        members: {
                            employee: data.members.filter(x => x.objectType === 120000).map(x => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.lastName, x.foreName, x.shortCaption, x.personNumber), group: x.objectTypeCaption, subText: x.institute })),
                            client: data.members.filter(x => x.objectType !== 120000).map(x => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.lastName, x.foreName, x.shortCaption, x.personNumber), group: x.objectTypeCaption, subText: x.institute })),
                        },
                        data: data,
                    };
                    this.loading.group = false;
                    this.$qui.functionWaiter("createForm.participantsForm", this);
                    if (this.group.allowAdditionalInternalParticipants && !this.group.onlyNumberOfParticipants) {
                        this.loading.group = true;
                        this.clientService.getPersonListByObjectType(140000, '', true).then((dataClient) => {
                            const groupValues = dataClient.map(x => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber), group: this.lng.translate(21002000, 'Klient'), subText: x.institute }));
                            // remove duplicates
                            for (const member of groupValues) {
                                if (!this.group.members.client.some(x => x.value === member.value))
                                    this.group.members.client.push(member);
                            }
                            this.$qui.functionWaiter("createForm.participantsForm", this);
                            this.loading.group = false;
                        });
                    }
                });
            }
            /**
             * get the current carer list for the additional carers for which to create the documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            getCarers() {
                this.loading.wv = true;
                if (!this.isGroup) {
                    this.fachleistungService.getCarerListForCase(this.flsCaseIds[0], true).then((data) => {
                        this.carers = data.map((x) => ({
                            value: x.objectId, text: this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber)
                        }));
                        this.carersIds = data.map(carerId => carerId.objectId);
                        this.getWv(this.flsCaseIds, null);
                    });
                }
                else {
                    this.carersIds.push($('#session').data().personId);
                    this.getWv(this.flsCaseIds, null);
                }
            }
            /**
             * Find carer by ID
             * @private
             */
            findCarerById(carerId) {
                return this.carers.find(carer => carer.value === carerId);
            }
            /**
             * Create a new activity form for the selected carer the user just selected
             * @private
             */
            createCarerActivityForm(carerIds) {
                var _a, _b;
                if (this.isGroup || !this.carerActivityForm) {
                    // DA-1834, make sure wvs are still valid
                    const wvCarerList = this.wvCarerDocumentationList[0].documentationCarerWvModel;
                    const formCarers = this.form.carers;
                    const carer = formCarers && formCarers.length > 0 ? this.findCarerById(formCarers[0].carerId) : undefined;
                    this.ensureActivityValidity(this.activityForm, carer, wvCarerList, true);
                    return;
                }
                if (!this.defaultActivities) {
                    setTimeout(() => { this.createCarerActivityForm(carerIds); }, 50);
                    return;
                }
                const lastList = angular.copy(this.carerActivityForm);
                for (const form of this.carerActivityForm) {
                    this.disposeWatchers(form.watcherList);
                }
                this.carerActivityForm = [];
                if (carerIds.length === 0)
                    return;
                for (const carerId of carerIds) {
                    const carer = this.findCarerById(carerId);
                    const wvCarerList = this.getCarerWvList(carerId);
                    // if we already had this carer just push it
                    const existed = lastList.find(x => x.carerId === carerId);
                    if (existed) {
                        this.ensureActivityValidity(existed, carer, wvCarerList);
                        this.carerActivityForm.push(existed);
                    }
                    else {
                        const carerActForm = {
                            carerId: carerId,
                            activityWvId: QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                            contactTypeWvId: null,
                            careTypeWvId: null,
                            miscontactWvId: QMC.Common.Constants.FLS_NO_MISCONTACT,
                            isActivityFix: false,
                            careTypeWv: [],
                            contactTypeWv: [],
                            activityWv: [],
                            carerName: '',
                            errors: [],
                            warnings: [],
                            watcherList: [],
                            activityBoxOpen: carerId === $('#session').data().personId ? 'open' : 'close',
                            isMiscontactEnabled: false
                        };
                        carerActForm.zIndex = this.zIndexCarerForm - this.carerActivityForm.length - 1;
                        carerActForm.activityCarerDescr = this.lng.translate(20016205, 'Tätigkeit für') + (((_a = carer === null || carer === void 0 ? void 0 : carer.text) === null || _a === void 0 ? void 0 : _a.length) ? `: ${carer.text}` : ` ${this.lng.translate(20016009, 'Dokumentation')}`);
                        carerActForm.carerName = carer === null || carer === void 0 ? void 0 : carer.text;
                        this.applyWvs(carerActForm, carer, wvCarerList);
                        this.carerActivityForm.push(carerActForm);
                        // DA-1401 if this is not the first carer, use activities from first carer if aplicable
                        // only change activity if it is not fixed and standard is not valid with not just two options available (standard and one alternative)
                        if (this.checkIfWvIsPresentById(wvCarerList.activityWv, this.carerActivityForm[0].activityWvId) && !carerActForm.isActivityFix && wvCarerList.activityWv.length !== 2 && !this.standardActivityAllowedIfRequired)
                            carerActForm.activityWvId = this.carerActivityForm[0].activityWvId;
                        if (this.checkIfWvIsPresentById(wvCarerList.careTypeWv, this.carerActivityForm[0].careTypeWvId))
                            carerActForm.careTypeWvId = this.carerActivityForm[0].careTypeWvId;
                        if (this.checkIfWvIsPresentById(wvCarerList.contactTypeWv, this.carerActivityForm[0].contactTypeWvId))
                            carerActForm.contactTypeWvId = this.carerActivityForm[0].contactTypeWvId;
                        if (this.checkIfWvIsPresentById(wvCarerList.miscontactWv, this.carerActivityForm[0].miscontactWvId))
                            carerActForm.miscontactWvId = ((_b = this.carerActivityForm[0]) === null || _b === void 0 ? void 0 : _b.isMiscontactEnabled) ? this.carerActivityForm[0].miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT;
                        carerActForm.isMiscontactEnabled = this.requiredFields.workingHours.miscontactWvId || (carerActForm.miscontactWvId && carerActForm.miscontactWvId !== QMC.Common.Constants.FLS_NO_MISCONTACT);
                    }
                    this.registerCarerActivityWatchers(this.carerActivityForm.length - 1);
                }
                this.scheduleWebClientValidation();
            }
            registerCarerActivityWatchers(index) {
                const form = this.carerActivityForm[index];
                if (!form)
                    return;
                this.disposeWatchers(form.watcherList);
                form.watcherList = [
                    this.$scope.$watch('vm.carerActivityForm[' + index + '].careTypeWvId', (newValue, oldValue) => {
                        if (newValue !== oldValue && this.carerActivityForm[index])
                            this.scheduleWebClientValidation();
                    }),
                    this.$scope.$watch('vm.carerActivityForm[' + index + '].activityWvId', (newValue, oldValue) => {
                        if (newValue !== oldValue && this.carerActivityForm[index])
                            this.scheduleWebClientValidation();
                    }),
                    this.$scope.$watch('vm.carerActivityForm[' + index + '].contactTypeWvId', (newValue, oldValue) => {
                        if (newValue !== oldValue && this.carerActivityForm[index])
                            this.scheduleWebClientValidation();
                    }),
                    this.$scope.$watch('vm.carerActivityForm[' + index + '].isMiscontactEnabled', (newValue, oldValue) => {
                        if (newValue !== oldValue && this.carerActivityForm[index])
                            this.scheduleWebClientValidation();
                    }),
                    this.$scope.$watch('vm.carerActivityForm[' + index + '].miscontactWvId', (newValue, oldValue) => {
                        if (newValue !== oldValue && this.carerActivityForm[index])
                            this.scheduleWebClientValidation();
                    })
                ];
            }
            showActivityResetNotification(carerName, area, caption) {
                this.$qui.notify({
                    message: this.$qui.formatString(this.lng.translate(20016241, 'Die {0} {1} ist an dem Dokumentationsdatum ungültig'), area, caption),
                    title: ((carerName === null || carerName === void 0 ? void 0 : carerName.length) ? `<strong>${carerName}</strong>:` : '') + this.$qui.formatString(this.lng.translate(0, 'Die {0} wurde zurückgesetzt'), area),
                    icon: "qm-icon-information",
                    status: "info",
                    timer: 8000
                });
            }
            ensureActivityValidity(form, carer, currentWvs, useActvityForm = false) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const previousValues = {
                    activity: form.activityWvId,
                    activityCaption: (_c = (_b = (_a = form.activityWv) === null || _a === void 0 ? void 0 : _a.filter(x => x.value === form.activityWvId)[0]) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : '',
                    contact: form.contactTypeWvId,
                    contactCaption: (_f = (_e = (_d = form.contactTypeWv) === null || _d === void 0 ? void 0 : _d.filter(x => x.value === form.contactTypeWvId)[0]) === null || _e === void 0 ? void 0 : _e.text) !== null && _f !== void 0 ? _f : '',
                    care: form.careTypeWvId,
                    careCaption: (_j = (_h = (_g = form.careTypeWv) === null || _g === void 0 ? void 0 : _g.filter(x => x.value === form.careTypeWvId)[0]) === null || _h === void 0 ? void 0 : _h.text) !== null && _j !== void 0 ? _j : ''
                };
                this.applyWvs(form, carer, currentWvs, useActvityForm);
                if (this.checkIfWvIsPresentById(currentWvs.activityWv, previousValues.activity))
                    form.activityWvId = previousValues.activity;
                else
                    this.showActivityResetNotification(carer === null || carer === void 0 ? void 0 : carer.text, this.lng.translate(20016046, 'Tätigkeit'), previousValues.activityCaption);
                if (this.checkIfWvIsPresentById(currentWvs.careTypeWv, previousValues.care))
                    form.careTypeWvId = previousValues.care;
                else
                    this.showActivityResetNotification(carer === null || carer === void 0 ? void 0 : carer.text, this.lng.translate(20016051, 'Betreuungsart'), previousValues.careCaption);
                if (this.checkIfWvIsPresentById(currentWvs.contactTypeWv, previousValues.contact))
                    form.contactTypeWvId = previousValues.contact;
                else
                    this.showActivityResetNotification(carer === null || carer === void 0 ? void 0 : carer.text, this.lng.translate(20016049, 'Kontaktart'), previousValues.contactCaption);
            }
            /**
             * Apply default activity values if available and valid
             * @private
             */
            applyDefaultActivityValues(carerActForm, wvCarerList) {
                if (!this.defaultActivities)
                    return;
                if (this.isValidGuid(this.defaultActivities.careType) && this.checkIfWvIsPresentById(wvCarerList.careTypeWv, this.defaultActivities.careType)) {
                    carerActForm.careTypeWvId = this.defaultActivities.careType;
                }
                if (this.isValidGuid(this.defaultActivities.contactType) && this.checkIfWvIsPresentById(wvCarerList.contactTypeWv, this.defaultActivities.contactType)) {
                    carerActForm.contactTypeWvId = this.defaultActivities.contactType;
                }
                if (!carerActForm.isActivityFix && this.isValidGuid(this.defaultActivities.activityType) && this.checkIfWvIsPresentById(wvCarerList.activityWv, this.defaultActivities.activityType)) {
                    carerActForm.activityWvId = this.defaultActivities.activityType;
                }
                else if (!carerActForm.isActivityFix && wvCarerList.activityWv.length === 2 && !this.standardActivityAllowedIfRequired) {
                    const nonDefaultActivity = wvCarerList.activityWv.find(element => element.objectId !== QMC.Common.Constants.DEFAULT_ACTIVITY_ID);
                    if (nonDefaultActivity) {
                        carerActForm.activityWvId = nonDefaultActivity.objectId;
                    }
                }
            }
            /**
             * Check if a GUID is valid (not null and not empty)
             * @private
             */
            isValidGuid(guid) {
                return guid !== null && guid !== undefined && guid !== QMC.Common.Constants.GUID_EMPTY;
            }
            resolveDefaultAbrechenbarkeitId(caseDefaultAccountableRuleId) {
                if (this.isValidGuid(caseDefaultAccountableRuleId))
                    return caseDefaultAccountableRuleId;
                return this.defaultAccountabilityRule;
            }
            /**
             * Apply planned activity values from localStorage
             * @private
             */
            applyPlannedActivityValues(carerActForm) {
                var _a, _b, _c, _d;
                const plannedFlsObject = JSON.parse(QMC.Common.personalLocalStorage.getItem('flsObject'));
                carerActForm.activityWvId = (_a = plannedFlsObject.activity) !== null && _a !== void 0 ? _a : carerActForm.activityWvId;
                carerActForm.careTypeWvId = (_b = plannedFlsObject.careType) !== null && _b !== void 0 ? _b : carerActForm.careTypeWvId;
                carerActForm.contactTypeWvId = (_c = plannedFlsObject.contactType) !== null && _c !== void 0 ? _c : carerActForm.contactTypeWvId;
                carerActForm.miscontactWvId = (_d = plannedFlsObject.miscontact) !== null && _d !== void 0 ? _d : carerActForm.miscontactWvId;
                carerActForm.isMiscontactEnabled = carerActForm.miscontactWvId && carerActForm.miscontactWvId !== QMC.Common.Constants.FLS_NO_MISCONTACT;
            }
            applyWvs(carerActForm, carer, wvCarerList, useActvityForm = false) {
                wvCarerList = wvCarerList !== null && wvCarerList !== void 0 ? wvCarerList : this.wvCarerDocumentationList[0].documentationCarerWvModel;
                if (!wvCarerList.activityWv)
                    wvCarerList.activityWv = [];
                carerActForm.activityWv = this.getActivityList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                carerActForm.careTypeWv = this.getCareTypeList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                carerActForm.contactTypeWv = this.getContactList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                carerActForm.miscontactWv = this.getMiscontactList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                this.getCatalogSettings(useActvityForm ? null : carerActForm);
                this.applyDefaultActivityValues(carerActForm, wvCarerList);
                // if we come from a planning update carerForm with selected values from planning
                if (this.isPlaned && !this.carerActivityForm.length && QMC.Common.personalLocalStorage.getItem('flsObject')) {
                    this.applyPlannedActivityValues(carerActForm);
                }
            }
            getWarningErrorsCount(getForWarnings = true) {
                var _a;
                if (!this.isNewDocumentation || !((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length)) {
                    return 0;
                }
                const mode = getForWarnings ? 'warnings' : 'errors';
                return this.carerActivityForm.reduce((count, form) => { var _a, _b; return count + ((_b = (_a = form[mode]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); }, 0);
            }
            /**
             * Gets the catalog settings for the cases.
             */
            getCatalogSettings(carerActivityForm = null) {
                var _a;
                this.loading.editorSettings = true;
                this.fachleistungService.getCatalogSettings(this.flsCaseIds, this.documentationIds[0], this.timeForm.dateFrom, (_a = carerActivityForm === null || carerActivityForm === void 0 ? void 0 : carerActivityForm.carerId) !== null && _a !== void 0 ? _a : $('#session').data().personId).then((data) => {
                    var _a, _b, _c;
                    this.flsDocumentationEditorSettings = data;
                    this.configRoundInterval = data.hasStartHourRounding || data.hasEndHourRound ? Math.max(data.timeSetMinuteInterval, (_c = (_b = (_a = this.ui.documentationTimeForm.form[0]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.roundInterval) !== null && _c !== void 0 ? _c : 0) : 0;
                    this.configStartRoundType = data.hasStartHourRounding ? data.startRoundingType : null;
                    this.configEndRoundType = data.hasEndHourRound ? data.endRoundingType : null;
                    //this setting should be applied only for new entries and in case of saved entries after the user changes the date from/to
                    if (this.isNewDocumentation) {
                        if (this.configRoundInterval > 0) {
                            this.ui.documentationTimeForm.form[0].config.roundInterval = this.configRoundInterval;
                        }
                        if (!this.isPlaned && !this.defaultTimesSet) {
                            this.timeForm.dateFrom.setHours(data.defaultHour);
                            this.timeForm.dateFrom.setMinutes(0);
                            this.timeForm.dateTo.setHours(data.defaultHour + 1);
                            this.timeForm.dateTo.setMinutes(0);
                            if (this.createForm.timeForm)
                                this.createForm.timeForm();
                        }
                        if (this.form.drivingCost[0]) {
                            this.form.drivingCost[0].dateOfArrival.setHours(this.timeForm.dateFrom.getHours());
                            this.form.drivingCost[0].dateOfArrival.setMinutes(0);
                            this.form.drivingCost[0].dateOfDeparture.setHours(this.timeForm.dateFrom.getHours());
                            this.form.drivingCost[0].dateOfDeparture.setMinutes(0);
                            this.form.drivingCost[0].timeOfArrival.setHours(this.timeForm.dateFrom.getHours());
                            this.form.drivingCost[0].timeOfArrival.setMinutes(0);
                            this.form.drivingCost[0].timeOfDeparture.setHours(this.timeForm.dateFrom.getHours());
                            this.form.drivingCost[0].timeOfDeparture.setMinutes(0);
                        }
                    }
                    this.defaultTimesSet = true;
                    this.standardActivityAllowedIfRequired = data.isActivityStandardValidValue;
                    if (carerActivityForm === null) {
                        this.requiredFields.workingHours.contactTypeWvId = data.isContactTypeRequiered || this.requiredFields.workingHours.contactTypeWvId;
                        this.requiredFields.workingHours.careTypeWvId = data.isCareTypeRequiered || this.requiredFields.workingHours.careTypeWvId;
                    }
                    else {
                        carerActivityForm.requiredFields = this.requiredFields;
                        carerActivityForm.requiredFields.workingHours.contactTypeWvId = data.isContactTypeRequiered || carerActivityForm.requiredFields.workingHours.contactTypeWvId || this.requiredFields.workingHours.contactTypeWvId;
                        carerActivityForm.requiredFields.workingHours.careTypeWvId = data.isCareTypeRequiered || carerActivityForm.requiredFields.workingHours.careTypeWvId || this.requiredFields.workingHours.careTypeWvId;
                    }
                    // if we got a fix activity Id set the activity to it!
                    if (this.flsCaseIds.length === 1) {
                        if (carerActivityForm === null) {
                            this.activityForm.isActivityFix = (data.fixActivityId && data.fixActivityId !== QMC.Common.Constants.GUID_EMPTY);
                            if (this.activityForm.isActivityFix)
                                this.activityForm.activityWvId = data.fixActivityId;
                        }
                        else {
                            carerActivityForm.isActivityFix = (data.fixActivityId && data.fixActivityId !== QMC.Common.Constants.GUID_EMPTY);
                            if (carerActivityForm.isActivityFix)
                                carerActivityForm.activityWvId = data.fixActivityId;
                        }
                    }
                    this.loading.editorSettings = false;
                    this.$qui.functionWaiter("createForm.activityForm", this);
                    this.scheduleWebClientValidation();
                }).catch(() => {
                    this.loading.editorSettings = false;
                    this.disableForm = true;
                });
            }
            shouldDisable() {
                if (this.fkSourceSystem !== 0)
                    return true;
                return this.form.isSigned ? this.form.isSigned : (!this.isNewDocumentation && !this.showSaveButton()) || this.hasPrevMonthLock() || this.disableForm;
            }
            showSaveButton() {
                if (this.documentationSaveSucceeded) {
                    return false;
                }
                return ((this.modifiyDescription || this.form.isUpdateAllowed || this.editLockType === 'warnings' || this.formState == 'new') && (this.pausedCases && !(this.pausedCases.length > 0 && this.editLockType === 'errors')));
            }
            showDeleteButton() {
                return this.form.isDeleteAllowed && (this.pausedCases && !(this.pausedCases.length > 0 && this.editLockType === 'errors')) && !this.hasPrevMonthLock();
            }
            hasPrevMonthLock() {
                if (this.isNewDocumentation || this.editLockType === 'warnings')
                    return false; // DAA-481
                if (!this.userConfig || !this.timeForm || !this.timeForm.dateFrom)
                    return true; // no settings loaded / not init => block
                let res = false;
                if (moment(this.timeForm.dateFrom).startOf('month') < moment().startOf('month') && this.userConfig.isLockedCreatingForPreviousMonth) {
                    let i = 0;
                    let dtmin = new moment().startOf('month');
                    while (i < this.userConfig.daysAllowedCreatingReportsForPreviousMonth) {
                        dtmin = dtmin.add(1, 'day');
                        if (!((dtmin.day() === 6) || (dtmin.day() === 0)))
                            i++;
                    }
                    if (dtmin.toDate() < this.timeForm.dateFrom) {
                        res = true;
                    }
                }
                this.addOrRemoveError(this.lng.translate(20016225, 'Die Dokumentation kann aufgrund der Sperre Vormonat nicht mehr verändert werden. Ausgenommen ist das Bemerkungsfeld'), res);
                return res;
            }
            getWv(caseIds, documentationId) {
                let carerIds = this.isNewDocumentation ? this.selectedCarerList : this.carersIds;
                if (!carerIds || carerIds.length === 0) {
                    carerIds = [$('#session').data().personId];
                }
                ;
                const getRequestString = JSON.stringify({ caseIds, documentationId, carerIds, date: this.timeForm.dateFrom });
                if (this.lastWvGetRequest === getRequestString)
                    return;
                this.lastWvGetRequest = getRequestString;
                this.loading.wv = true;
                this.fachleistungService.getFlsDocumentationWvModel(caseIds, documentationId, carerIds, this.timeForm.dateFrom).then((data) => {
                    //sort wvs alphanumerically
                    data.forEach(carer => {
                        for (const wv in carer.documentationCarerWvModel) {
                            if (Array.isArray(carer.documentationCarerWvModel[wv])) {
                                console.log(wv, carer.documentationCarerWvModel[wv]);
                                carer.documentationCarerWvModel[wv] = carer.documentationCarerWvModel[wv].sort((a, b) => { var _a, _b; return ((_a = a.caption) !== null && _a !== void 0 ? _a : a.name).localeCompare(((_b = b.caption) !== null && _b !== void 0 ? _b : b.name), undefined, { sensitivity: 'base' }); });
                            }
                        }
                    });
                    this.wvCarerDocumentationList = data;
                    if (!this.isNewDocumentation || this.isGroup) {
                        //the carersIds will always be filled for an existing documentation in the getDocumentation() function with the ReferencePersonId of the Documentation
                        this.wvList = this.getCarerWvList(this.carersIds[0]);
                    }
                    else {
                        //DA-4495 check if the session user can be a carer before adding him/her to the selectedCarerList
                        if (this.selectedCarerList.length === 0 && this.carersIds.some(x => x === $('#session').data().personId)) {
                            this.selectedCarerList.push($('#session').data().personId);
                        }
                        this.createCarerActivityForm(this.selectedCarerList);
                    }
                    this.wvlivingAreaList = this.getLivingAreaWvList();
                    if (this.wvlivingAreaList.length > 0) {
                        this.livingAreaId = this.wvlivingAreaList[0].value;
                    }
                    //only do this part when you create a group fls, for a new documentation with carers the settings are loaded and set in createCarerActivityForm
                    if (this.isNewDocumentation && this.isGroup) {
                        this.$timeout(() => {
                            this.userService.getUserSettings(["FLS.DEFAULTCARETYPE", "FLS.DEFAULTCONTACTTYPE", "FLS.DEFAULTACTIVITYTYPE"], false).then((data) => {
                                const wvCarerList = this.getCarerWvList($('#session').data().personId);
                                if (!wvCarerList.activityWv)
                                    wvCarerList.activityWv = [];
                                this.activityForm.carerId = $('#session').data().personId;
                                if (this.isValidGuid(data[0].value) && this.checkIfWvIsPresentById(wvCarerList.careTypeWv, data[0].value))
                                    this.activityForm.careTypeWvId = data[0].value;
                                if (this.isValidGuid(data[1].value) && this.checkIfWvIsPresentById(wvCarerList.contactTypeWv, data[1].value))
                                    this.activityForm.contactTypeWvId = data[1].value;
                                if (!this.activityForm.isActivityFix && this.isValidGuid(data[2].value) && this.checkIfWvIsPresentById(wvCarerList.activityWv, data[2].value)) {
                                    this.activityForm.activityWvId = data[2].value;
                                }
                                else if (!this.activityForm.isActivityFix && wvCarerList.activityWv.length === 2 && !this.standardActivityAllowedIfRequired) {
                                    const nonDefaultActivity = wvCarerList.activityWv.find(element => element.objectId !== QMC.Common.Constants.DEFAULT_ACTIVITY_ID);
                                    if (nonDefaultActivity) {
                                        this.activityForm.activityWvId = nonDefaultActivity.objectId;
                                    }
                                }
                            });
                        });
                    }
                    this.loading.wvFirst = false;
                    this.loading.wv = false;
                    this.createCarerActivityForm(carerIds);
                    this.scheduleWebClientValidation();
                });
            }
            getCarerWvList(carerId) {
                var _a, _b;
                for (const element of this.wvCarerDocumentationList) {
                    if (element.carerId === carerId) {
                        return element.documentationCarerWvModel;
                    }
                }
                ;
                // no wv found go with default as failsafe
                return (_b = (_a = this.wvCarerDocumentationList[0]) === null || _a === void 0 ? void 0 : _a.documentationCarerWvModel) !== null && _b !== void 0 ? _b : {};
            }
            checkIfWvIsPresentById(list, id) {
                if (!list)
                    list = [];
                for (const element of list) {
                    if (element.objectId === id
                        //failsafe if any of the involved values is undefined
                        || (!id && element.objectId === QMC.Common.Constants.GUID_EMPTY)
                        || (!element.objectId && id === QMC.Common.Constants.GUID_EMPTY))
                        return true;
                }
                return false;
            }
            getDrivingCostCategoryWv() {
                if (this.wvList && this.wvList.drivingCostCategoryWv.length > 0) {
                    return this.wvList.drivingCostCategoryWv;
                }
                else {
                    const wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return wvCarerList.drivingCostCategoryWv;
                }
            }
            getDrivingCostCategoryList() {
                var _a, _b, _c;
                if (this.wvList && ((_a = this.wvList.drivingCostCategoryWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return (_b = this.wvList.drivingCostCategoryWv) === null || _b === void 0 ? void 0 : _b.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
                else {
                    const wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return (_c = wvCarerList.drivingCostCategoryWv) === null || _c === void 0 ? void 0 : _c.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
            }
            getDrivingCostCharingList() {
                var _a, _b, _c;
                if (this.wvList && ((_a = this.wvList.drivingCostChargingMethodWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return (_b = this.wvList.drivingCostChargingMethodWv) === null || _b === void 0 ? void 0 : _b.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
                else {
                    const wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return (_c = wvCarerList.drivingCostChargingMethodWv) === null || _c === void 0 ? void 0 : _c.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
            }
            getActivityList(carerId = QMC.Common.Constants.GUID_EMPTY, wvCarerList = this.getCarerWvList($('#session').data().personId)) {
                var _a;
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.activityWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.activityWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
                else {
                    return wvCarerList.activityWv ? wvCarerList.activityWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix })) : [];
                }
            }
            getContactList(carerId = QMC.Common.Constants.GUID_EMPTY, wvCarerList = this.getCarerWvList($('#session').data().personId)) {
                var _a;
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.contactTypeWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.contactTypeWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
                else {
                    return wvCarerList.contactTypeWv ? wvCarerList.contactTypeWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix })) : [];
                }
            }
            getCareTypeList(carerId = QMC.Common.Constants.GUID_EMPTY, wvCarerList = this.getCarerWvList($('#session').data().personId)) {
                var _a;
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.careTypeWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.careTypeWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
                else {
                    return wvCarerList.careTypeWv ? wvCarerList.careTypeWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix })) : [];
                }
            }
            getMiscontactList(carerId = QMC.Common.Constants.GUID_EMPTY, wvCarerList = this.getCarerWvList($('#session').data().personId)) {
                var _a;
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.miscontactWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.miscontactWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                }
                else {
                    return wvCarerList.miscontactWv ? wvCarerList.miscontactWv.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix })) : [];
                }
            }
            getLivingAreaWvList() {
                if (this.wvList && this.wvList.livingAreaWvList.length > 0) {
                    const livingAreaWvList = this.wvList.livingAreaWvList.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                    livingAreaWvList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                    return livingAreaWvList;
                }
                else {
                    //get the wvList for the current user
                    const wvCarerList = this.getCarerWvList($('#session').data().personId);
                    const livingAreaWvList = wvCarerList.livingAreaWvList.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                    livingAreaWvList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                    return livingAreaWvList;
                }
            }
            getSubLivingAreaWvList() {
                if (this.livingAreaId && this.livingAreaId !== '') {
                    let data = [];
                    const livingAreaName = this.getlivingAreaName(this.livingAreaId);
                    if (livingAreaName !== '' && livingAreaName) {
                        data = this.wvList.subLivingAreaWvList[livingAreaName];
                        if (data.length > 0) {
                            data = data.map(function (obj) {
                                return {
                                    value: obj.objectId,
                                    text: obj.name
                                };
                            });
                            data.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                        }
                    }
                    return data;
                }
            }
            getlivingAreaName(livingAreaId) {
                const livingAreaType = this.wvList.livingAreaWvList.filter(livingAreaType => livingAreaType.objectId === livingAreaId);
                if (livingAreaType && livingAreaType.length > 0) {
                    const livingAreaName = livingAreaType[0].name;
                    return livingAreaName.substring(0, 1).toLowerCase() + livingAreaName.substring(1);
                }
            }
            getParticipantsList() {
                //only return members assigned for the current day
                const list = this.group.members.client.filter(member => {
                    if (this.group.allowAdditionalInternalParticipants)
                        return true; // allow all members if additional members are allowed
                    const fullMember = this.group.data.members.find(x => x.objectId === member.value);
                    if (!fullMember)
                        return true; // member is not in the original participant list, always add
                    return this.checkIfInDateRange(this.timeForm.dateFrom, fullMember.dateFrom, fullMember.dateTo);
                });
                this.participantsForm.participants = this.participantsForm.participants.filter(x => list.some(y => y.value === x));
                return list;
            }
            getParticipantEmployeesList() {
                const list = this.group.members.employee.filter(employee => {
                    const fullMember = this.group.data.members.find(x => x.objectId === employee.value);
                    if (!fullMember)
                        return true; // member is not in the original participant list, always add
                    return this.checkIfInDateRange(this.timeForm.dateFrom, fullMember.dateFrom, fullMember.dateTo);
                });
                this.participantsForm.participantEmployees = this.participantsForm.participantEmployees.filter(x => list.some(y => y.value === x));
                return list;
            }
            checkIfInDateRange(_target, _dateFrom, _dateTo) {
                //convert dates to moment:
                const target = moment(_target).set({ hours: 12, minutes: 0, seconds: 0 });
                const from = (_dateFrom ? moment(_dateFrom) : moment(0)).startOf('day'); //if no date supplied use minimal possible date
                const to = (_dateTo ? moment(_dateTo) : moment().set('year', 9999)).endOf('day'); // if no date supplied get use astronomical high date
                return target.isBetween(from, to, 'days', '[]');
            }
            getAccountabilityRuleName(id) {
                if (!this.wvList)
                    return '';
                for (const rule of this.wvList.abrechenbarkeitWv)
                    if (rule.objectId === id)
                        return rule.caption;
                return '';
            }
            /////////////// REPORT FUNCTIONS ///////////////
            /**
             * Keeps the report template dropdown (`reportForm.templateId`) and the save payload (`form.reportTemplateId`) identical.
             */
            syncReportTemplateIdsToUiAndForm(activeTemplateId) {
                this.reportForm.templateId = activeTemplateId;
                this.form.reportTemplateId = activeTemplateId !== null && activeTemplateId !== void 0 ? activeTemplateId : QMC.Common.Constants.GUID_EMPTY;
            }
            /**
             * Copies `form.reportTemplateId` back to the UI after canceling a template change, or when no template id was passed to the loader.
             */
            restoreReportTemplateDropdownFromPersistedForm() {
                const persistedReportTemplateId = this.form.reportTemplateId;
                this.reportForm.templateId =
                    persistedReportTemplateId && persistedReportTemplateId !== QMC.Common.Constants.GUID_EMPTY ? persistedReportTemplateId : null;
            }
            /** Loads the list of report templates; for new documentation, selection + items are finalized in {@link tryApplyNewDocumentationReportTemplate}. */
            getReportTemplates() {
                this.loading.templates = true;
                this.fachleistungService.getReportTemplates().then((reportTemplates) => {
                    this.loading.templates = false;
                    this.reportForm.templates = reportTemplates;
                    this.reportForm.normalReportTemplates = reportTemplates;
                    if (this.isNewDocumentation)
                        this.tryApplyNewDocumentationReportTemplate();
                    this.reportTemplates.normal = reportTemplates.map(x => ({ text: x.caption, value: x.id }));
                });
            }
            /**
             * New documentation: fixed case template, else case default template, else catalog `isDefault`, else first template by caption (localeCompare).
             */
            resolveNewDocumentationTemplateId() {
                const list = this.reportForm.templates;
                if (!(list === null || list === void 0 ? void 0 : list.length))
                    return null;
                const empty = QMC.Common.Constants.GUID_EMPTY;
                if (this.isReportTemplateFix && this.defaultReportTemplateId && this.defaultReportTemplateId !== empty)
                    return this.defaultReportTemplateId;
                if (!this.isReportTemplateFix && this.defaultReportTemplateId && this.defaultReportTemplateId !== empty)
                    return this.defaultReportTemplateId;
                return this.pickCatalogFallbackTemplateId();
            }
            /** Catalog-only: template with `isDefault`, else alphabetically first by `caption`. */
            pickCatalogFallbackTemplateId() {
                var _a, _b;
                const list = this.reportForm.templates;
                if (!(list === null || list === void 0 ? void 0 : list.length))
                    return null;
                const def = list.find(t => t.isDefault);
                if (def)
                    return def.objectId;
                const sorted = [...list].sort((a, b) => (a.caption || '').localeCompare(b.caption || '', undefined, { sensitivity: 'base' }));
                return (_b = (_a = sorted[0]) === null || _a === void 0 ? void 0 : _a.objectId) !== null && _b !== void 0 ? _b : null;
            }
            /** After cases and/or template list are ready: apply chosen template for a new documentation and load matching items. */
            tryApplyNewDocumentationReportTemplate() {
                var _a;
                if (!this.isNewDocumentation || !((_a = this.reportForm.templates) === null || _a === void 0 ? void 0 : _a.length))
                    return;
                const id = this.resolveNewDocumentationTemplateId();
                if (!id)
                    return;
                this.suppressReportTemplateIdWatch = true;
                this.syncReportTemplateIdsToUiAndForm(id);
                this.getReportTemplateItems(id, false, true, false);
                this.$timeout(() => { this.suppressReportTemplateIdWatch = false; }, 0);
            }
            /**
             * True if this HTTP response belongs to an older template request (parallel or out-of-order responses).
             */
            isStaleReportTemplateItemsResponse(requestedTemplateId) {
                return requestedTemplateId !== this.reportForm.templateId;
            }
            /**
             * Loads nested report template items for the selected template. If there is already report text and the change
             * would replace it, asks for confirmation before calling the API.
             */
            getReportTemplateItems(templateId, changeReportType = false, noPrompt = false, mergePreviousComments = true) {
                var _a, _b, _c;
                if (!templateId) {
                    this.restoreReportTemplateDropdownFromPersistedForm();
                    return;
                }
                const needsConfirmationBeforeLoad = !noPrompt &&
                    !this.dontTriggerReportPrompt &&
                    this.isReportEntryCommented(this.reportForm.reports);
                if (needsConfirmationBeforeLoad) {
                    if (this.templatePromptOpen)
                        return;
                    this.templatePromptOpen = true;
                    const reportsSnapshot = angular.copy((_a = this.reportForm.reports) !== null && _a !== void 0 ? _a : []);
                    const activeReportIdSnapshot = (_c = (_b = this.reportForm.activeReport) === null || _b === void 0 ? void 0 : _b.objectId) !== null && _c !== void 0 ? _c : null;
                    QMC.Common.Utilities.confirm(this.promptOptionsTemplateChange, (response) => {
                        this.dontTriggerReportPrompt = true;
                        if (response) {
                            this.fetchReportTemplateItemsAndApply(templateId, mergePreviousComments);
                        }
                        else {
                            // Revert selection without triggering the template watch/load path.
                            // Otherwise a same-template reload can still rebuild the tree and drop
                            // comments when persisted/report ids differ from template item ids.
                            this.suppressReportTemplateIdWatch = true;
                            this.reportTemplateItemsRequestSeq++;
                            this.reportForm.reports = reportsSnapshot;
                            this.restoreReportTemplateDropdownFromPersistedForm();
                            if (activeReportIdSnapshot) {
                                const restoredActive = this.findReportByObjectId(this.reportForm.reports, activeReportIdSnapshot);
                                if (restoredActive)
                                    this.reportForm.activeReport = restoredActive;
                            }
                            if (changeReportType) {
                                this.isSupportPlanDocu = !this.isSupportPlanDocu;
                                this.toggleSupportPlan(true, false);
                            }
                        }
                        setTimeout(() => {
                            var _a;
                            this.dontTriggerReportPrompt = false;
                            this.templatePromptOpen = false;
                            this.suppressReportTemplateIdWatch = false;
                            (_a = $('.modal-backdrop')) === null || _a === void 0 ? void 0 : _a.remove();
                        }, 500);
                    }, '#promptTemplate', true);
                    return;
                }
                this.fetchReportTemplateItemsAndApply(templateId, mergePreviousComments);
            }
            /** Fetches report template items from the API and applies them (no confirmation — caller handles that). */
            fetchReportTemplateItemsAndApply(templateId, mergePreviousComments = true) {
                const seq = ++this.reportTemplateItemsRequestSeq;
                const templateItemsServiceMethod = !this.isSupportPlanDocu ? "getReportTemplateItems" : "getSupportPlanTargetTemplateItems";
                this.fachleistungService[templateItemsServiceMethod](templateId).then((reportTemplateItemTree) => {
                    if (seq !== this.reportTemplateItemsRequestSeq)
                        return;
                    if (this.isStaleReportTemplateItemsResponse(templateId))
                        return;
                    this.setReportTemplateItems(templateId, reportTemplateItemTree, mergePreviousComments);
                });
            }
            /**
             * Builds `reportForm.reports` from API template items. When `mergePreviousComments` is true, copies comments from the
             * previous tree onto matching nodes (template / user switches). When false (bootstrap from server template only),
             * replaces the tree without merging.
             */
            setReportTemplateItems(templateId, reportTemplateItemTree, mergePreviousComments = true) {
                var _a, _b;
                if (this.isStaleReportTemplateItemsResponse(templateId))
                    return;
                const newTree = this.createReportTemplateRecursive(reportTemplateItemTree);
                if (((_a = this.pendingCacheReportRestore) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.setReportContentFromCache(newTree, this.pendingCacheReportRestore);
                    this.pendingCacheReportRestore = null;
                }
                else if (mergePreviousComments && ((_b = this.reportForm.reports) === null || _b === void 0 ? void 0 : _b.length) > 0)
                    this.setReportContentFromCache(newTree, this.reportForm.reports);
                this.reportForm.reports = newTree;
                this.$timeout(() => {
                    if (!this.isReportEntryCommented(this.reportForm.reports))
                        this.reportForm.activeReport = this.reportForm.reports[0];
                    this.scheduleWebClientValidation();
                });
                this.syncReportTemplateIdsToUiAndForm(templateId);
            }
            /** Pushes `activeReport.comment` into the tree so comment detection works for nested nodes. */
            syncActiveReportCommentIntoTree(nodes, objectId, comment) {
                var _a;
                const value = comment !== null && comment !== void 0 ? comment : '';
                for (const node of nodes) {
                    if (node.objectId == objectId) {
                        node.comment = value;
                        return true;
                    }
                    if (((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) && this.syncActiveReportCommentIntoTree(node.children, objectId, comment))
                        return true;
                }
                return false;
            }
            /** Finds a report node by objectId in the nested tree. */
            findReportByObjectId(nodes, objectId) {
                var _a;
                for (const node of nodes) {
                    if (node.objectId == objectId)
                        return node;
                    if ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) {
                        const nested = this.findReportByObjectId(node.children, objectId);
                        if (nested)
                            return nested;
                    }
                }
                return null;
            }
            /** True if the exact node reference exists in the current tree. */
            hasReportNodeReference(nodes, nodeRef) {
                var _a;
                for (const node of nodes) {
                    if (node === nodeRef)
                        return true;
                    if (((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) && this.hasReportNodeReference(node.children, nodeRef))
                        return true;
                }
                return false;
            }
            isReportEntryCommented(items, setFirstCommented = true) {
                this.flushReportEditor();
                if (this.reportForm.activeReport &&
                    this.reportForm.reports &&
                    this.hasReportNodeReference(this.reportForm.reports, this.reportForm.activeReport)) {
                    this.syncActiveReportCommentIntoTree(this.reportForm.reports, this.reportForm.activeReport.objectId, this.reportForm.activeReport.comment);
                }
                for (const entry of items) {
                    if (entry.comment && this.strip(entry.comment).length > 0) {
                        if (setFirstCommented) {
                            this.reportForm.activeReport = entry;
                        }
                        return true;
                    }
                    if (entry.children && entry.children.length > 0 && this.isReportEntryCommented(entry.children, setFirstCommented))
                        return true;
                }
                return false;
            }
            /** Recursively maps API report template items to editable report nodes. */
            createReportTemplateRecursive(templateItems) {
                const result = [];
                for (const templateItem of templateItems) {
                    const item = {
                        caption: templateItem.caption,
                        children: [],
                        comment: '',
                        templateReferenceId: templateItem.objectId,
                        wvChildId: templateItem.reportItemId,
                        objectId: templateItem.objectId,
                        icon: this.isSupportPlanDocu ? templateItem.measureId ? 'qm-icon-lifebelt' : templateItem.targetId ? 'qm-icon-target' : 'qm-icon-elements' : ''
                    };
                    if (templateItem.children.length > 0)
                        item.children = this.createReportTemplateRecursive(templateItem.children);
                    result.push(item);
                }
                return result;
            }
            /**
             * Select and set the report template item
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            selectReport(reportItem) {
                this.flushReportEditor();
                this.reportForm.activeReport = reportItem;
                if (this.focusSummernote) {
                    this.focusSummernote();
                }
            }
            /** Pushes the Summernote editor content into `ngModel` before reads or tree sync (model is SSOT). */
            flushReportEditor() {
                if (this.flushSummernote) {
                    this.flushSummernote();
                }
            }
            /**
             * get the support plan from api
             *
             * @private
             * @param {Guid} id
             *
             * @memberof FlsDocumentationController
             */
            getSupportPlanTargetTemplates(id, oldDate) {
                if (this.flsCaseIds.length > 1)
                    return; // if multiple cases, never offer support plans
                this.fachleistungService.getSupportPlanTargetTemplates(id).then((dataSupportPlan) => {
                    dataSupportPlan = dataSupportPlan
                        //sorting
                        .sort((a, b) => {
                        const fromA = moment(a.dateFrom);
                        const fromB = moment(b.dateFrom);
                        return fromA < fromB ? 1 : fromA > fromB ? -1 : 0;
                    })
                        //filtering
                        .filter(x => ((moment(x.dateFrom).startOf('day') <= moment(this.timeForm.dateFrom).startOf('day')) || x.dateFrom == null)
                        && ((moment(x.dateTo).startOf('day') >= moment(this.timeForm.dateFrom).startOf('day')) || x.dateTo == null));
                    if (this.reportForm.supportPlanTemplates === dataSupportPlan)
                        return;
                    this.reportForm.supportPlanTemplates = dataSupportPlan;
                    this.reportTemplates.supportPlan = dataSupportPlan.map(x => ({
                        text: x.caption,
                        subText: x.supportPlanCaption,
                        value: x.id
                    }));
                    if (this.isSupportPlanDocu) {
                        this.reportForm.templates = dataSupportPlan;
                        //check whether an element is selected in the list and a text is in the report text, then make things
                        this.openDateTemplateChange(oldDate);
                    }
                    // Get the activ phase from the CarePlan
                    // Select the first entry from the array
                    const firstTemplate = dataSupportPlan[0];
                    if (firstTemplate) {
                        //get active phase from careplan
                        this.fachleistungService.getSupportPlanActivePhase(firstTemplate.supportPlanId).then((dataPhase) => {
                            if (!(dataPhase === null || dataPhase === void 0 ? void 0 : dataPhase.careplanId)) {
                                this.activeSupportPlanPhase = null;
                                return;
                            }
                            if ((dataPhase.phase != 'CareSummarization') && (dataPhase.phaseState != 'IsDone')) {
                                this.activeSupportPlanPhase = dataPhase;
                            }
                        });
                    }
                });
            }
            /**
             * on DateChange check if supportplan exist
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            openDateTemplateChange(oldDate) {
                var _a;
                //is there already a selected Item
                if (this.reportForm.templateId) {
                    const dataSupportPlan = this.reportForm.supportPlanTemplates;
                    //find Item in the list
                    const findItem = dataSupportPlan.find(x => x.id === this.reportForm.templateId);
                    //if item not in the list
                    if (!findItem && dataSupportPlan) {
                        const firstSupportPlanId = (_a = dataSupportPlan[0]) === null || _a === void 0 ? void 0 : _a.id;
                        if (!firstSupportPlanId)
                            return;
                        //select first item, if there is no Berichts-Text
                        if (!this.isReportEntryCommented(this.reportForm.reports)) {
                            this.getReportTemplateItems(this.reportForm.templateId, true);
                        }
                        else {
                            //Ask, if change Template
                            QMC.Common.Utilities.confirm(this.promptDateTemplateChange, (response) => {
                                if (response) {
                                    //Yes, now delete text an set first item in list
                                    this.reportForm.reports = [];
                                    this.getReportTemplateItems(firstSupportPlanId, true);
                                }
                                else {
                                    //No, so go back to the Date before
                                    if (oldDate) {
                                        this.timeForm.dateFrom = oldDate;
                                    }
                                }
                                setTimeout(() => {
                                    var _a;
                                    // the backdrop sometimes remained...
                                    (_a = $('.modal-backdrop')) === null || _a === void 0 ? void 0 : _a.remove();
                                }, 500);
                            }, '#promptDateTemplate', true);
                        }
                    }
                }
            }
            /**
             * get the phase of the support plan
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            getActiveSupportPlanPhase() {
                let result = '';
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhase(this.activeSupportPlanPhase.phase, this.lng);
                }
                return result;
            }
            /**
             * get the state of the support plan phase
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            getActiveSupportPlanPhaseState() {
                let result = '';
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseState(this.activeSupportPlanPhase.phaseState, this.lng);
                }
                return result;
            }
            /**
            * get the color of the support plan phase
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            getActiveSupportPlanPhaseColor() {
                let result = '';
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseColor(this.activeSupportPlanPhase.phaseState);
                }
                return result;
            }
            /**
            * get the text of the support plan phase
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            getActiveSupportPlanPhaseText() {
                let result = '';
                let today = new Date();
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseText(this.activeSupportPlanPhase, this.lng, this.$qui);
                }
                return result;
            }
            /**
            *  generate the Link to support plan frontend
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            getActiveSupportPlanLink() {
                let sUrl = '';
                if (this.activeSupportPlanPhase && this.activeSupportPlanPhase.careplanId) {
                    sUrl = QMC.Common.SupportPlanHelper.getActiveSupportPlanLink(this.activeSupportPlanPhase.careplanId.toString());
                }
                return sUrl;
            }
            /**
            *  switches to support plan templates
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            toggleSupportPlan(dontSetTemplates = false, overwrite = true) {
                if (this.isSupportPlanDocu) {
                    this.reportForm.templates = this.reportForm.supportPlanTemplates;
                }
                else {
                    this.reportForm.templates = this.reportForm.normalReportTemplates;
                }
                if (overwrite && (!dontSetTemplates || !(this.isNewDocumentation && this.form.isSupportPlanDocu))) {
                    this.reportForm.templateId = this.defaultReportTemplateId && !this.isSupportPlanDocu ? this.defaultReportTemplateId : this.reportForm.templates[0].id;
                    this.getReportTemplateItems(this.reportForm.templateId, true);
                }
            }
            /////////////// SAVELOGIC ///////////////
            /**
             * Validate the current documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            allowSaveAnyway() {
                var _a;
                const hasGlobalErrors = this.validation.errors.length === 0;
                const hasCarerErrors = !((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length) ||
                    this.carerActivityForm.every(x => x.errors.length === 0);
                return hasGlobalErrors && hasCarerErrors;
            }
            /**
             * Runs web client validation; if doServerValidation is true, also calls the server (checkForWarningsAndErrors) and then afterSuccessfullValidationAction.
             * For reactive validation on data changes use scheduleWebClientValidation() instead. This method is used by the save flow only.
             */
            validateDocumentation(debounce = 1500, saveAnyway = false, doServerValidation = false, afterSuccessfullValidationAction = () => { }) {
                if (this.loading.save)
                    return;
                const exitValidation = () => {
                    this.loading.validate = this.isValidating;
                    this.$qui.scopeApply(this.$scope);
                };
                if (isNaN(this.timeForm.dateFrom.valueOf()) || isNaN(this.timeForm.dateTo.valueOf())) {
                    this.webClientValidation();
                    return;
                }
                this.normalizeDate(this.timeForm.dateFrom);
                this.normalizeDate(this.timeForm.dateTo);
                if (this.loading.requieredFields) {
                    setTimeout(() => { this.scheduleWebClientValidation(); }, 500);
                    return;
                }
                if (!doServerValidation) {
                    this.webClientValidation();
                    exitValidation();
                    return;
                }
                this.loading.validate = true;
                this.webClientValidation();
                const references = this.validationService.buildValidationReferences({ cases: this.cases, form: this.form });
                if (!references || references.length === 0) {
                    this.loading.validate = this.isValidating;
                    return;
                }
                const carer = this.validationService.buildValidationCarers({
                    carerActivityForm: this.carerActivityForm,
                    isGroup: this.isGroup,
                    isNewDocumentation: this.isNewDocumentation,
                    form: this.form,
                    activityForm: this.activityForm
                });
                if (!carer || carer.length === 0) {
                    exitValidation();
                    return;
                }
                setTimeout(() => {
                    var _a, _b, _c;
                    const validationObject = this.validationService.buildValidationObject({
                        timeForm: this.timeForm,
                        form: this.form,
                        formState: this.formState,
                        documentationIds: this.documentationIds,
                        ignoreConfigRoundInterval: this.ignoreConfigRoundInterval,
                        isNewDocumentation: this.isNewDocumentation,
                        isGroup: this.isGroup,
                        cases: this.cases,
                        references,
                        carer,
                        roundInterval: (_c = (_b = (_a = this.ui.documentationTimeForm.form[0]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.roundInterval) !== null && _c !== void 0 ? _c : 0,
                        generateGuid: () => this.$qui.generateGuid(),
                        hoursMinutesToDecimal: (h, m) => this.hoursMinutesToDecimal(h, m)
                    });
                    if (!validationObject) {
                        exitValidation();
                        return;
                    }
                    this.validationService.addDrivingCostsToValidation(validationObject, {
                        form: this.form,
                        convertHours: (h, m) => this.ui.convertHours(h, m),
                        addTimeToDate: (date, time) => this.$qui.addTimeToDate(date, time)
                    });
                    // failsafe to make absolutely sure to not validate with manual duration, when there is none
                    if (validationObject.hasManualDuration && !validationObject.manualDuration) {
                        validationObject.manualDuration = 0;
                    }
                    if (this.lastValidation) {
                        const last = JSON.parse(this.lastValidation);
                        const current = angular.copy(validationObject);
                        delete last.requestId;
                        delete current.requestId;
                        if (this.equal(last, current)) {
                            exitValidation();
                            return;
                        }
                    }
                    if (references.length === 0) {
                        exitValidation();
                        return;
                    }
                    this.lastValidation = JSON.stringify(validationObject);
                    this.isValidating = true;
                    this.validation.errors = [];
                    this.validation.warnings = [];
                    this.webClientValidation();
                    this.fachleistungService.checkForWarningsAndErrors([validationObject], false).then((data) => {
                        if (JSON.parse(this.lastValidation).requestId !== validationObject.requestId)
                            return;
                        this.isValidating = false;
                        this.validationService.processValidationResults(data, {
                            isGroup: this.isGroup,
                            isNewDocumentation: this.isNewDocumentation,
                            carerActivityForm: this.carerActivityForm,
                            validation: this.validation
                        }, (msg, mode, carerActForm) => this.addValidation(msg, mode, carerActForm));
                        this.removeValidation(this.lng.translate(21003033, "Die Leistung konnte nicht validiert werden."), "errors");
                        this.validationFailCounter = 0;
                        this.loading.validate = false;
                        afterSuccessfullValidationAction(saveAnyway);
                    }).catch(() => {
                        this.loading.validate = false;
                        this.validation.errors = [];
                        this.validation.warnings = [];
                        this.validation.errors.push(this.lng.translate(21003033, "Die Leistung konnte nicht validiert werden."));
                        this.isValidating = false;
                        if (this.validationFailCounter < 5)
                            setTimeout(() => {
                                this.scheduleWebClientValidation();
                                this.validationFailCounter++;
                            }, 2500);
                    }).finally(() => {
                        this.loading.validate = false;
                        this.$qui.scopeApply(this.$scope);
                    });
                }, debounce);
            }
            /**
             * Schedules web client validation with debounce. Use when relevant data (timeForm, form, reportForm, selectedCarerList, selectedMarkings, udfs, driving cost, etc.) changes.
             * Cancels any pending run and runs validation after WEB_CLIENT_VALIDATION_DEBOUNCE_MS.
             */
            scheduleWebClientValidation() {
                if (this.webClientValidationDebouncePromise) {
                    this.$timeout.cancel(this.webClientValidationDebouncePromise);
                    this.webClientValidationDebouncePromise = null;
                }
                this.webClientValidationDebouncePromise = this.$timeout(() => {
                    this.webClientValidation();
                    this.$qui.scopeApply(this.$scope);
                    this.webClientValidationDebouncePromise = null;
                }, FlsDocumentationController_1.WEB_CLIENT_VALIDATION_DEBOUNCE_MS);
            }
            /**
             * returns true if error
             * */
            webClientValidation() {
                const translate = (id, fallback) => this.lng.translate(id, fallback);
                return this.validationService.runWebClientValidation({
                    timeForm: this.timeForm,
                    form: this.form,
                    requiredFields: this.requiredFields,
                    resetHoursOnManualDuration: this.resetHoursOnManualDuration,
                    dateFromNotRequired: this.ui.documentationTimeForm.form[0].config.dateFromNotRequired,
                    selectedCarerList: this.selectedCarerList,
                    isGroup: this.isGroup,
                    isNewDocumentation: this.isNewDocumentation,
                    selectedMarkings: this.selectedMarkings,
                    isMarkingRequired: this.isMarkingRequired,
                    reportForm: this.reportForm,
                    allowEmptyReports: this.allowEmptyReports,
                    carerActivityForm: this.carerActivityForm,
                    activityForm: this.activityForm,
                    standardActivityAllowedIfRequired: this.standardActivityAllowedIfRequired,
                    validateEmptyDrivingCost: this.validateEmptyDrivingCost,
                    udfs: this.udfs
                }, {
                    addOrRemoveError: (err, add, carer) => this.addOrRemoveError(err, add, carer),
                    addOrRemoveWarning: (warning, add) => this.addOrRemoveWarning(warning, add),
                    hasPrevMonthLock: () => this.hasPrevMonthLock(),
                    hasReportEntryWithComment: () => this.isReportEntryCommented(this.reportForm.reports, false),
                    scopeApply: () => this.$qui.scopeApply(this.$scope),
                    translate,
                    mergeCarerValidationToGlobal: (actFormToCheck) => {
                        ['warnings', 'errors'].forEach(mode => {
                            actFormToCheck[mode].forEach(entry => this.addIfNotPresent(this.validation[mode], entry));
                        });
                    }
                });
            }
            checkTitle() {
                return this.validationService.checkTitle({ requiredFields: this.requiredFields, form: this.form }, (id, fallback) => this.lng.translate(id, fallback), (err, add) => this.addOrRemoveError(err, add));
            }
            addOrRemoveError(error, add, carerActForm = null) {
                if (add)
                    this.addValidation(error, "errors", carerActForm);
                else
                    this.removeValidation(error, "errors", carerActForm);
                return add;
            }
            addOrRemoveWarning(warning, add) {
                if (add)
                    this.addValidation(warning, "warnings");
                else
                    this.removeValidation(warning, "warnings");
            }
            addValidation(msg, mode, carerActForm = null) {
                if (!carerActForm || carerActForm[mode] === undefined) {
                    this.addIfNotPresent(this.validation[mode], msg);
                }
                else {
                    // error is already added globally
                    if (this.validation[mode].some(x => x === msg))
                        return;
                    if (!this.checkPresentForMoreCarers(msg, mode)) {
                        this.addIfNotPresent(carerActForm[mode], msg);
                    }
                    else {
                        this.addIfNotPresent(this.validation[mode], msg);
                        this.carerActivityForm.forEach(carerForm => {
                            this.removeValidation(msg, "errors", carerForm);
                        });
                    }
                }
            }
            addIfNotPresent(arr, str) {
                if (!arr.some(x => x === str))
                    arr.push(str);
            }
            checkPresentForMoreCarers(msg, mode) {
                var _a;
                return ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.filter(x => x[mode].some(y => y === msg)).length) > 1;
            }
            removeValidation(error, mode, carerActForm = null) {
                var _a, _b;
                const src = ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length) ? carerActForm !== null && carerActForm !== void 0 ? carerActForm : this.validation : this.validation;
                src[mode] = (_b = src[mode]) === null || _b === void 0 ? void 0 : _b.filter(x => x !== error);
            }
            /**
             * Strip html tags
             *
             * @private
             * @param {any} html
             * @returns {string}
             *
             * @memberof FlsDocumentationController
             */
            strip(html) {
                var _a, _b;
                if (!html)
                    return "";
                const textEl = document.createElement("div");
                textEl.innerHTML = html;
                return (_b = (_a = textEl.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
            }
            /**
             * Shows validation modal and either runs server validation (saveAnyway false) or saves directly (saveAnyway true).
             *
             * @private
             * @param {any} saveAnyway - When true, skip server validation and call saveDocumentationAction(true) directly.
             *
             * @memberof FlsDocumentationController
             */
            saveDocumentation(saveAnyway) {
                if (this.documentationSaveSucceeded) {
                    return;
                }
                this.flushReportEditor();
                $('#validationModal').modal('show');
                this.lastValidation = null;
                if (saveAnyway) {
                    this.webClientValidation();
                    this.saveDocumentationAction(true);
                }
                else {
                    this.validateDocumentation(0, false, true, this.saveDocumentationAction.bind(this));
                }
            }
            /**
             * Prepare the data to put / post the documentation
             *
             * @private
             * @param {any} saveAnyway
             *
             * @memberof FlsDocumentationController
             */
            saveDocumentationAction(saveAnyway) {
                if ((this.validation.warnings.length + this.validation.errors.length === 0) && (this.getWarningErrorsCount(true) + this.getWarningErrorsCount(false) === 0) || saveAnyway && !this.loading.validate) {
                    setTimeout(() => {
                        this.flushReportEditor();
                        const form = { ...this.form };
                        if (this.strip(this.emptyDescription).length > 0) {
                            form.description = this.emptyDescription;
                        }
                        form.flsCaseId = this.flsCaseIds[0];
                        if (!form.drivingCost)
                            form.drivingCost = [];
                        for (const element of form.drivingCost) {
                            if (!element.drivingDistance || isNaN(parseFloat(element.drivingDistance + '')))
                                element.drivingDistance = 0;
                            element.duration = this.ui.convertHours(element.hours, element.minutes >= 0 ? element.minutes : 0);
                            element.drivingCostType = element.isPrivate ? 0 : element.isCarPool ? 1 : 2;
                        }
                        form.workingHours = {
                            abrechenbarkeitId: form.workingHours.abrechenbarkeitId,
                            activityWvId: this.activityForm.activityWvId,
                            contactTypeWvId: this.activityForm.contactTypeWvId,
                            careTypeWvId: this.activityForm.careTypeWvId,
                            miscontactWvId: this.activityForm.isMiscontactEnabled ? this.activityForm.miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT
                        };
                        form.isManualDuration = this.timeForm.isManualDuration;
                        form.dateFrom = this.timeForm.dateFrom;
                        form.dateTo = this.timeForm.dateTo;
                        if (!this.userSettings.dateToEnabled) {
                            form.dateTo = new Date(form.dateFrom.getFullYear(), form.dateFrom.getMonth(), form.dateFrom.getDate(), form.dateTo.getHours(), form.dateTo.getMinutes(), form.dateTo.getSeconds());
                        }
                        if (this.isGroup) {
                            this.formatParticipants(form);
                            form.participantCount = this.participantsForm.participantCount;
                        }
                        form.reports = this.reportForm.reports;
                        //(<IFlsDocumentationCreate>this.form).isSupportPlanDocu = this.isSupportPlanDocu;
                        form.isSupportPlanDocu = this.isSupportPlanDocu;
                        form.isManualDuration = this.timeForm.isManualDuration;
                        if (form.isManualDuration) {
                            this.timeForm.durationInHours = form.durationInHours = this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes); // + unary operator, convert the var into number
                        }
                        form.reportTemplateId = this.reportForm.templateId;
                        form.isReportTemplateFix = this.isReportTemplateFix;
                        //Driving Cost
                        this.formatDrivingCost(form);
                        //remove driving cost if not allowed
                        if (!this.permissions.drivingCostModuleAccess)
                            delete form.drivingCost;
                        //ellaborative Warning
                        if (form.warning && this.elaborativeWarning) {
                            form.warningReasons = {};
                            for (const item in this.elaborativeWarningData) {
                                if (this.elaborativeWarningData[item].active)
                                    form.warningReasons[item] = this.elaborativeWarningData[item].comment;
                            }
                        }
                        document.body.scrollTop = document.documentElement.scrollTop = 0;
                        this.loading.save = true;
                        $('#validationModal').modal('hide');
                        if (this.formState === 'new') {
                            this.postDocumentation(form);
                        }
                        else {
                            this.putDocumentation(form);
                        }
                        this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
                    });
                }
            }
            /**
             * Updates an existing fls documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            putDocumentation(form) {
                //Special case when a docu with manual duration was opened, manual duration is foridden and time was not changed while editing
                if (this.timeForm.durationInHours !== this.diffHours(form.dateFrom, form.dateTo) && this.timeForm.isManualDuration && !this.timeForm.isManualTimeAllowed) {
                    form.isManualDuration = true;
                    form.durationInHours = this.timeForm.durationInHours;
                }
                this.fachleistungService.putFlsDocumentation(form.id, form, this.carersIds[0], this.modifiyDescription && this.shouldDisable()).then(() => {
                    this.isSaving = false;
                    this.ui.notify(this.ui.successNote);
                    if ($('.modal-backdrop') !== null)
                        $('.modal-backdrop').remove();
                    this.leaveState();
                }).catch((e) => this.handleSaveActionError(e));
            }
            diffHours(dt2, dt1) {
                let diff = (dt2.getTime() - dt1.getTime()) / 1000;
                diff /= (60 * 60);
                return Math.abs(Math.round(diff));
            }
            /**
             * Post an existing fls documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            postDocumentation(form) {
                //Carers
                for (const element of this.carerActivityForm) {
                    if (element.errors.length === 0) {
                        const addCarer = {
                            carerId: element.carerId,
                            workingHours: {
                                activityWvId: element.activityWvId,
                                contactTypeWvId: element.contactTypeWvId,
                                careTypeWvId: element.careTypeWvId,
                                miscontactWvId: element.isMiscontactEnabled ? element.miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT
                            }
                        };
                        form.carers.push(addCarer);
                    }
                }
                //remove duplicates
                form.carers = form.carers.slice().reverse().filter((v, i, a) => a.findIndex(t => (t.carerId === v.carerId)) === i).reverse();
                // make sure only ´currently selected carers remain
                form.carers = form.carers.filter((x) => this.selectedCarerList.indexOf(x.carerId) >= 0);
                // create array of docus, one for each case (new multiple cases)
                const dataArray = [];
                for (let i = 0; i < this.flsCaseIds.length; i++) {
                    const data = jQuery.extend(true, {}, form);
                    data.flsCaseId = this.flsCaseIds[i];
                    data.documentationId = this.documentationIds[i];
                    for (const element of this.cases) {
                        if (element.objectId === this.flsCaseIds[i]) {
                            data.referencedPersonId = element.clientObjectId;
                            if (element.isAccountableRuleFix)
                                data.workingHours.abrechenbarkeitId = element.defaultAccountableRuleId;
                        }
                    }
                    data.additionalFls = this.additionalFls;
                    data.additionalFlsText = this.additionalFls ? this.additionalFlsText : "";
                    dataArray.push(data);
                }
                this.fachleistungService.postFlsDocumentation(dataArray, this.timeForm.distributeHours, null, dataArray.length > 1 || dataArray[0].carers.length > 1).then(() => {
                    this.isSaving = false;
                    this.loading.save = false;
                    this.documentationSaveSucceeded = true;
                    this.$qui.scopeApply(this.$scope);
                    this.ui.notify(this.ui.successNote);
                    this.continueDialog();
                }).catch((e) => this.handleSaveActionError(e));
            }
            /**
             * Format the form particiants, by group members
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            formatParticipants(form = this.form) {
                var _a, _b;
                form.participants = new Array();
                let participants = (_a = this.participantsForm.participantEmployees) !== null && _a !== void 0 ? _a : [];
                if (!this.group.onlyNumberOfParticipants)
                    participants = participants.concat((_b = this.participantsForm.participants) !== null && _b !== void 0 ? _b : []);
                if (participants && participants.length > 0) {
                    for (const part of participants) {
                        const members = this.group.data.members.filter(x => x.objectId === part);
                        if (members.length > 0) {
                            form.participants.push({
                                objectId: members[0].objectId,
                                isEmployee: members[0].objectType === QMC.Common.Constants.OBJECTTYPE_EMPLOYEE,
                                isGroupMember: true
                            });
                        }
                        else {
                            form.participants.push({
                                objectId: part,
                                isEmployee: false,
                                isGroupMember: false
                            });
                        }
                    }
                }
                if (!this.group.onlyNumberOfParticipants) {
                    if (form.participants)
                        form.participantCount = form.participants.length;
                    else
                        form.participantCount = 0;
                }
            }
            /**
             * Checks if the user should be asked if the docu should be signed right away, and asks him.
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            continueDialog() {
                $('#afterSaveActionModal').modal('show');
            }
            leaveState() {
                QMC.Common.personalLocalStorage.removeItem(this.cachingObjectName);
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {
                        plannedDocumentationId: this.$stateParams.plannedDocumentationId,
                        flsCaseIds: this.$stateParams.flsCaseIds
                    }
                }));
                if ($('.modal-backdrop') !== null)
                    $('.modal-backdrop').remove();
                this.$timeout(() => {
                    this.$state.go(this.returnState.state, this.returnState.params);
                });
            }
            afterSaveAction(action) {
                $('#afterSaveActionModal').modal('hide');
                // saving completed, clear cache
                QMC.Common.personalLocalStorage.removeItem(this.cachingObjectName);
                switch (action) {
                    case 'sign':
                        this.$state.go("signaturedetail", { id: this.documentationIds[0] });
                        break;
                    case 'more':
                        this.$state.go('documentationnew', { flsCaseIds: this.flsCaseIds, plannedDocumentationId: undefined }, { reload: true });
                        break;
                    default:
                        this.leaveState();
                        break;
                }
            }
            /**
             * get the smart action client list
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            getSmartActionClientAndEmployeeList() {
                const lngTagClient = this.lng.translate(21002000, 'Klient');
                const lngTagEmployee = this.lng.translate(20000235, 'Mitarbeiter');
                this.clientService.getClientAndEmployeeList('', true).then((data) => {
                    this.smartClientAndEmployeeList = data.map(function (obj) {
                        let textValue = '';
                        if (obj.objectType === 140000) {
                            textValue = obj.displayTitle + ' (' + lngTagClient + ')';
                        }
                        else {
                            textValue = obj.displayTitle + ' (' + lngTagEmployee + ')';
                        }
                        return {
                            text: textValue,
                            value: obj.objectId,
                            objType: obj.objectType
                        };
                    });
                });
            }
            handleSaveActionError(e) {
                if (e.data)
                    e = e.data;
                this.saveErrors = [];
                // first try to gather all error msgs in one handy array
                if (typeof e === 'string')
                    this.saveErrors.push(e);
                if (typeof e === 'object') {
                    if (e.fieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.fieldErrors);
                    if (e.FieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.FieldErrors);
                    if (e.fieldError)
                        this.saveErrors.push(e.fieldError);
                    if (e.FieldError)
                        this.saveErrors.push(e.FieldError);
                    if (e.globalErrors)
                        this.saveErrors = this.saveErrors.concat(e.globalErrors);
                    if (e.GlobalErrors)
                        this.saveErrors = this.saveErrors.concat(e.GlobalErrors);
                    if (e.globalError)
                        this.saveErrors.push(e.globalError);
                    if (e.GlobalError)
                        this.saveErrors.push(e.GlobalError);
                }
                if (Array.isArray(e)) {
                    this.saveErrors = this.saveErrors.concat(e);
                }
                $('#saveErrorModal').modal('show');
            }
            afterErrorAction(action) {
                $('#saveErrorModal').modal('hide');
                // saving completed, clear cache
                switch (action) {
                    case 'reloadCacheless':
                        QMC.Common.personalLocalStorage.removeItem(this.cachingObjectName);
                        this.$state.reload();
                        break;
                    case 'reload':
                        this.$state.reload();
                        break;
                    case 'case':
                        this.$state.go('case');
                        break;
                    case 'docu':
                        this.$state.go('documentation');
                        break;
                    default:
                        this.leaveState();
                        break;
                }
            }
            /////////////// DELETE DOCUMENTATION ///////////////
            /**
             * delete the current fls documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            deleteDocumentation() {
                console.log("delete docu", this.deleteDocu);
                this.fachleistungService.deleteFlsDocumentation(this.deleteDocu.deleteItemId, { deleteReasonText: this.deleteDocu.deleteText, deleteReasonWvId: this.deleteDocu.deleteReason }).then(() => {
                    this.ui.notify(this.ui.deleteNote);
                    this.leaveState();
                }).catch((e) => this.handleSaveActionError(e));
            }
            /**
             * open die delete modal, prepare the data.
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            openDeleteDokuModal() {
                this.deleteDocu.deleteItemId = this.form.objectId;
                if (this.isReportEntryCommented(this.reportForm.reports)) {
                    QMC.Common.Utilities.confirm(this.promptOptiondsDeleteDokuWithText, (response) => {
                        if (response) {
                            $('#deleteDokuModal').modal('toggle');
                        }
                    }, '#promptDeleteDokuWithText');
                }
                else {
                    $('#deleteDokuModal').modal('toggle');
                }
            }
            /////////////// ADDITIONAL COST ///////////////
            /**
             * add an additional cost
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            addAdditionalCost() {
                const wv = this.getCurrentGenericWvList();
                const newCost = {
                    id: null,
                    objectId: null,
                    additionalCostTypeId: wv.additionalCostTypeWv.length > 0 ? wv.additionalCostTypeWv[0].objectId : null,
                    accountabilityTypeId: wv.additionalCostAccountabilityTypeWv.length > 0 ? wv.additionalCostAccountabilityTypeWv[0].objectId : null,
                    amount: 0,
                    quantity: 1,
                    durration: 0,
                    comment: "",
                    additionalCostType: null,
                    accountabilityType: null,
                };
                if (!this.form.additionalCost)
                    this.form.additionalCost = [];
                if (wv.additionalCostAccountabilityTypeWv.length >= 2)
                    newCost.accountabilityTypeId = wv.additionalCostAccountabilityTypeWv[1].objectId;
                this.form.additionalCost.push(newCost);
            }
            /**
             * remove an additional cost
             *
             * @private
             * @param {(IFlsDocumentationAdditionalCostCreate | IFlsDocumentationAdditionalCostUpdate)} cost
             *
             * @memberof FlsDocumentationController
             */
            deleteAdditionalCost(cost) {
                this.form.additionalCost = this.form.additionalCost.filter(function (obj) {
                    return obj !== cost;
                });
            }
            initDcData() {
                if (this.isDcInit)
                    return;
                this.isDcInit = true;
                this.loading.ressources = true;
                this.fachleistungService.getVehicleList().then((dataV) => {
                    this.vehiclesMap = dataV.map(x => ({ value: x.objectId, text: x.displayTitle }));
                    this.vehiclesMap.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: '' });
                    this.loading.ressources = false;
                });
                this.clientService.getAllAddresses().then((data) => {
                    this.drivingAddresses = this.ui.formatAddresses(data);
                });
            }
            /**
             * add a driving cost
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            addDrivingCost(cost, isLoadingTheDocumentation) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (!isLoadingTheDocumentation) {
                    if (this.loading.wv || !this.requiredFields || !this.requiredFields.drivingCost) {
                        if (this.flsDocDestroyed)
                            return;
                        if (this.addDrivingCostRetryTimeoutId != null) {
                            clearTimeout(this.addDrivingCostRetryTimeoutId);
                            this.addDrivingCostRetryTimeoutId = null;
                        }
                        this.addDrivingCostRetryTimeoutId = setTimeout(() => {
                            this.addDrivingCostRetryTimeoutId = null;
                            if (this.flsDocDestroyed)
                                return;
                            this.addDrivingCost(cost, false);
                        }, 500);
                        return;
                    }
                    if (!cost) {
                        cost = {
                            hours: 0,
                            minutes: 0,
                            duration: 0,
                            drivingDistance: 0,
                            drivingCostCategoryId: this.getdrivingCostCategoryId(),
                            chargingMethodId: "ecaf4b95-1915-4370-9d9a-b5842bd797cb",
                            departure: "",
                            destination: "",
                            vehicle: "",
                            dateOfArrival: (_a = this.form.dateFrom) !== null && _a !== void 0 ? _a : this.timeForm.dateFrom,
                            dateOfDeparture: (_b = this.form.dateFrom) !== null && _b !== void 0 ? _b : this.timeForm.dateFrom,
                            timeOfArrival: (_c = this.form.dateFrom) !== null && _c !== void 0 ? _c : this.timeForm.dateFrom,
                            timeOfDeparture: (_d = this.form.dateFrom) !== null && _d !== void 0 ? _d : this.timeForm.dateFrom,
                            isPrivate: false,
                            isCarPool: false,
                            synchronize: true,
                            mileageArrival: 0,
                            mileageDeparture: 0,
                            comment: "",
                            drivingCostType: 0,
                            isBlocked: false,
                            isDrivingValidating: false,
                            objectId: QMC.Common.Constants.GUID_EMPTY,
                            vehicleId: QMC.Common.Constants.GUID_EMPTY,
                            watcherList: null
                        };
                    }
                    else {
                        cost.isPrivate = cost.isPrivate || (!cost.vehicleId && !cost.dateOfDeparture);
                        cost.isCarPool = cost.isCarPool || (!cost.isPrivate && !cost.dateOfDeparture);
                        cost.synchronize = true;
                    }
                    (_e = cost.dateOfArrival) === null || _e === void 0 ? void 0 : _e.setSeconds(0);
                    (_f = cost.dateOfDeparture) === null || _f === void 0 ? void 0 : _f.setSeconds(0);
                    (_g = cost.timeOfArrival) === null || _g === void 0 ? void 0 : _g.setSeconds(0);
                    (_h = cost.timeOfDeparture) === null || _h === void 0 ? void 0 : _h.setSeconds(0);
                    if (!this.form.drivingCost) {
                        this.form.drivingCost = [];
                    }
                    else if (this.form.drivingCost.length === 1 && !this.form.drivingCost[0].objectId) {
                        //the drivingCost array is filled when creating the forms, documentationDrivingCostsForm, is not a real IFlsDocumentationDrivingCost
                        //since we are filling the array with the right one here, remove the one created automatically
                        this.disposeWatchers(this.form.drivingCost[0].watcherList);
                        this.form.drivingCost = [];
                    }
                    const index = this.form.drivingCost.length;
                    this.form.drivingCost.push(cost);
                    this.addEventValidations(index);
                }
                else {
                    for (let i = 0; i < this.form.drivingCost.length; i++) {
                        this.addEventValidations(i);
                    }
                }
            }
            getdrivingCostCategoryId() {
                const wv = this.getCurrentGenericWvList();
                if (wv && wv.drivingCostCategoryWv.length > 0) {
                    return this.requiredFields.drivingCost.drivingCostCategoryId && wv.drivingCostCategoryWv.length === 1 ? wv.drivingCostCategoryWv[0].objectId : null;
                }
                else {
                    const wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return this.requiredFields.drivingCost.drivingCostCategoryId && wvCarerList.drivingCostCategoryWv && wvCarerList.drivingCostCategoryWv.length === 1 ? wvCarerList.drivingCostCategoryWv[0].objectId : null;
                }
            }
            /**
             * Compare two values by JSON stringification
             * @private
             */
            equal(a, b) {
                return JSON.stringify(a) === JSON.stringify(b);
            }
            addEventValidations(index) {
                const isDcTabActive = () => {
                    return $('#drivingCostTab').hasClass('active');
                };
                this.$timeout(() => {
                    this.createTypeAhead();
                    if (!this.form.drivingCost[index])
                        return;
                    this.disposeWatchers(this.form.drivingCost[index].watcherList);
                    this.form.drivingCost[index].watcherList = [];
                    this.form.drivingCost[index].watcherList.push(this.$scope.$watch('vm.form.drivingCost[' + index + ']', (newValue, oldValue) => {
                        const currentCost = this.form.drivingCost[index];
                        if (!newValue || !oldValue || !currentCost || this.loading.save || !isDcTabActive() || this.equal(newValue, oldValue))
                            return;
                        if (newValue.isPrivate && !this.equal(newValue.isPrivate, oldValue.isPrivate)) {
                            currentCost.isCarPool = false;
                            this.initCostArrDep(currentCost);
                            this.$qui.scopeApply(this.$scope);
                        }
                        if (newValue.isCarPool && !this.equal(newValue.isCarPool, oldValue.isCarPool)) {
                            currentCost.isPrivate = false;
                            this.initCostArrDep(currentCost);
                            this.$qui.scopeApply(this.$scope);
                            this.scheduleWebClientValidation();
                        }
                        if (newValue && !this.equal(newValue.drivingDistance, oldValue.drivingDistance)) {
                            this.updateMileage(currentCost, 'distance');
                            this.scheduleWebClientValidation();
                        }
                        if (!this.equal(newValue.mileageDeparture, oldValue.mileageDeparture))
                            this.updateMileage(currentCost, 'departure');
                        if (!this.equal(newValue.mileageArrival, oldValue.mileageArrival))
                            this.updateMileage(currentCost, 'arrival');
                        if (!this.equal(newValue.timeOfArrival, oldValue.timeOfArrival))
                            this.validateDrivingTime(currentCost, 'timeOfArrival');
                        if (!this.equal(newValue.timeOfDeparture, oldValue.timeOfDeparture))
                            this.validateDrivingTime(currentCost, 'timeOfDeparture');
                        if (!this.equal(newValue.dateOfArrival, oldValue.dateOfArrival))
                            this.validateDrivingTime(currentCost, 'arrival');
                        if (!this.equal(newValue.dateOfDeparture, oldValue.dateOfDeparture))
                            this.validateDrivingTime(currentCost, 'departure');
                        if (!this.equal(newValue.hours, oldValue.hours)) {
                            currentCost.hours = this.cleanInputNumber(currentCost.hours);
                            this.scheduleWebClientValidation();
                            this.validateDrivingTime(currentCost, 'costHoursMinutes');
                        }
                        if (!this.equal(newValue.minutes, oldValue.minutes)) {
                            let minutes = this.cleanInputNumber(currentCost.minutes);
                            let hours = this.cleanInputNumber(currentCost.hours);
                            while (minutes >= 60) {
                                minutes = minutes - 60;
                                hours = hours + 1;
                            }
                            currentCost.minutes = minutes;
                            currentCost.hours = hours;
                            this.scheduleWebClientValidation();
                            this.validateDrivingTime(currentCost, 'costHoursMinutes');
                        }
                        if (!this.equal(newValue.synchronize, oldValue.synchronize) && newValue.synchronize) {
                            if (!currentCost.mileageDeparture)
                                currentCost.mileageDeparture = 0;
                            if (!currentCost.mileageArrival)
                                currentCost.mileageArrival = 0;
                            if (!currentCost.drivingDistance)
                                currentCost.drivingDistance = 0;
                            currentCost.drivingDistance = currentCost.mileageArrival - currentCost.mileageDeparture;
                            this.validateDrivingTime(currentCost, 'departure');
                        }
                        if (!this.equal(newValue.drivingCostCategoryId, oldValue.drivingCostCategoryId))
                            this.scheduleWebClientValidation();
                    }, true));
                });
            }
            /**
             * remove a driving cost
             *
             * @private
             * @param {(IFlsDocumentationAdditionalCostCreate | IFlsDocumentationAdditionalCostUpdate)} cost
             *
             * @memberof FlsDocumentationController
             */
            deleteDrivingCost(cost) {
                this.disposeWatchers(cost.watcherList);
                this.form.drivingCost = this.form.drivingCost.filter(function (obj) {
                    return obj !== cost;
                });
                this.scheduleWebClientValidation();
            }
            disposeWatchers(watchers) {
                if (!(watchers === null || watchers === void 0 ? void 0 : watchers.length))
                    return;
                for (const unwatch of watchers) {
                    if (typeof unwatch === 'function')
                        unwatch();
                }
                watchers.length = 0;
            }
            cleanupRuntimeBindings() {
                var _a, _b, _c;
                this.flsDocDestroyed = true;
                if (this.webClientValidationDebouncePromise) {
                    this.$timeout.cancel(this.webClientValidationDebouncePromise);
                    this.webClientValidationDebouncePromise = null;
                }
                if (this.cacheWatcherInitTimeoutId != null) {
                    clearTimeout(this.cacheWatcherInitTimeoutId);
                    this.cacheWatcherInitTimeoutId = null;
                }
                if (this.postLoadInitTimeoutId != null) {
                    clearTimeout(this.postLoadInitTimeoutId);
                    this.postLoadInitTimeoutId = null;
                }
                if (this.loadDocuWaiterTimeoutId != null) {
                    clearTimeout(this.loadDocuWaiterTimeoutId);
                    this.loadDocuWaiterTimeoutId = null;
                }
                if (this.initFormEventsTimeoutId != null) {
                    clearTimeout(this.initFormEventsTimeoutId);
                    this.initFormEventsTimeoutId = null;
                }
                if (this.addDrivingCostRetryTimeoutId != null) {
                    clearTimeout(this.addDrivingCostRetryTimeoutId);
                    this.addDrivingCostRetryTimeoutId = null;
                }
                if (this.udfsDeepWatchUnwatch) {
                    this.udfsDeepWatchUnwatch();
                    this.udfsDeepWatchUnwatch = null;
                }
                if (this.drivingCostOverlapListUnwatch) {
                    this.drivingCostOverlapListUnwatch();
                    this.drivingCostOverlapListUnwatch = null;
                }
                this.disposeCacheFormWatchers();
                if ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length) {
                    for (const form of this.carerActivityForm) {
                        this.disposeWatchers(form.watcherList);
                    }
                }
                if ((_c = (_b = this.form) === null || _b === void 0 ? void 0 : _b.drivingCost) === null || _c === void 0 ? void 0 : _c.length) {
                    for (const cost of this.form.drivingCost) {
                        this.disposeWatchers(cost.watcherList);
                    }
                }
                const floatingMenuButton = $('ul.floating-menu>li>button.floating-menu-open');
                if (floatingMenuButton === null || floatingMenuButton === void 0 ? void 0 : floatingMenuButton.off) {
                    floatingMenuButton.off(`click${FlsDocumentationController_1.JQUERY_EVENT_NS}`);
                }
                const documentElement = $(document);
                if (documentElement === null || documentElement === void 0 ? void 0 : documentElement.off) {
                    documentElement.off(`scroll${FlsDocumentationController_1.JQUERY_EVENT_NS}`);
                }
            }
            getMileage(cost, index) {
                if (cost.isPrivate || !cost.vehicleId || cost.vehicleId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                let sum = 0;
                let first = true;
                for (let i = 0; i < index; i++) {
                    if (this.form.drivingCost[i].vehicleId === cost.vehicleId) {
                        first = false;
                        sum = sum + parseInt(this.form.drivingCost[i].mileageArrival + "");
                    }
                }
                if (!first) {
                    cost.mileageDeparture = sum;
                    cost.mileageArrival = sum + parseInt(cost.drivingDistance + "");
                    return;
                }
                this.fachleistungService.getMileage(cost.vehicleId).then((mileage) => {
                    console.log(mileage);
                    cost.mileageDeparture = mileage;
                    cost.mileageArrival = parseInt(mileage + "") + parseInt(cost.drivingDistance + "");
                });
            }
            updateMileage(cost, origin) {
                if (!cost.mileageDeparture)
                    cost.mileageDeparture = 0;
                if (!cost.mileageArrival)
                    cost.mileageArrival = 0;
                if (!cost.drivingDistance)
                    cost.drivingDistance = 0;
                if ((!cost.synchronize && cost.drivingDistance === 0) || (!cost.isCarPool && !cost.isPrivate))
                    return;
                switch (origin) {
                    case 'arrival':
                        const current = parseFloat(cost.mileageArrival.toString());
                        setTimeout(() => {
                            if (current !== parseFloat(cost.mileageArrival.toString()))
                                return;
                            if (parseFloat(cost.mileageArrival.toString()) < parseFloat(cost.mileageDeparture.toString()))
                                cost.mileageArrival = parseInt(cost.mileageDeparture.toString());
                            const calcDist = parseFloat(cost.mileageArrival.toString()) - parseFloat(cost.mileageDeparture.toString());
                            if (calcDist !== Math.round(cost.drivingDistance))
                                cost.drivingDistance = calcDist;
                            this.$qui.scopeApply(this.$scope);
                        }, 500);
                        break;
                    case 'departure':
                        cost.mileageArrival = Math.round(parseFloat(cost.mileageDeparture.toString()) + parseFloat(cost.drivingDistance.toString()));
                        break;
                    case 'distance':
                        cost.mileageArrival = Math.round(parseFloat(cost.mileageDeparture.toString()) + parseFloat(cost.drivingDistance.toString()));
                        break;
                }
                this.$qui.scopeApply(this.$scope);
            }
            validateDrivingTime(cost, origin) {
                if (cost.isDrivingValidating || this.lastDrivingCost === JSON.stringify(cost) || this.isSaving)
                    return;
                if (!$('#drivingCostTab').hasClass('active') || origin === 'costHoursMinutes')
                    return; //only redo validation if the tab is active or base data is changed
                cost.isDrivingValidating = true;
                const init = (!cost.dateOfDeparture || !cost.dateOfArrival || !cost.timeOfDeparture || !cost.timeOfArrival) && (cost.isPrivate || cost.isCarPool);
                if (!cost.dateOfDeparture)
                    cost.dateOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                if (!cost.dateOfArrival)
                    cost.dateOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                if (!cost.timeOfDeparture)
                    cost.timeOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                if (!cost.timeOfArrival)
                    cost.timeOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                // make sure all values are consistent and complete
                cost.timeOfArrival = this.$qui.addTimeToDate(cost.dateOfArrival, cost.timeOfArrival);
                cost.timeOfDeparture = this.$qui.addTimeToDate(cost.dateOfDeparture, cost.timeOfDeparture);
                cost.dateOfArrival = angular.copy(cost.timeOfArrival);
                cost.dateOfDeparture = angular.copy(cost.timeOfDeparture);
                if (init) {
                    const hourMinutes = this.getHoursMinutesForDrivingCost(cost);
                    cost.hours = hourMinutes[0];
                    cost.minutes = hourMinutes[1];
                }
                let hours = 0;
                let minutes = 0;
                switch (origin) {
                    case 'costHoursMinutes':
                        if ((cost.hours === 0 && cost.hours === null) || (cost.minutes === 0 && cost.minutes === null)) {
                            cost.dateOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                            cost.dateOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                            cost.timeOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                            cost.timeOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                            break;
                        }
                        hours = cost.hours;
                        minutes = (cost.minutes === 0 || cost.minutes === null) ? 0 : cost.minutes;
                        const arrivalTime = this.$qui.createDateFromString(cost.dateOfDeparture);
                        arrivalTime.setHours(arrivalTime.getHours() + hours);
                        if (!cost.synchronize || (cost.synchronize && !(cost.isCarPool || cost.isPrivate))) {
                        }
                        else {
                            if (this.$qui.createDateFromString(arrivalTime.getTime() + minutes * 60000) !== cost.timeOfArrival) {
                                let newDateTime = this.$qui.addTimeToDate(cost.dateOfDeparture, cost.timeOfDeparture);
                                newDateTime = moment(newDateTime).add(hours, 'hours').add(minutes, 'minutes').toDate();
                                cost.dateOfArrival = newDateTime;
                                cost.timeOfArrival = newDateTime;
                            }
                        }
                        break;
                    case 'arrival':
                    case 'timeOfArrival':
                        if (cost.timeOfArrival < cost.timeOfDeparture) {
                            cost.timeOfDeparture = angular.copy(cost.timeOfArrival);
                            cost.dateOfDeparture = angular.copy(cost.dateOfArrival);
                        }
                        [hours, minutes] = this.getHoursMinutesForDrivingCost(cost);
                        if (!cost.synchronize || (cost.synchronize && !(cost.isCarPool || cost.isPrivate))) {
                        }
                        else {
                            cost.hours = hours;
                            cost.minutes = minutes;
                        }
                        break;
                    case 'departure':
                    case 'timeOfDeparture':
                        if (cost.timeOfArrival < cost.timeOfDeparture) {
                            cost.timeOfArrival = angular.copy(cost.timeOfDeparture);
                            cost.dateOfArrival = angular.copy(cost.dateOfDeparture);
                        }
                        [hours, minutes] = this.getHoursMinutesForDrivingCost(cost);
                        if (!cost.synchronize || (cost.synchronize && !(cost.isCarPool || cost.isPrivate))) {
                        }
                        else {
                            cost.hours = hours;
                            cost.minutes = minutes;
                        }
                        break;
                }
                cost.isDrivingValidating = false;
                this.lastDrivingCost = JSON.stringify(cost);
                this.$qui.scopeApply(this.$scope);
            }
            getHoursMinutesForDrivingCost(cost) {
                let hours = 0;
                let minutes = 0;
                [hours, minutes] = this.$qui.convertDec((cost.timeOfArrival.getTime() - cost.timeOfDeparture.getTime()) / 36e5);
                if (minutes === 60) {
                    minutes = 0;
                    hours = hours + 1;
                }
                return [hours, minutes];
            }
            initCostArrDep(cost) {
                if (!isNaN(this.timeForm.dateFrom.valueOf())) {
                    cost.dateOfDeparture = angular.copy(this.timeForm.dateFrom);
                    cost.timeOfDeparture = angular.copy(this.timeForm.dateFrom);
                    cost.dateOfArrival = angular.copy(this.timeForm.dateFrom);
                    cost.dateOfArrival = angular.copy(this.timeForm.dateFrom);
                }
                this.validateDrivingTime(cost, 'costHoursMinutes');
                this.updateMileage(cost, 'departure');
            }
            formatDrivingCost(form = this.form) {
                for (const element of form.drivingCost) {
                    if (!element.isPrivate)
                        delete element.vehicle;
                    if (!element.isCarPool)
                        delete element.vehicleId;
                    if (!element.isPrivate && !element.isCarPool) {
                        delete element.dateOfDeparture;
                        delete element.dateOfArrival;
                        delete element.timeOfArrival;
                        delete element.timeOfDeparture;
                    }
                    else {
                        element.timeOfArrival.setSeconds(0, 0);
                        element.timeOfDeparture.setSeconds(0, 0);
                        element.dateOfArrival.setSeconds(0, 0);
                        element.dateOfDeparture.setSeconds(0, 0);
                    }
                    delete element.isCarPool;
                    delete element.isPrivate;
                    delete element.synchronize;
                    element.duration = this.hoursMinutesToDecimal(element.hours, element.minutes);
                }
            }
            openElaborativeWarningModal() {
                if (this.elaborativeWarning) {
                    $('#elaborativeWarningModal').modal('show');
                }
            }
            getInternalElobaritveWarningObject(data) {
                const result = {};
                for (const id in data) {
                    result[id] = { active: true, comment: data[id] };
                }
                return result;
            }
        };
        FlsDocumentationController.JQUERY_EVENT_NS = '.flsDocumentation';
        FlsDocumentationController.WEB_CLIENT_VALIDATION_DEBOUNCE_MS = 150;
        FlsDocumentationController = FlsDocumentationController_1 = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsDocumentationController'),
            QMC.Inject('$location', 'FachleistungService', 'FlsDocumentationCacheService', 'FlsDocumentationValidationService', '$qui', '$stateParams', '$scope', '$state', '$timeout', 'KlientService', 'UserService', 'QmcLanguageService', 'QmcPermissionService', 'QmcMarkItemService', 'QmcUdfService')
        ], FlsDocumentationController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsDocumentationEndingConfirmationController = class FlsDocumentationEndingConfirmationController {
            constructor(flsService, $scope, $qui, userService, permissionService, lng) {
                this.flsService = flsService;
                this.$scope = $scope;
                this.$qui = $qui;
                this.userService = userService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.isLoading = false;
                this.setDate = null;
                this.cases = [];
                this.init();
                $qui.init($qui.getSectionColor("/fls/documentation"), () => {
                    //$qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                this.promptOptions = {
                    title: "Fachleistungen",
                    yesNo: true,
                    icon: "qm-icon-clock",
                    text: this.lng.translate(20016137, 'Erfassungsende wirklich setzen? Änderungen werden bis zu dem angegebenen Datum nicht mehr möglich sein.')
                };
            }
            init() {
                this.isLoading = true;
                this.cases = [];
                this.userService.getUserSettings(['FACHLSDOKU.ERFASSUNGENDE.AKTIV'], false).then((data) => {
                    this.permissionService.getPermissionsByObjectTypes([230017]).then((dataPerm) => {
                        this.newPermission = data[0].value.toLowerCase() === "true" && dataPerm[0].new;
                        this.modifyPermission = data[0].value.toLowerCase() === "true" && dataPerm[0].modify;
                        this.deletePermission = data[0].value.toLowerCase() === "true" && dataPerm[0].delete;
                        this.viewPermission = data[0].value.toLowerCase() === "true" && dataPerm[0].view;
                        if (this.viewPermission)
                            this.flsService.getDocEndingConfirmList().then((data) => {
                                // Format lock date for date input fields
                                for (let i = 0; i < data.length; i++) {
                                    if (data[i].lockDate !== null) {
                                        data[i].lockDate = this.$qui.createDateFromString(data[i].lockDate.toString());
                                        data[i].dbLockDate = this.$qui.createDateFromString(data[i].lockDate.toString());
                                    }
                                    else {
                                        data[i].lockDate = null;
                                        data[i].dbLockDate = null;
                                    }
                                }
                                this.cases = data;
                                this.isLoading = false;
                            });
                    });
                });
            }
            setLockDates() {
                for (let i = 0; i < this.cases.length; i++) {
                    if (this.cases[i].dbLockDate !== null) {
                        if (this.cases[i].dbLockDate < this.setDate) {
                            this.cases[i].lockDate = this.setDate;
                        }
                        else {
                            this.cases[i].lockDate = this.cases[i].dbLockDate;
                        }
                    }
                    else {
                        this.cases[i].lockDate = this.setDate;
                    }
                }
            }
            saveLockDates() {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        for (const cCase of this.cases) {
                            if (!cCase.lockDate)
                                continue;
                            if (!cCase.id && cCase.id !== QMC.Common.Constants.GUID_EMPTY) {
                                this.postLockDate(cCase);
                            }
                            else {
                                this.putLockDate(cCase);
                            }
                        }
                        setTimeout(() => {
                            this.init();
                        }, 500);
                    }
                });
            }
            postLockDate(flsCase) {
                this.flsService.postDocEndingConfirm(flsCase);
            }
            putLockDate(flsCase) {
                this.flsService.putDocEndingConfirm(flsCase.id, flsCase);
            }
        };
        FlsDocumentationEndingConfirmationController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsDocumentationEndingConfirmationController'),
            QMC.Inject('FachleistungService', '$scope', '$qui', 'UserService', 'QmcPermissionService', 'QmcLanguageService')
        ], FlsDocumentationEndingConfirmationController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsPlanedRawListController = class FlsPlanedRawListController {
            constructor($location, flsService, $qui, $scope, $stateParams, $state, userService) {
                this.$location = $location;
                this.flsService = flsService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.ui = new Fachleistung.UserInterface();
                this.loading = true;
                this.createRawTable = null;
                this.createPlanedTable = null;
                this.allPlannedDocus = [];
                this.onlyOwn = true;
                $qui.init($qui.getSectionColor("/fls/documentation"), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {}
                }));
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                // Get days to the past to get pled/raw docus for
                this.userService.getUserSettings(["FLS.PLANEDRAWDAYS"]).then((data) => {
                    var days = parseInt(data[0].value);
                    if (isNaN(days) || days === null || days === undefined)
                        days = QMC.Common.UserSettingConstantsAndDefaults.PLANEDRAWDAYS;
                    this.userService.getUserSettings(["FLS.PLANEDDAYSFUTURE"]).then((data) => {
                        var daysFuture = parseInt(data[0].value);
                        if (isNaN(daysFuture) || daysFuture === null || daysFuture === undefined)
                            daysFuture = QMC.Common.UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE;
                        this.GetPlanedAndRawDocumentations(days, daysFuture);
                    });
                });
                this.cards = false;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                $scope.$watch('vm.onlyOwn', () => {
                    this.updatePlannedTable();
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            writeFlsObjectToLocalStorage(data) {
                console.log("storage", data);
                var flsObject = data;
                var cacheObject = {
                    dateFrom: data.dateFrom,
                    timeFrom: data.dateFrom,
                    dateTo: data.dateTo,
                    timeTo: data.dateTo,
                    flsCaseId: data.flsCaseId,
                    description: data.description,
                    activity: data.activityTypeId,
                    careType: data.careTypeId,
                    contactType: data.contactTypeId,
                    miscontact: data.miscontactId,
                    carerId: data.carerId
                };
                QMC.Common.personalLocalStorage.setItem('flsObject', JSON.stringify(cacheObject));
                window.location.hash = "#/fls/documentation/new/" + cacheObject.flsCaseId + "?plannedDocumentationId=" + data.objectId;
            }
            updatePlannedTable() {
                if (this.onlyOwn)
                    this.ui.planedDocuTable.data = this.allPlannedDocus.filter(x => x.carerId === $('#session').data().personId);
                else
                    this.ui.planedDocuTable.data = this.allPlannedDocus;
                if (this.createPlanedTable)
                    this.createPlanedTable();
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
            * GetPlanedDocumentations
            * @description Gets all planed but not docuemented documentations in the past x days.
            */
            GetPlanedAndRawDocumentations(days, daysFuture) {
                this.flsService.getPlannedDocumentations(days, daysFuture).then((data) => {
                    this.allPlannedDocus = data;
                    this.plannedDocusForMeCount = data.filter(x => x.carerId === $('#session').data().personId).length;
                    this.updatePlannedTable();
                });
                this.flsService.getRawDocumentations(days).then((data) => {
                    this.ui.rawDocuTable.data = data;
                    if (this.createRawTable)
                        this.createRawTable();
                });
                this.loading = false;
            }
        };
        FlsPlanedRawListController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsPlanedRawListController'),
            QMC.Inject('$location', 'FachleistungService', '$qui', '$scope', '$stateParams', '$state', 'UserService')
        ], FlsPlanedRawListController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsWeekplannerListController = class FlsWeekplannerListController {
            constructor($location, fachleistungsService, $qui, terminService, aznService, $scope, $state, $timeout, lng, permissionService, userService, $stateParams) {
                this.fachleistungsService = fachleistungsService;
                this.$qui = $qui;
                this.terminService = terminService;
                this.aznService = aznService;
                this.$scope = $scope;
                this.$state = $state;
                this.$timeout = $timeout;
                this.lng = lng;
                this.userService = userService;
                this.$stateParams = $stateParams;
                this.typeFlsDocumentation = 'FlsDocumentation';
                this.typeAppointment = 'Appointment';
                this.typeAzn = 'AZN';
                this.dragMode = this.typeFlsDocumentation;
                this.formState = 'new';
                this.validation = {
                    errors: [],
                    warnings: [],
                    type: this.typeFlsDocumentation
                };
                // loading
                this.wvLoading = false;
                this.copyLoading = false;
                this.calendarLoading = false;
                this.validationLoading = false;
                this.caseLoading = false;
                // calender data
                this.caseFilterObject = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.caseFilter = '';
                this.aznList = [];
                this.eventList = [];
                this.ui = new Fachleistung.UserInterface();
                this.colorFlsDocumentation = '#333333';
                this.colorPlannedFlsDocumentation = '#3F51B5';
                this.colorAzn = '#FE9700';
                this.colorPlannedAzn = '#876c4c';
                this.colorAppointment = '#4CAF50';
                // permissions
                this.permissions = {
                    fls: { new: false, modify: false, delete: false },
                    azn: { new: false, modify: false, delete: false }
                };
                // Case pagination
                this.currentPage = 0;
                this.pageSize = 7;
                this.numberOfPages = 0;
                // AZNTypes pagination
                this.aznCurrentPage = 0;
                this.aznPageSize = 10;
                this.aznNumberOfPages = 0;
                this.showWeekends = false;
                this.showHoliday = false;
                this.showVacation = true;
                this.showPublicHoliday = true;
                this.eventLength = 60;
                this.showUnplannableCases = false;
                this.slotDuration = 30;
                this.getFutureCases = false;
                this.getPastCases = false;
                this.selectedPerson = QMC.Common.personalLocalStorage.getItem('weekplanner:lastSelectedPerson') ? QMC.Common.personalLocalStorage.getItem('weekplanner:lastSelectedPerson') : $("#session").data().personId;
                this.loadingAllCases = false;
                this.formFirstInit = true;
                this.lastFlsValidationRequestId = '';
                this.firstLoad = true;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    setTimeout(this.events, 300);
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                this.showWeekends = QMC.Common.personalLocalStorage.getItem('weekplanner:showWeeks') === 'true';
                const keys = [];
                keys.push("FLS.WEEKPLANNER.SHOWHOLIDAY");
                keys.push("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES");
                keys.push("FLS.WEEKPLANNER_INCLUDE_PAST_CASES");
                keys.push("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH");
                keys.push('CALENDAR.SLOTDURATION');
                keys.push('WEEKPLANNER.SHOWUNPLANNABLECASES');
                keys.push("FLS.WEEKPLANNER.SHOWVACATION");
                keys.push("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY");
                keys.push(QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY);
                this.userService.getUserSettings(keys).then((data) => {
                    var _a, _b, _c;
                    this.showHoliday = data[0].value === "" ? this.showHoliday : data[0].value.toLowerCase() === "true";
                    this.getFutureCases = data[1].value === "" ? this.getFutureCases : data[1].value.toLowerCase() === "true";
                    this.getPastCases = data[2].value === "" ? this.getPastCases : data[2].value.toLowerCase() === "true";
                    this.eventLength = data[3].value === "" ? this.eventLength : parseInt(data[3].value);
                    this.slotDuration = data[4].value && data[4].value.length > 0 ? parseInt(data[4].value) : this.slotDuration;
                    this.showUnplannableCases = ((_a = data[5].value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
                    this.showVacation = data[6].value === "" ? this.showVacation : ((_b = data[6].value) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'true';
                    this.showPublicHoliday = data[7].value === "" ? this.showPublicHoliday : ((_c = data[7].value) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true';
                    this.caseFilterObject = data[8].value === '' ? this.caseFilterObject : JSON.parse(data[8].value);
                    this.getWv();
                });
                this.promptOptions = {
                    title: "Wochenplanung",
                    yesNo: true,
                    icon: "",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.fachleistungsService.getAllPossibleCarer().then((data) => {
                    data.sort((a, b) => (a.displayTitle.toLocaleLowerCase() > b.displayTitle.toLocaleLowerCase()) ? 1 : ((b.displayTitle.toLocaleLowerCase() > a.displayTitle.toLocaleLowerCase()) ? -1 : 0));
                    this.possibleCarer = data;
                    this.possibleCarerMap = data.map(x => ({ text: this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber), value: x.objectId }));
                    this.$scope.$watch('vm.selectedPerson', (newVal, oldVal) => {
                        if (newVal !== oldVal) {
                            this.copyCandidates = [];
                            this.resetCalendar();
                            this.getCases();
                            QMC.Common.personalLocalStorage.setItem('weekplanner:lastSelectedPerson', this.selectedPerson);
                        }
                    });
                    this.$scope.$watch('vm.form.carerId', (newVal, oldVal) => {
                        if (newVal !== oldVal) {
                            this.selectedPerson = newVal;
                            this.getAllCases();
                        }
                    });
                    if (this.possibleCarer.filter(x => x.objectId === QMC.Common.personalLocalStorage.getItem('weekplanner:lastSelectedPerson')).length === 0)
                        QMC.Common.personalLocalStorage.setItem('weekplanner:lastSelectedPerson', this.selectedPerson);
                    if (!this.possibleCarer.some(x => x.objectId === this.selectedPerson))
                        this.selectedPerson = $("#session").data().personId;
                    this.getAllCases();
                    this.getCases();
                    this.$scope.$watch('vm.caseFilterObject.onlyCurrentCases', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        this.toggleShowCurrentOnly();
                    });
                });
                //ObjectType: FlsZeitplanungSoll
                permissionService.getPermissionsByObjectType(230007).then((data) => {
                    this.permissions.fls.delete = data[0].delete && data[0].moduleAccess;
                    this.permissions.fls.new = data[0].new && data[0].moduleAccess;
                    this.permissions.fls.modify = data[0].modify && data[0].moduleAccess;
                    // check only for view permission
                    if (data[0].view && data[0].moduleAccess) {
                        this.dragMode = this.typeFlsDocumentation;
                    }
                    else {
                        this.dragMode = "NoPlanningAllowed";
                    }
                    this.setNewButton();
                });
                permissionService.getPermissionsByObjectType(411010).then((data) => {
                    this.permissions.azn.delete = data[0].new;
                    this.permissions.azn.new = data[0].new;
                    this.permissions.azn.modify = data[0].new;
                    // set the dragMode to typeAZN only when the dragMode is not arleady set to typeFlsDocumentation, check only for view permission
                    if (data[0].view && data[0].moduleAccess) {
                        this.dragMode = this.dragMode === this.typeFlsDocumentation ? this.typeFlsDocumentation : this.typeAzn;
                    }
                    else {
                        this.dragMode = this.dragMode === this.typeFlsDocumentation ? this.typeFlsDocumentation : "NoPlanningAllowed";
                    }
                    this.setNewButton();
                });
                this.getWv();
                this.getAznWv();
            }
            /******************* Misc *******************/
            getCaseList() {
                var _a;
                //this.$timeout(this.filterEvents);
                return (_a = this.cases) !== null && _a !== void 0 ? _a : [];
            }
            getAllCases() {
                const request = JSON.stringify({
                    carerId: this.selectedPerson
                });
                if (this.lastAllCaseRequest === request)
                    return;
                this.lastAllCaseRequest = request;
                this.allCases = [];
                this.allCasesMap = [];
                this.loadingAllCases = true;
                this.fachleistungsService.getCasesList(QMC.Common.Constants.GUID_EMPTY, false, this.selectedPerson).then((data) => {
                    if (!this.getFutureCases) {
                        data = data.filter(item => moment(item.dateFrom).toDate() <= new Date());
                    }
                    if (!this.getPastCases) {
                        data = data.filter(item => !item.dateTo || moment(item.dateTo).endOf("day").toDate() >= new Date());
                    }
                    this.allCases = data;
                    data.forEach(x => x.displayTitle = this.$qui.createCaseDisplayObject(x).text);
                    this.allCasesMap = data.map(x => this.$qui.createCaseDisplayObject(x));
                    this.loadingAllCases = false;
                });
            }
            handleFilterChange() {
                if (this.caseFilter.length > 0) {
                    this.currentPage = 0;
                }
                this.numberOfPages = Math.ceil(this.getCaseList().length / this.pageSize);
            }
            events() {
                if (!this.$scope)
                    return;
                this.handleFilterChange();
                this.$scope.$watch('vm.caseFilter', (newVal, oldVal) => {
                    if (newVal !== oldVal)
                        this.filterEvents();
                });
                this.$scope.$watch('vm.showWeekends', (newVal, oldVal) => {
                    QMC.Common.personalLocalStorage.setItem('weekplanner:showWeeks', String(newVal));
                    if (newVal !== oldVal)
                        this.$state.reload();
                });
                setTimeout(() => {
                    this.filterEvents();
                    this.buildPlanner();
                }, 500);
                this.$scope.$watch('vm.aznForm', (newVal, oldVal) => {
                    if (this.dragMode !== this.typeAzn || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.checkPlausibilityAzn();
                }, true);
                this.$scope.$watch('vm.isAznFormValid', (newVal, oldVal) => {
                    if (this.dragMode !== this.typeFlsDocumentation || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.checkPlausibilityAzn();
                });
                this.$scope.$watch('vm.flsForm', (newVal, oldVal) => {
                    if (this.dragMode !== this.typeFlsDocumentation || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.checkPlausibilityFls();
                }, true);
                this.$scope.$watch('vm.isFlsFormValid', (newVal, oldVal) => {
                    if (this.dragMode !== this.typeFlsDocumentation || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.checkPlausibilityFls();
                });
                this.$scope.$watch('vm.dragMode', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    if (newVal === this.typeAzn)
                        this.checkPlausibilityAzn();
                    else if (newVal === this.typeFlsDocumentation)
                        this.checkPlausibilityFls();
                });
            }
            setNewButton() {
                if (this.dragMode === this.typeFlsDocumentation) {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = this.permissions.fls.new ? 'unset' : 'hidden');
                }
                else if (this.dragMode === this.typeAzn) {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = this.permissions.azn.new ? 'unset' : 'hidden');
                }
                else {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                }
            }
            async getCases() {
                const request = JSON.stringify({
                    carerFilter: this.caseFilterObject.carerTypeFilterId,
                    carerId: this.selectedPerson,
                    onlyCurrent: this.caseFilterObject.onlyCurrentCases,
                    showUnplannableCases: this.showUnplannableCases
                });
                if (this.lastCaseRequest === request || !this.caseFilterObject.carerTypeFilterId || this.caseFilterObject.carerTypeFilterId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.lastCaseRequest = request;
                this.caseLoading = true;
                this.cases = [];
                this.casesMap = [];
                await this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilterObject) }] });
                this.fachleistungsService.getCasesList(this.caseFilterObject.carerTypeFilterId, this.caseFilterObject.onlyCurrentCases, this.selectedPerson, this.showUnplannableCases).then((data) => {
                    if (!this.getFutureCases) {
                        data = data.filter(item => moment(item.dateFrom).toDate() <= moment().endOf('day').toDate());
                    }
                    if (!this.getPastCases) {
                        data = data.filter(item => !item.dateTo || moment(item.dateTo).toDate() >= moment().startOf('day').toDate());
                    }
                    this.casesMap = this.cases.map(x => this.$qui.createCaseDisplayObject(x));
                    data.forEach(x => x.displayTitle = this.$qui.createCaseDisplayObject(x).text);
                    this.cases = data;
                    setTimeout(() => {
                        this.$qui.anonAvatar();
                        this.$qui.scopeApply(this.$scope);
                    }, 500);
                    this.caseLoading = false;
                    this.events();
                });
            }
            getWv() {
                this.fachleistungsService.getFlsCaseWv().then((data) => {
                    this.flsCaseWv = data;
                    // Set carer type filter from local storage, or if not present, from the first wv item
                    if (!this.flsCaseWv.carerTypeWv.some(x => x.objectId === this.caseFilterObject.carerTypeFilterId))
                        this.caseFilterObject.carerTypeFilterId = this.flsCaseWv.carerTypeWv[0].id;
                    this.getCases();
                });
            }
            getDateOnlyString(date) {
                return moment(date).format("YYYY-MM-DD");
            }
            getEvents(view) {
                if (this.dontGetDates) {
                    this.dontGetDates = false;
                    return;
                }
                if (view) {
                    QMC.Common.personalLocalStorage.setItem('calendarView', view.name);
                }
                if (this.firstLoad && this.$stateParams.startDay) {
                    this.firstLoad = false;
                    $('#weekplannerCalendar').fullCalendar('gotoDate', this.$stateParams.startDay);
                }
                this.$state.go('.', {
                    startDay: this.getDateOnlyString(this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start)),
                    view: $('#weekplannerCalendar').fullCalendar('getView').name
                });
                // calendar is not yet updated, that would mess up everything thats going to follow => bail out
                if (this.getDateOnlyString(this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start)) !== this.getDateOnlyString(moment(this.$state.params.startDay).toDate())) {
                    setTimeout(() => { this.getEvents(view); }, 50);
                    return;
                }
                const localEvents = [];
                this.eventList = [];
                this.setViewDates();
                $('#weekplannerCalendar').fullCalendar('removeEvents');
                $("#filterCheck").attr("disabled", "true");
                $(".squaredThree label").css("opacity", "0.4").css("cursor", "not-allowed");
                this.copyCandidates = [];
                this.deleteItems = [];
                this.calendarLoading = true;
                this.getWeekPlanning().then((weekData) => {
                    this.addToEventlist(weekData, localEvents);
                    this.getAppointmentList().then((appointmentData) => {
                        this.addToEventlist(appointmentData, localEvents);
                        this.getArbeitszeitnachweis().then((arbeitszeitnachweisData) => {
                            this.addToEventlist(arbeitszeitnachweisData, localEvents);
                            this.terminService.getHolidaysSpecific($('#weekplannerCalendar').fullCalendar('getDate').year(), this.showPublicHoliday, this.showVacation).then((holidays) => {
                                this.addToEventlist(this.createHolidayCalendarEntry(holidays), localEvents);
                                this.eventList = localEvents;
                                this.renderCalendar();
                                this.calendarLoading = false;
                                const calView = $('#weekplannerCalendar').fullCalendar('getView');
                                const start = calView.intervalStart.startOf('day');
                                let end = calView.intervalEnd.subtract(1, 'days').endOf('day');
                                if (!this.showWeekends)
                                    end = end.subtract(2, 'days');
                                let allDay = false;
                                for (const event of this.eventList) {
                                    if (event.allDay && (start.toString().slice(0, 24) === event.start.toString().slice(0, 24) || moment(event.start).isBetween(start, end) || (moment(start).isSameOrBefore(event.end) && moment(event.start).isSameOrBefore(end)))) {
                                        allDay = true;
                                        break;
                                    }
                                }
                                this.dontGetDates = true;
                                $('#weekplannerCalendar').fullCalendar('option', 'allDaySlot', allDay);
                            });
                        });
                    });
                });
            }
            createHolidayCalendarEntry(holidays) {
                for (const holiday of holidays) {
                    holiday.allDay = true;
                    holiday.title = holiday.caption;
                    holiday.editable = false;
                    holiday.color = "#DBDBDB";
                    holiday.start = moment(holiday.dateFrom);
                    holiday.end = moment(holiday.dateTo);
                }
                return holidays;
            }
            getAppointmentList() {
                const appointmentTypes = [];
                appointmentTypes.push(401000);
                if (this.showHoliday) {
                    appointmentTypes.push(411003); //holidays
                    appointmentTypes.push(411004); //sick days
                }
                // send appointment without userId, those always getting for current.
                return this.terminService.getAppointmentList(this.selectedPerson, this.viewDateFrom, this.viewDateTo, appointmentTypes).then((data) => {
                    const dataArray = [];
                    let setColor = true;
                    for (const element of data) {
                        const tempEvent = this.ui.createCalendarEvent(element);
                        tempEvent.editable = false;
                        if (setColor) {
                            setColor = false;
                            $("#appointmentColor").css("color", tempEvent.color);
                        }
                        dataArray.push(tempEvent);
                    }
                    return dataArray;
                });
            }
            openNewForm() {
                var _a;
                if (this.formFirstInit) {
                    this.formFirstInit = false;
                    return;
                }
                ;
                this.aznForm = {
                    dateFrom: moment().startOf('hour').toDate(),
                    dateTo: moment().startOf('hour').add(this.eventLength, 'm').toDate(),
                    typeId: QMC.Common.Constants.GUID_EMPTY,
                    referencePersonId: ((_a = this.possibleCarer) === null || _a === void 0 ? void 0 : _a.some(x => x.objectId === $("#session").data().personId)) ? $("#session").data().personId : QMC.Common.Constants.GUID_EMPTY
                };
                this.setFlsForm(undefined, undefined, this.selectedPerson);
                this.formState = 'new';
                $('#weekplanner-entry').modal('show');
            }
            postForm() {
                switch (this.dragMode) {
                    case this.typeAzn:
                        this.saveNewAznPlanning();
                        break;
                    case this.typeFlsDocumentation:
                        this.saveNewFlsPlanning();
                        break;
                    default:
                        console.warn(`create not supported for dragMode ${this.dragMode}`);
                }
            }
            putForm() {
                switch (this.dragMode) {
                    case this.typeAzn:
                        this.updateAznPlanning();
                        break;
                    case this.typeFlsDocumentation:
                        this.updateFlsPlanning();
                        break;
                    default:
                        console.warn(`update not supported for dragMode ${this.dragMode}`);
                }
            }
            deleteForm() {
                switch (this.dragMode) {
                    case this.typeAzn:
                        this.deleteAznPlanning();
                        break;
                    case this.typeFlsDocumentation:
                        this.deleteFlsPlanning();
                        break;
                    default:
                        console.warn(`delete not supported for dragMode ${this.dragMode}`);
                }
            }
            createDocumentation(mode) {
                if (mode === this.typeFlsDocumentation) {
                    const cacheObject = {
                        dateFrom: this.flsForm.dateFrom,
                        timeFrom: this.flsForm.dateFrom,
                        dateTo: this.flsForm.dateTo,
                        timeTo: this.flsForm.dateTo,
                        flsCaseId: this.flsForm.flsCaseId,
                        description: this.flsForm.description,
                        activity: this.flsForm.activityTypeId,
                        careType: this.flsForm.careTypeId,
                        contactType: this.flsForm.contactTypeId,
                        miscontact: this.flsForm.miscontactId,
                        carerId: this.flsForm.carerId
                    };
                    QMC.Common.personalLocalStorage.setItem('flsObject', JSON.stringify(cacheObject));
                    this.$state.go('documentationnew', { plannedDocumentationId: this.flsForm.objectId, flsCaseIds: this.flsForm.flsCaseId }, { reload: true });
                }
                else if (mode === this.typeAzn) {
                    this.goToAznDetail(this.aznForm.objectId);
                }
            }
            /******************* FLS *******************/
            toggleShowCurrentOnly() {
                this.getCases();
                this.getAllCases();
            }
            async saveUnplannableSetting() {
                await this.userService.setUserSettings({ settings: [{ key: 'WEEKPLANNER.SHOWUNPLANNABLECASES', value: String(this.showUnplannableCases) }] });
            }
            checkPlausibilityFls(afterValidationAction, form) {
                this.$timeout(() => {
                    var _a;
                    form = form !== null && form !== void 0 ? form : this.flsForm;
                    if (!form)
                        return;
                    this.validation = {
                        errors: [],
                        warnings: [],
                        type: this.typeFlsDocumentation
                    };
                    if (!this.isFlsFormValid) {
                        this.validation.errors.push(this.lng.translate(20002061, 'Es wurden nicht alle Pflichtfelder ausgefüllt.'));
                    }
                    if (!this.flsForm.miscontactId || this.flsForm.miscontactId === QMC.Common.Constants.GUID_EMPTY) {
                        this.validation.errors.push(this.lng.translate(20016243, "Die Fehlkontaktart muss ausgewählt werden"));
                    }
                    if ((_a = this.validation.errors) === null || _a === void 0 ? void 0 : _a.length) {
                        if (afterValidationAction)
                            afterValidationAction();
                        this.validationLoading = false;
                        return;
                    }
                    // get current case
                    const currentCase = this.allCases.filter(x => form.flsCaseId === x.objectId)[0];
                    if (!currentCase) {
                        this.validation.errors = [this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                        if (afterValidationAction)
                            afterValidationAction();
                        this.validationLoading = false;
                        return;
                    }
                    this.validationLoading = true;
                    const validationObject = {
                        dateFrom: form.dateFrom,
                        dateTo: !form.dateTo ? moment(form.dateFrom).add(this.eventLength, 'minutes').toDate() : form.dateTo,
                        hasManualDuration: false,
                        documentationId: !form.objectId ? QMC.Common.Constants.GUID_EMPTY : form.documentationId,
                        references: [{ caseId: currentCase.objectId, referenceId: currentCase.clientObjectId, accountabilityId: currentCase.defaultAccountableRuleId }],
                        carer: [{
                                activityTypeId: form.activityTypeId,
                                contactTypeId: form.contactTypeId,
                                careTypeId: form.careTypeId,
                                miscontactId: form.miscontactId,
                                carerId: form.carerId
                            }],
                        manualDuration: 0,
                        requestId: this.$qui.generateGuid(),
                        ignoreConfigRoundInterval: false
                    };
                    const requestId = '_' + Math.random().toString(36).substring(2, 10);
                    this.lastFlsValidationRequestId = requestId;
                    this.fachleistungsService.checkForWarningsAndErrors([validationObject], true).then((data) => {
                        if (this.lastFlsValidationRequestId !== requestId)
                            return;
                        data.forEach(result => {
                            for (const key in result.validation) {
                                this.validation.errors = result.validation[key].errors;
                                this.validation.warnings = result.validation[key].warnings;
                            }
                        });
                        if (afterValidationAction)
                            afterValidationAction();
                        this.validationLoading = false;
                        this.$qui.scopeApply(this.$scope);
                    })
                        .catch((e) => {
                        this.validation.errors = [this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                        this.handleSaveActionError(e);
                        this.validationLoading = false;
                    });
                });
            }
            saveNewFlsPlanning() {
                this.calendarLoading = true;
                $("#weekplanner-entry").modal("hide");
                this.fachleistungsService.postWeekPlanningPlannedDoc([this.flsForm]).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                    this.resetCalendar();
                    this.calendarLoading = false;
                }).catch((e) => this.handleSaveActionError(e));
            }
            updateFlsPlanning(form) {
                form = form !== null && form !== void 0 ? form : this.flsForm;
                this.calendarLoading = true;
                $('#weekplanner-entry').modal('hide');
                this.fachleistungsService.putWeekPlanningPlannedDoc(form.documentationId, form).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                    this.resetCalendar();
                    this.calendarLoading = false;
                }).catch((e) => this.handleSaveActionError(e));
            }
            changeFlsEvent(id, dateFrom, dateTo, revertFunc) {
                var _a, _b;
                this.dragMode = 'none';
                const origPlanning = this.flsWeekPlanning.filter(x => x.objectId === id)[0];
                if (!(origPlanning === null || origPlanning === void 0 ? void 0 : origPlanning.flsCaseId))
                    return;
                const currentCase = this.cases.filter(x => origPlanning.flsCaseId === x.objectId)[0];
                if (!currentCase) {
                    this.$qui.notify({
                        message: this.lng.translate(20002066, "Der gewählte Fall steht nicht mehr zur Verfügung, die Planung kann nicht editiert oder dokumentiert werden!"),
                        title: this.lng.translate(20002015, "Fehler"),
                        icon: "qm-icon-delete",
                        status: "warning",
                        timer: 6000
                    });
                    revertFunc();
                    return;
                }
                ;
                this.calendarLoading = true;
                const form = {
                    ...origPlanning,
                    documentationId: id,
                    serviceTypeId: currentCase.serviceTypeId,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    description: (_a = origPlanning.description) !== null && _a !== void 0 ? _a : '',
                    flsCaseId: (_b = origPlanning.flsCaseId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY
                };
                this.setFlsForm(form);
                this.checkPlausibilityFls(() => {
                    if (!this.validation.errors.length && !this.validation.warnings.length) {
                        this.updateFlsPlanning(form);
                    }
                    else {
                        this.formState = 'edit';
                        this.dragMode = this.typeFlsDocumentation;
                        $('#weekplanner-entry').modal('show');
                        revertFunc();
                        this.calendarLoading = false;
                    }
                    this.dragMode = this.typeFlsDocumentation;
                }, form);
            }
            getWeekPlanning() {
                return this.fachleistungsService.getWeekPlanningList(this.selectedPerson, this.viewDateFrom, this.viewDateTo).then((data) => {
                    this.addFlsToCopyCandidates(data);
                    this.addFlsToDeleteItems(data);
                    this.flsWeekPlanning = data;
                    const dataArray = [];
                    for (const element of data) {
                        let color = this.colorFlsDocumentation;
                        let isDraggable = false;
                        if (element.isPlannedDocumentation) {
                            color = this.colorPlannedFlsDocumentation;
                            isDraggable = this.permissions.fls.modify;
                        }
                        dataArray.push({
                            id: element.objectId,
                            title: element.reportTitle,
                            objectId: element.flsCaseId,
                            start: this.$qui.createDateFromString(element.dateFrom),
                            end: this.$qui.createDateFromString(element.dateTo),
                            color: color,
                            editable: isDraggable,
                            type: this.typeFlsDocumentation,
                            description: element.description
                        });
                    }
                    this.buildPlanner();
                    this.renderCalendar();
                    return dataArray;
                });
            }
            deleteFlsPlanning() {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    $('#weekplanner-entry').modal('hide');
                    if (data)
                        this.fachleistungsService.deleteWeekPlanningPlannedDoc(this.flsForm.objectId).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.resetCalendar();
                        });
                });
            }
            addFlsToDeleteItems(items) {
                if (this.cases.length < 1) {
                    setTimeout(() => {
                        this.addFlsToDeleteItems(items);
                    }, 1000);
                }
                for (const item of items) {
                    let currentCase;
                    for (const cuCase of this.cases) {
                        if (cuCase.objectId == item.flsCaseId)
                            currentCase = cuCase;
                    }
                    if (!currentCase || !item.isPlannedDocumentation)
                        continue;
                    this.deleteItems.push({
                        dateFrom: this.$qui.createDateFromString(item.dateFrom),
                        dateTo: this.$qui.createDateFromString(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.reportTitle,
                        type: 230000,
                        flsCase: currentCase,
                        aznImputeId: undefined,
                        aznTypeId: undefined
                    });
                }
            }
            addFlsToCopyCandidates(items) {
                if (this.cases.length < 1) {
                    setTimeout(() => {
                        this.addFlsToCopyCandidates(items);
                    }, 1000);
                }
                for (const item of items) {
                    if (this.copyCandidates.some(x => x.objectId === item.objectId))
                        continue; //If the candidate already exists, skip it.
                    this.copyCandidates.push({
                        dateFrom: this.$qui.createDateFromString(item.dateFrom),
                        dateTo: this.$qui.createDateFromString(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.reportTitle,
                        type: 230000,
                        flsCase: null,
                        flsCaseId: item.flsCaseId,
                        aznImputeId: undefined,
                        aznTypeId: undefined,
                        activityForm: {
                            activityTypeId: item.activityTypeId,
                            careTypeId: item.careTypeId,
                            contactTypeId: item.contactTypeId,
                            miscontactId: item.miscontactId
                        }
                    });
                }
            }
            /******************* AZN *******************/
            checkPlausibilityAzn(afterValidationAction) {
                this.$timeout(() => {
                    var _a;
                    if (!this.aznForm)
                        return;
                    this.aznForm.referencePersonId = (_a = this.aznForm.referencePersonId) !== null && _a !== void 0 ? _a : this.selectedPerson;
                    this.validation = {
                        errors: [],
                        warnings: [],
                        type: this.typeAzn
                    };
                    if (!this.isAznFormValid) {
                        this.validation.errors.push(this.lng.translate(20002061, 'Es wurden nicht alle Pflichtfelder ausgefüllt.'));
                        if (afterValidationAction)
                            afterValidationAction();
                        this.validationLoading = false;
                        return;
                    }
                    if (moment(this.aznForm.dateTo).isBefore(this.aznForm.dateFrom)) {
                        this.validation.errors = [this.lng.translate(20002004, 'Das Startdatum ist größer als das Enddatum')];
                        return;
                    }
                    this.validationLoading = true;
                    this.aznService.checkForWarningsAndErrors({
                        idObjectAznw: this.aznForm.objectId,
                        dateFrom: moment(this.aznForm.dateFrom).format(),
                        dateTo: moment(this.aznForm.dateTo).format(),
                        performingPersonObjIdList: [this.aznForm.referencePersonId],
                        isPlanned: true,
                        activityId: QMC.Common.Constants.GUID_EMPTY,
                        imputeWvId: QMC.Common.Constants.GUID_EMPTY,
                        instituteId: QMC.Common.Constants.GUID_EMPTY
                    })
                        .then((data) => {
                        this.validation.errors = data.errors;
                        this.validation.warnings = data.warnings;
                        if (afterValidationAction)
                            afterValidationAction();
                        this.$qui.scopeApply(this.$scope);
                    })
                        .catch((e) => {
                        this.validation.errors = [this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                    })
                        .finally(() => this.validationLoading = false);
                });
            }
            saveNewAznPlanning() {
                this.calendarLoading = true;
                $("#weekplanner-entry").modal("hide");
                this.aznService.postAznWeekPlanning(this.aznForm).then((e) => {
                    this.$qui.notify(this.$qui.successNote);
                    this.resetCalendar();
                    this.calendarLoading = false;
                }).catch((e) => this.handleSaveActionError(e));
            }
            updateAznPlanning() {
                this.calendarLoading = true;
                $('#weekplanner-entry').modal('hide');
                this.aznService.putAznWeekPlanning(this.aznForm.objectId, this.aznForm).then((e) => {
                    this.$qui.notify(this.$qui.successNote);
                    this.resetCalendar();
                    this.calendarLoading = false;
                }).catch((e) => this.handleSaveActionError(e));
            }
            changeAznEvent(id, dateFrom, dateTo, revertFunc) {
                const azn = this.aznList.filter(x => x.objectId === id)[0];
                if (!azn)
                    return;
                this.calendarLoading = true;
                azn.dateFrom = dateFrom;
                azn.dateTo = dateTo;
                this.aznForm = azn;
                this.checkPlausibilityAzn(() => {
                    if (!this.validation.errors.length && !this.validation.warnings.length) {
                        this.updateAznPlanning();
                    }
                    else {
                        this.formState = 'edit';
                        this.dragMode = this.typeAzn;
                        $('#weekplanner-entry').modal('show');
                        revertFunc();
                        this.calendarLoading = false;
                    }
                });
                this.$qui.scopeApply(this.$scope);
            }
            openAznPlanning(data) {
                this.aznForm = {
                    dateFrom: data.start.toDate(),
                    dateTo: data.end.toDate(),
                    typeId: data.typeId,
                    objectId: data.id,
                    referencePersonId: this.selectedPerson
                };
                this.dragMode = this.typeAzn;
                $('#weekplanner-entry').modal('show');
                this.formState = 'edit';
                this.$qui.scopeApply(this.$scope);
            }
            deleteAznPlanning() {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    $('#weekplanner-entry').modal('hide');
                    if (data)
                        this.aznService.deleteAznWeekPlanning(this.aznForm.objectId).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.resetCalendar();
                        });
                });
            }
            getArbeitszeitnachweis() {
                return this.aznService.getAznWeekPlanning(this.viewDateFrom, this.viewDateTo, true, true, this.selectedPerson).then((data) => {
                    this.addAznToCopyCandidates(data);
                    this.addAznToDeleteItems(data);
                    const dataArray = [];
                    this.aznList = data;
                    for (const azn of data) {
                        dataArray.push({
                            id: azn.objectId,
                            title: azn.type,
                            objectId: azn.objectId,
                            start: this.$qui.createDateFromString(azn.dateFrom),
                            end: this.$qui.createDateFromString(azn.dateTo),
                            color: azn.isPlanned ? this.colorPlannedAzn : this.colorAzn,
                            editable: azn.isPlanned && azn.permissions.modify,
                            deletable: azn.isPlanned && azn.permissions.delete,
                            type: this.typeAzn,
                            isPlanned: azn.isPlanned,
                            typeId: azn.typeId
                        });
                    }
                    return dataArray;
                });
            }
            addAznToCopyCandidates(items) {
                for (const item of items) {
                    this.copyCandidates.push({
                        dateFrom: new Date(item.dateFrom),
                        dateTo: new Date(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.type,
                        type: 425000,
                        flsCase: undefined,
                        aznTypeId: item.typeId,
                        aznImputeId: item.imputeId,
                        flsCaseId: undefined,
                        activityForm: {
                        //Currently empty since planning activity is not supported for AZN at time of writing
                        }
                    });
                }
            }
            addAznToDeleteItems(items) {
                for (const item of items) {
                    if (!item.isPlanned)
                        continue;
                    this.deleteItems.push({
                        dateFrom: new Date(item.dateFrom),
                        dateTo: new Date(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.type,
                        type: 425000,
                        flsCase: undefined,
                        aznTypeId: item.typeId,
                        aznImputeId: item.imputeId
                    });
                }
            }
            getAznWv() {
                this.wvLoading = true;
                this.aznService.getArbeitzeitnachweisWv(undefined).then((data) => {
                    this.aznTypesMap = this.$qui.select(data.types.filter(x => x.objectId && x.objectId !== QMC.Common.Constants.GUID_EMPTY), { value: 'objectId', text: 'name' });
                    this.aznCurrentPage = 0;
                    this.aznNumberOfPages = Math.ceil(this.aznTypesMap.length / this.aznPageSize);
                });
            }
            goToAznDetail(id) {
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {
                        startDay: this.getDateOnlyString(this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start)),
                        view: $('#weekplannerCalendar').fullCalendar('getView').name
                    }
                }));
                this.$state.go('azndetail', { id: id }, { reload: true });
            }
            toggleDragMode() {
                if (this.dragMode == this.typeFlsDocumentation) {
                    this.dragMode = this.typeAzn;
                    this.validation.type = this.typeAzn;
                    this.setNewButton();
                }
                else if (this.dragMode == this.typeAzn) {
                    this.dragMode = this.typeFlsDocumentation;
                    this.validation.type = this.typeFlsDocumentation;
                    this.setNewButton();
                }
            }
            handleSaveActionError(e) {
                this.saveErrors = [];
                // first try to gather all error msgs in one handy array
                if (typeof e === 'string')
                    this.saveErrors.push(e);
                if (typeof e === 'object') {
                    if (e.fieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.fieldErrors);
                    if (e.FieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.FieldErrors);
                    if (e.fieldError)
                        this.saveErrors.push(e.fieldError);
                    if (e.FieldError)
                        this.saveErrors.push(e.FieldError);
                    if (e.globalErrors)
                        this.saveErrors = this.saveErrors.concat(e.globalErrors);
                    if (e.GlobalErrors)
                        this.saveErrors = this.saveErrors.concat(e.GlobalErrors);
                    if (e.globalError)
                        this.saveErrors.push(e.globalError);
                    if (e.GlobalError)
                        this.saveErrors.push(e.GlobalError);
                }
                if (Array.isArray(e)) {
                    this.saveErrors = this.saveErrors.concat(e);
                }
                $('#saveErrorModal').modal('show');
            }
            leaveState() {
                if ($('.modal-backdrop') !== null)
                    $('.modal-backdrop').remove();
                this.$timeout(() => {
                    this.$state.reload();
                });
            }
            afterErrorAction() {
                $('#saveErrorModal').modal('hide');
                // saving completed, clear cache
                this.$state.reload();
            }
            isDraggable(id) {
                return this.cases.some(x => x.objectId === id);
            }
            filterEvents() {
                setTimeout(() => {
                    $('.fc-event.dummy').each(function (i) {
                        $(this).data('event', {
                            title: $.trim($(this).text()),
                            id: $(this).data('id'),
                            flsCaseId: $(this).data('case'),
                            clientId: $(this).data('client'),
                            serviceTypeId: $(this).data('service'),
                            type: $(this).data('type'),
                            stick: true
                        });
                        $(this).draggable({
                            zIndex: 999,
                            revert: true,
                            revertDuration: 0
                        });
                    });
                }, 150);
            }
            async addDropEvent(obj, revertFunc) {
                this.calendarLoading = true;
                obj.carerId = this.selectedPerson;
                if (obj.type === this.typeFlsDocumentation && this.permissions.fls.new) {
                    this.flsForm = await this.setFlsForm(obj, obj.flsCaseId);
                    this.$timeout(() => {
                        this.checkPlausibilityFls(() => {
                            if (!this.validation.errors.length && !this.validation.warnings.length)
                                this.saveNewFlsPlanning();
                            else {
                                this.dragMode = this.typeFlsDocumentation;
                                $('#weekplanner-entry').modal('show');
                                this.calendarLoading = false;
                                revertFunc();
                            }
                        });
                    });
                }
                else if (obj.type === this.typeAzn && this.permissions.azn.new) {
                    this.aznForm = {
                        dateFrom: obj.dateFrom,
                        dateTo: moment(obj.dateFrom).add(this.eventLength, 'minutes').toDate(),
                        typeId: obj.id,
                        referencePersonId: obj.carerId
                    };
                    this.checkPlausibilityAzn(() => {
                        if (!this.validation.errors.length && !this.validation.warnings.length)
                            this.saveNewAznPlanning();
                        else {
                            this.dragMode = this.typeAzn;
                            $('#weekplanner-entry').modal('show');
                            this.calendarLoading = false;
                            revertFunc();
                        }
                    });
                }
                else {
                    $('#noPermissionDialog').modal('show');
                    this.calendarLoading = false;
                }
            }
            resetCalendar() {
                $(".modal-backdrop").remove();
                this.getEvents(null);
            }
            addToEventlist(arr, targetList = this.eventList) {
                for (const event of arr) {
                    targetList.push(event);
                }
            }
            renderCalendar() {
                $("#filterCheck").removeAttr("disabled");
                $(".squaredThree label").css("opacity", "1").css("cursor", "pointer");
                ;
                $('#weekplannerCalendar').fullCalendar('removeEvents');
                $('#weekplannerCalendar').fullCalendar('addEventSource', this.eventList);
            }
            setViewDates() {
                let dateFrom = $('#weekplannerCalendar').fullCalendar('getView').start;
                let dateTo = $('#weekplannerCalendar').fullCalendar('getView').end;
                if (typeof dateFrom !== "object")
                    dateFrom = new Date();
                if (typeof dateTo !== "object")
                    dateTo = new Date();
                this.viewDateFrom = moment(dateFrom).startOf('week').format();
                this.viewDateTo = moment(dateTo).endOf('week').add(1, 'day').format();
            }
            deviceDefault() {
                if (this.$stateParams.view && this.$stateParams.view.length > 0)
                    return this.$stateParams.view;
                if (QMC.Common.personalLocalStorage.getItem('calendarView') != null && QMC.Common.personalLocalStorage.getItem('calendarView') != 'month') {
                    return QMC.Common.personalLocalStorage.getItem('calendarView');
                }
                if (QMC.Common.Constants.IS_MOBILE)
                    return 'agendaDay';
                else
                    return 'agendaWeek';
            }
            getHeight() {
                if ($('body').hasClass('mobile'))
                    return 350;
                return null;
            }
            buildPlanner() {
                const vm = this;
                const allDayText = this.lng.translate(20018016, "Ganztägig");
                $('#weekplannerCalendar').fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    defaultTimedEventDuration: '00:30:00',
                    contentHeight: $(window).height() * 0.6,
                    defaultView: this.deviceDefault(),
                    timezone: 'local',
                    allDaySlot: false,
                    allDayText: allDayText,
                    slotLabelFormat: 'H:mm',
                    slotDuration: this.$qui.timeStringFromHours(this.slotDuration),
                    events: this.eventList,
                    firstDay: 1,
                    weekends: this.showWeekends,
                    monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                    monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                    dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                    dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                    weekNumbers: true,
                    weekNumberCalculation: (date) => { return moment(date).isoWeek(); },
                    views: {
                        month: {
                            titleFormat: 'MMMM yyyy',
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY',
                        },
                        day: {
                            titleFormat: 'dddd D.MM'
                        }
                    },
                    columnFormat: 'ddd D.M',
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'agendaWeek, agendaDay'
                    },
                    timeFormat: 'H:mm',
                    buttonText: {
                        today: this.lng.translate(20000126, 'Heute'),
                        month: this.lng.translate(20000115, 'Monat'),
                        week: this.lng.translate(20000114, 'Woche'),
                        day: this.lng.translate(20000041, 'Tag')
                    },
                    viewRender: (view) => {
                        this.getEvents(view);
                        this.filterEvents();
                    },
                    editable: this.permissions.fls.new,
                    droppable: true,
                    eventResize: (event, delta, revertFunc) => {
                        if (event.type == this.typeFlsDocumentation) {
                            this.changeFlsEvent(event.id, moment(event.start).toDate(), moment(event.end).toDate(), revertFunc);
                        }
                        else if (event.type == this.typeAzn) {
                            this.changeAznEvent(event.id, moment(event.start).toDate(), moment(event.end).toDate(), revertFunc);
                        }
                    },
                    eventRender: (event, element) => {
                        $(element).find(".fc-title").prepend(event.iconCode);
                    },
                    eventDrop: (event, delta, revertFunc) => {
                        if (event.type == this.typeFlsDocumentation && this.permissions.fls.new) {
                            this.changeFlsEvent(event.id, moment(event.start).toDate(), moment(event.end || event.start).toDate(), revertFunc);
                        }
                        else if (event.type == this.typeAzn && this.permissions.azn.new) {
                            this.changeAznEvent(event.id, moment(event.start).toDate(), moment(event.end || event.start).toDate(), revertFunc);
                        }
                        else {
                            $('#noPermissionDialog').modal('show');
                        }
                    },
                    eventReceive: function (data) {
                        var _a;
                        vm.formState = 'new';
                        const dropForm = {
                            dateFrom: moment(data.start).toDate(),
                            dateTo: moment(data.start).add(vm.eventLength, 'minutes').toDate(),
                            flsCaseId: data.flsCaseId,
                            serviceTypeId: data.serviceTypeId,
                            clientObjectId: data.clientId,
                            description: '',
                            type: (_a = data.type) !== null && _a !== void 0 ? _a : vm.getTypeFailSafe(data.id),
                            id: data.id
                        };
                        // eventReceive does not come with its own revertFunc, so we create oute own (delete events from calender where ids match)
                        vm.addDropEvent(dropForm, () => {
                            $('#weekplannerCalendar').fullCalendar('removeEvents', (event) => event.id === data.id);
                        });
                    },
                    eventClick: (e) => {
                        sessionStorage.setItem('weekplanner:lastSelectedPerson', this.selectedPerson);
                        if (e.type === this.typeFlsDocumentation) {
                            QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                                state: 'weekplanner',
                                params: {
                                    startDay: this.getDateOnlyString(this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start)),
                                    view: $('#weekplannerCalendar').fullCalendar('getView').name
                                }
                            }));
                            if (e.color === this.colorFlsDocumentation) {
                                this.$state.go('documentationdetail', { "id": e.id });
                            }
                            else if (e.color === this.colorPlannedFlsDocumentation) {
                                const fls = this.flsWeekPlanning.filter(x => e.id === x.objectId)[0];
                                if (!(fls === null || fls === void 0 ? void 0 : fls.isPlannedDocumentation))
                                    return;
                                const currentCase = this.allCases.filter(x => fls.flsCaseId === x.objectId)[0];
                                if (!currentCase) {
                                    this.$qui.notify({
                                        message: this.lng.translate(20002066, "Der gewählte Fall steht nicht mehr zur Verfügung, die Planung kann nicht editiert oder dokumentiert werden!"),
                                        title: this.lng.translate(20002067, "Editieren nicht möglich"),
                                        icon: "qm-icon-information",
                                        status: "info",
                                        timer: 8000
                                    });
                                    return;
                                }
                                this.formState = 'edit';
                                this.dragMode = this.typeFlsDocumentation;
                                this.setFlsForm({
                                    id: fls.id,
                                    objectId: fls.objectId,
                                    clientObjectId: fls.clientObjectId,
                                    dateFrom: moment(fls.dateFrom).toDate(),
                                    dateTo: moment(fls.dateTo).toDate(),
                                    description: fls.description,
                                    flsCaseId: fls.flsCaseId,
                                    serviceTypeId: currentCase.serviceTypeId,
                                    carerId: fls.carerId,
                                    documentationId: fls.objectId,
                                    activityTypeId: fls.activityTypeId,
                                    careTypeId: fls.careTypeId,
                                    contactTypeId: fls.contactTypeId,
                                    miscontactId: fls.miscontactId
                                });
                                $('#weekplanner-entry').modal('show');
                                this.$qui.scopeApply(this.$scope);
                            }
                        }
                        else if (e.type === this.typeAzn) {
                            if (!e.isPlanned) {
                                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE, JSON.stringify({
                                    state: this.$state.$current.name,
                                    params: {
                                        startDay: this.getDateOnlyString(this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start)),
                                        view: $('#weekplannerCalendar').fullCalendar('getView').name
                                    }
                                }));
                                this.$state.go('azndetail', { "id": e.id });
                            }
                            else {
                                this.openAznPlanning(e);
                            }
                        }
                        else if (e.isTypeAppointment) {
                            if (e.end == undefined)
                                e.end = e.start;
                            location.hash = "#/appointment/appointment/" +
                                (e.isRecurring ? e.mid : e.id) + "/" +
                                e.isRecurring + "/" + e.participantObjectId + "/" +
                                e.dateFrom + "/" +
                                ((e.start !== undefined) ? moment(e.start._d).toISOString() : 0) + "/" +
                                ((e.end !== undefined) ? moment(e.end._d).toISOString() : ((e.start !== undefined) ? moment(e.start._d).toISOString() : 0)) + "/" +
                                e.isRecurring + `/${e.permFlag}`;
                        }
                    },
                    dayClick: () => {
                        console.log('NOT IMPLEMENTED NOW');
                    }
                });
                this.filterEvents();
            }
            getTypeFailSafe(id) {
                if (this.cases.some(x => x.objectId === id))
                    return this.typeFlsDocumentation;
                if (this.aznTypesMap.some(x => x.value === id))
                    return this.typeAzn;
            }
        };
        FlsWeekplannerListController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsWeekplannerListController'),
            QMC.Inject('$location', 'FachleistungService', '$qui', 'TerminService', 'ArbeitszeitnachweisService', '$scope', '$state', '$timeout', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$stateParams')
        ], FlsWeekplannerListController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let QmWeekPlannerCopyDirective = class QmWeekPlannerCopyDirective {
            constructor($qui, $state, lng, permissionService, flsService, aznService) {
                this.$qui = $qui;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                this.aznService = aznService;
                this.restrict = 'E';
                this.templateUrl = './fls/WeekplannerCopyDirective';
                this.replace = true;
                this.scope = {
                    qmCalendarName: '@',
                    qmData: '=',
                    qmCarerId: '=' // = is a two way databinding
                };
                this.link = (scope) => {
                    //init
                    scope.cases = [];
                    this.flsService.getCasesList(null, true).then((cases) => {
                        scope.cases = cases;
                    });
                    if (!scope.qmCalendarName || scope.qmCalendarName == '')
                        scope.qmCalendarName = 'calendar';
                    scope.lng = this.lng;
                    scope.flsService = this.flsService;
                    scope.aznService = this.aznService;
                    scope.$qui = this.$qui;
                    scope.copySettings = {
                        copyMode: 'target',
                        futureWeekSelect: 0,
                        start: null,
                        end: null,
                        candidates: [],
                        plannings: [],
                        errors: [],
                        state: 'select',
                        selectAllCandidates: false,
                        selectAllPlannings: false,
                        isValidationFinished: false
                    };
                    scope.dayNames = scope.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(',');
                    scope.$watch('qmData', (newVal, oldVal) => {
                        if (newVal == oldVal)
                            return;
                        scope.createCandidates();
                    }, true);
                    scope.$watch('copySettings.isValidationFinished', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        if (newVal) {
                            scope.anythingOrAllSelected(scope.copySettings.plannings, true);
                            scope.copySettings.isValidationFinished = false;
                        }
                    }, true);
                    scope.createCandidates = () => {
                        var _a;
                        if (!scope.cases || scope.cases.length === 0)
                            setTimeout(() => { scope.createCandidates(); }, 500);
                        const start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        const end = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').end);
                        scope.copySettings.candidates = [];
                        for (const candidate of scope.qmData) {
                            if (candidate.dateFrom >= start && candidate.dateTo <= end) {
                                candidate.flsCase = (_a = scope.cases.filter(x => x.objectId === candidate.flsCaseId)[0]) !== null && _a !== void 0 ? _a : null;
                                if ((candidate.flsCase || candidate.type !== 230000) && !scope.copySettings.candidates.some(x => JSON.stringify(x) === JSON.stringify(candidate)))
                                    scope.copySettings.candidates.push(candidate);
                            }
                        }
                        scope.copySettings.candidates = scope.copySettings.candidates.sort((a, b) => { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                    };
                    scope.openCopyDialog = function () {
                        scope.loading = true;
                        $('#weekplanner-copy-modal').modal('show');
                        scope.copySettings.copyMode = 'target';
                        scope.copySettings.futureWeekSelect = 0;
                        scope.copySettings.plannings = [];
                        scope.copySettings.errors = [];
                        scope.copySettings.state = 'select';
                        //create target Week DropDown Values
                        const start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        scope.futureWeeks = [];
                        for (var i = 0; i < 53; i++) {
                            let temp = this.$qui.createDateFromString(start.toISOString());
                            temp = this.$qui.createDateFromString(temp.setDate(temp.getDate() + i * 7));
                            const weeks = weeksBetween(temp, new Date());
                            if (!(weeksBetween(temp, new Date()) > 1) || temp > new Date() || (temp < new Date() && weeks == 1))
                                if (i === 0)
                                    scope.futureWeeks.push({ value: i, text: i + 1 + " " + this.lng.translate(20000114, "Woche") });
                                else
                                    scope.futureWeeks.push({ value: i, text: i + 1 + " " + this.lng.translate(20000118, "Wochen") });
                        }
                        if (moment(start).week() < moment(new Date()).week()) {
                            const firstInArray = scope.futureWeeks[0];
                            scope.futureWeeks.unshift({ value: firstInArray.value - 1, text: this.lng.translate(20016187, "aktuelle Woche") });
                        }
                        scope.copySettings.futureWeekSelect = scope.futureWeeks[0].value;
                        scope.calculateCopyWeek();
                        // reset checkboxes
                        for (const candidate of scope.copySettings.candidates) {
                            candidate.isChecked = false;
                        }
                        $("#wpcm-toggleAllPlCb").prop("checked", false);
                        $("#wpcm-toggleAllCandCb").prop("checked", false);
                        scope.loading = false;
                    };
                    /////////////////// TimeFrame Helper Functions ///////////////////
                    scope.calculateCopyWeek = function () {
                        if (scope.copySettings.copyMode === 'target') {
                            const start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                            let temp = getNextWeek(start, 1);
                            scope.copySettings.start = this.$qui.createDateFromString(temp.setDate(temp.getDate() + (scope.copySettings.futureWeekSelect) * 7));
                            temp = this.$qui.createDateFromString(scope.copySettings.start.toDateString());
                            scope.copySettings.end = this.$qui.createDateFromString(temp.setDate(temp.getDate() + 6));
                        }
                        else if (scope.copySettings.copyMode === 'timeFrame') {
                            scope.copySettings.start = getNextWeek(new Date(), 1);
                            let temp = this.$qui.createDateFromString(scope.copySettings.start.getTime());
                            scope.copySettings.end = moment(this.$qui.createDateFromString(temp.setDate(temp.getDate() + 6))).add(scope.copySettings.futureWeekSelect, 'weeks').toDate();
                        }
                    };
                    const getNextWeek = function (date, dayOfWeek) {
                        var dayOffset = dayOfWeek > date.getDay()
                            ? dayOfWeek - date.getDay()
                            : dayOfWeek - date.getDay() + 7;
                        date.setDate(date.getDate() + dayOffset);
                        return date;
                    };
                    const weeksBetween = function (date1, date2) {
                        var date1ms = date1.getTime();
                        var date2ms = date2.getTime();
                        var diff = Math.abs(date2ms - date1ms);
                        // round back to weeks
                        return Math.ceil(diff / (1000 * 60 * 60 * 24 * 7));
                    };
                    /////////////////// Gui Helper Functions ///////////////////
                    scope.toggleAll = function (selectAllCandidates = true) {
                        const value = selectAllCandidates ? scope.copySettings.selectAllCandidates : scope.copySettings.selectAllPlannings;
                        for (const selection of selectAllCandidates ? scope.copySettings.candidates : scope.copySettings.plannings) {
                            selection.isChecked = selectAllCandidates || !value ? value : selection.validation.warnings.length + selection.validation.errors.length === 0;
                        }
                        setTimeout(() => {
                            this.$qui.scopeApply(this.$scope);
                        }, 5);
                    };
                    scope.getDayName = function (date) {
                        let dayNumber = (this.$qui.createDateFromString(date)).getDay();
                        if (dayNumber < 0)
                            return scope.dayNames[0];
                        if (dayNumber > 6)
                            return scope.dayNames[6];
                        return scope.dayNames[dayNumber];
                    };
                    scope.anythingOrAllSelected = function (arr, selectAll = false) {
                        let result = false;
                        if (!selectAll) {
                            const itemFound = arr.find((item) => item.isChecked === true);
                            result = itemFound != null ? true : false;
                        }
                        else {
                            result = arr.every(item => item.isChecked === true);
                        }
                        if (selectAll) {
                            if (arr === scope.copySettings.plannings) {
                                scope.copySettings.selectAllPlannings = result;
                                $("#wpcm-toggleAllPlCb").prop("checked", scope.copySettings.selectAllPlannings);
                            }
                            else {
                                scope.copySettings.selectAllCandidates = result;
                                $("#wpcm-toggleAllCandCb").prop("checked", scope.copySettings.selectAllCandidates);
                            }
                        }
                        return result;
                    };
                    scope.getValidationButtonState = function (validation) {
                        if (validation == (null || undefined)) {
                            validation = {
                                errors: [this.lng.translate(20016182, "Noch keine Validierung durchgeführt")],
                                warnings: []
                            };
                        }
                        ;
                        if (validation.errors.length == 0 && validation.warnings.length == 0)
                            return 0;
                        if (validation.errors.length == 0)
                            return 1;
                        return 2;
                    };
                    scope.showValidation = function (item) {
                        scope.currentItem = item;
                        $('#weekplanner-copy-validation-modal').modal('show');
                    };
                    // Workaround part2 since normal modal messes up the dom for whatever reason.
                    scope.hideValidation = function () {
                        $('#weekplanner-copy-validation-modal').modal('hide');
                    };
                    scope.isSaveDisabled = function () {
                        for (const planning of scope.copySettings.plannings) {
                            if (planning.isChecked && !planning.isValidating)
                                return false;
                        }
                        return true;
                    };
                    scope.toggleMode = function () {
                        scope.copySettings.futureWeekSelect = scope.futureWeeks[0].value;
                        setTimeout(() => {
                            scope.calculateCopyWeek();
                        }, 250);
                    };
                    /////////////////// Planning creation ///////////////////
                    scope.createPlannings = function () {
                        var _a, _b, _c, _d, _e, _f;
                        scope.loading = true;
                        scope.copySettings.errors = [];
                        scope.copySettings.plannings = [];
                        const validationObjects = [];
                        //Create plannings
                        for (const candidate of scope.copySettings.candidates) {
                            if (!candidate.isChecked)
                                continue;
                            if (candidate.type === 230000) {
                                const currentCase = candidate.flsCase;
                                if (currentCase == (null || undefined)) {
                                    scope.copySettings.errors.push(this.lng.translate(20016181, "Für den folgenden Fall kann keine Planung angelegt werden") + ': ' + candidate.reportTitle
                                        + ', ' + moment(candidate.dateFrom).format('DD.MM.YYYY HH:mm') + ' - ' + moment(candidate.dateTo).format('DD.MM.YYYY HH:mm'));
                                    continue;
                                }
                                if (scope.copySettings.copyMode == 'target') {
                                    const planning = createWeekPlanningObjectFls(currentCase, candidate, scope.copySettings.futureWeekSelect);
                                    planning.isValidating = true;
                                    validationObjects.push({
                                        dateFrom: planning.dateFrom,
                                        dateTo: planning.dateTo === undefined ? moment(planning.dateFrom).add(1, 'hours').toDate() : planning.dateTo,
                                        hasManualDuration: false,
                                        documentationId: planning.documentationId,
                                        references: [{ caseId: currentCase.objectId, referenceId: currentCase.clientObjectId, accountabilityId: currentCase.defaultAccountableRuleId }],
                                        carer: [{
                                                carerId: (_a = scope.qmCarerId) !== null && _a !== void 0 ? _a : $("#session").data().personId,
                                                activityTypeId: (_b = planning.activityTypeId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                                                contactTypeId: planning.contactTypeId,
                                                careTypeId: planning.careTypeId,
                                                miscontactId: (_c = planning.miscontactId) !== null && _c !== void 0 ? _c : QMC.Common.Constants.FLS_NO_MISCONTACT
                                            }],
                                        manualDuration: 0,
                                        ignoreConfigRoundInterval: false,
                                        requestId: planning.documentationId
                                    });
                                    scope.copySettings.plannings.push(planning);
                                }
                                else if (scope.copySettings.copyMode === 'timeFrame') {
                                    for (let j = 0; j <= scope.copySettings.futureWeekSelect; j++) {
                                        const planning = createWeekPlanningObjectFls(currentCase, candidate, j);
                                        planning.isValidating = true;
                                        validationObjects.push({
                                            dateFrom: planning.dateFrom,
                                            dateTo: planning.dateTo === undefined ? moment(planning.dateFrom).add(1, 'hours').toDate() : planning.dateTo,
                                            hasManualDuration: false,
                                            documentationId: planning.documentationId,
                                            references: [{ caseId: currentCase.objectId, referenceId: currentCase.clientObjectId, accountabilityId: currentCase.defaultAccountableRuleId }],
                                            carer: [{
                                                    carerId: (_d = scope.qmCarerId) !== null && _d !== void 0 ? _d : $("#session").data().personId,
                                                    activityTypeId: (_e = planning.activityTypeId) !== null && _e !== void 0 ? _e : QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                                                    contactTypeId: planning.contactTypeId,
                                                    careTypeId: planning.careTypeId,
                                                    miscontactId: (_f = planning.miscontactId) !== null && _f !== void 0 ? _f : QMC.Common.Constants.FLS_NO_MISCONTACT
                                                }],
                                            manualDuration: 0,
                                            ignoreConfigRoundInterval: false,
                                            requestId: planning.documentationId
                                        });
                                        scope.copySettings.plannings.push(planning);
                                    }
                                }
                            }
                            if (candidate.type === 425000) {
                                if (scope.copySettings.copyMode == 'target') {
                                    const planning = createWeekPlanningObjectAzn(candidate, scope.copySettings.futureWeekSelect);
                                    validatePlanningAzn(planning);
                                    scope.copySettings.plannings.push(planning);
                                }
                                else if (scope.copySettings.copyMode == 'timeFrame') {
                                    for (let j = 0; j <= scope.copySettings.futureWeekSelect; j++) {
                                        const planning = createWeekPlanningObjectAzn(candidate, j);
                                        validatePlanningAzn(planning);
                                        scope.copySettings.plannings.push(planning);
                                    }
                                }
                            }
                        }
                        if (validationObjects.length > 0) {
                            validatePlanningFls(validationObjects);
                        }
                        scope.copySettings.plannings = scope.copySettings.plannings.sort((a, b) => { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                        scope.loading = false;
                    };
                    const validatePlanningFls = function (validationObjects) {
                        scope.flsService.checkForWarningsAndErrors(validationObjects, true).then((data) => {
                            data.forEach(result => {
                                var _a;
                                const planning = scope.copySettings.plannings.filter(x => x.documentationId === result.requestId)[0];
                                if (!planning)
                                    return;
                                planning.validation = result.validation[(_a = scope.qmCarerId) !== null && _a !== void 0 ? _a : $("#session").data().personId];
                                planning.isValidating = false;
                                if (planning.validation.errors.length == 0 && planning.validation.warnings.length == 0)
                                    planning.isChecked = true;
                                else
                                    planning.isChecked = false;
                            });
                            scope.copySettings.isValidationFinished = true;
                        });
                    };
                    const validatePlanningAzn = function (planning) {
                        planning.isValidating = true;
                        scope.aznService.checkForWarningsAndErrors({
                            idObjectAznw: QMC.Common.Constants.GUID_EMPTY,
                            dateFrom: planning.dateFrom,
                            dateTo: planning.dateTo,
                            performingPersonObjIdList: [planning.clientObjectId],
                            activityId: planning.activityTypeId,
                            imputeWvId: QMC.Common.Constants.GUID_EMPTY,
                            instituteId: QMC.Common.Constants.GUID_EMPTY,
                            isPlanned: true
                        }).then((data) => {
                            planning.validation = data;
                            planning.isValidating = false;
                            if (data.errors.length == 0 && data.warnings.length == 0)
                                planning.isChecked = true;
                            else
                                planning.isChecked = false;
                        });
                    };
                    const createWeekPlanningObjectFls = function (currentCase, item, modifier) {
                        let weekModifier = (7 * (modifier + 1));
                        let tempStart = new Date(item.dateFrom.getTime());
                        let tempEnd = new Date(item.dateTo.getTime());
                        let newEntry = {
                            ...item,
                            dateFrom: new Date(tempStart.setDate(tempStart.getDate() + weekModifier)),
                            dateTo: new Date(tempEnd.setDate(tempEnd.getDate() + weekModifier)),
                            flsCaseId: currentCase.objectId,
                            serviceTypeId: currentCase.serviceTypeId,
                            clientObjectId: currentCase.clientObjectId,
                            title: item.title,
                            isValidating: false,
                            isChecked: false,
                            validation: null,
                            type: item.type,
                            documentationId: scope.copySettings.copyMode === 'timeFrame' ? scope.$qui.generateGuid() : item.id,
                            description: ""
                        };
                        return newEntry;
                    };
                    const createWeekPlanningObjectAzn = function (item, modifier) {
                        let weekModifier = (7 * (modifier + 1));
                        let tempStart = new Date(item.dateFrom.getTime());
                        let tempEnd = new Date(item.dateTo.getTime());
                        let newEntry = {
                            dateFrom: new Date(tempStart.setDate(tempStart.getDate() + weekModifier)),
                            dateTo: new Date(tempEnd.setDate(tempEnd.getDate() + weekModifier)),
                            clientObjectId: $('#session').data().personId,
                            flsCaseId: item.aznImputeId,
                            serviceTypeId: item.aznTypeId,
                            title: item.title,
                            isValidating: false,
                            isChecked: false,
                            validation: null,
                            type: item.type,
                            documentationId: QMC.Common.Constants.GUID_EMPTY,
                            description: ""
                        };
                        return newEntry;
                    };
                    scope.postPlannings = function () {
                        var _a;
                        scope.loading = true;
                        let toCreateFls = [];
                        let toCreateAzn = [];
                        for (const planning of scope.copySettings.plannings) {
                            if (planning.isChecked && planning.type === 230000) {
                                toCreateFls.push({
                                    id: null,
                                    objectId: null,
                                    carerId: (_a = scope.qmCarerId) !== null && _a !== void 0 ? _a : $("#session").data().personId,
                                    clientObjectId: planning.clientObjectId,
                                    dateFrom: planning.dateFrom,
                                    dateTo: planning.dateTo,
                                    flsCaseId: planning.flsCaseId,
                                    serviceTypeId: planning.serviceTypeId,
                                    description: null,
                                    documentationId: null,
                                    activityTypeId: planning.activityForm.activityTypeId,
                                    contactTypeId: planning.activityForm.contactTypeId,
                                    careTypeId: planning.activityForm.careTypeId,
                                    miscontactId: !planning.activityForm || planning.activityForm.miscontactId === QMC.Common.Constants.GUID_EMPTY
                                        ? QMC.Common.Constants.FLS_NO_MISCONTACT
                                        : planning.activityForm.miscontactId
                                });
                            }
                            if (planning.isChecked && planning.type === 425000) {
                                toCreateAzn.push({
                                    dateFrom: planning.dateFrom,
                                    dateTo: planning.dateTo,
                                    referencePersonId: planning.clientObjectId,
                                    typeId: planning.serviceTypeId,
                                    imputeId: planning.flsCaseId // ... azn purposes
                                });
                            }
                        }
                        scope.savingFls = false;
                        if (toCreateFls.length > 0) {
                            scope.savingFls = true;
                            this.flsService.postWeekPlanningPlannedDoc(toCreateFls).then((data) => {
                                scope.savingFls = false;
                                finishSaving();
                            });
                        }
                        scope.savingAzn = false;
                        if (toCreateAzn.length > 0) {
                            scope.savingAzn = true;
                            this.aznService.postAznWeekPlanning(toCreateAzn).then((data) => {
                                scope.savingAzn = false;
                                finishSaving();
                            });
                        }
                    };
                    const finishSaving = function () {
                        if (scope.savingAzn || scope.savingFls)
                            return;
                        scope.loading = false;
                        $('#weekplanner-copy-modal').modal('hide');
                        scope.$qui.notify(scope.$qui.successNote);
                    };
                };
            }
        };
        QmWeekPlannerCopyDirective = __decorate([
            QMC.Directive('QMC.Fachleistung', 'qmWeekplannerCopy', ['$qui', '$state', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService', 'ArbeitszeitnachweisService'])
        ], QmWeekPlannerCopyDirective);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let QmWeekPlannerDeleteDirective = class QmWeekPlannerDeleteDirective {
            constructor($qui, $state, lng, permissionService, flsService, aznService) {
                this.$qui = $qui;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                this.aznService = aznService;
                this.restrict = 'E';
                this.templateUrl = './fls/WeekplannerDeleteDirective';
                this.replace = true;
                this.scope = {
                    qmCalendarName: '@',
                    qmData: '=',
                    qmCases: '='
                };
                this.link = (scope) => {
                    //init
                    if (!scope.qmCalendarName || scope.qmCalendarName == '')
                        scope.qmCalendarName = 'calendar';
                    scope.lng = this.lng;
                    scope.flsService = this.flsService;
                    scope.aznService = this.aznService;
                    scope.$qui = this.$qui;
                    scope.$state = this.$state;
                    scope.promptOptions = {
                        title: "Wochenplannung Löschen",
                        yesNo: true,
                        icon: "qm-icon-history2",
                        text: 'Wollen Sie den Einträge wirklich löschen?',
                    };
                    scope.canDeleteAzn = this.deleteAzn;
                    scope.canDeleteFls = this.delete;
                    scope.deleteSettings = {
                        start: null,
                        end: null,
                        plannedItems: [],
                        plannedItemsToDelete: [],
                        errors: [],
                        state: 'select',
                        selectAll: false
                    };
                    scope.$watch('qmData', (newVal, oldVal) => {
                        if (newVal == oldVal)
                            return;
                        const start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        const end = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').end);
                        scope.deleteSettings.plannedItems = [];
                        for (const plannedItem of scope.qmData) {
                            if (plannedItem.dateFrom >= start && plannedItem.dateTo <= end) {
                                scope.deleteSettings.plannedItems.push(plannedItem);
                            }
                        }
                        scope.deleteSettings.plannedItems = scope.deleteSettings.plannedItems.sort((a, b) => { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                    }, true);
                    scope.openDeleteDialog = function () {
                        scope.loading = true;
                        $('#weekplanner-delete-modal').modal('show');
                        scope.deleteSettings.errors = [];
                        scope.deleteSettings.state = 'select';
                        scope.deleteSettings.selectAll = false;
                        //create target Week DropDown Values
                        const start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        // reset checkboxes
                        for (const plannedItem of scope.deleteSettings.plannedItems) {
                            plannedItem.isChecked = false;
                        }
                        $("#wpcm-toggleDeleteAllCb").prop("checked", false);
                        scope.loading = false;
                    };
                    /////////////////// Planning items to be deleted creation ///////////////////
                    scope.createPlanningItemsToBeDeleted = function () {
                        scope.loading = true;
                        scope.deleteSettings.errors = [];
                        scope.deleteSettings.plannedItemsToDelete = [];
                        //Create the items to be deleted with validation
                        for (const plannedItem of scope.deleteSettings.plannedItems) {
                            if (!plannedItem.isChecked)
                                continue;
                            const planningItemToDelete = createWeekPlanningDeleteObjectFls(plannedItem);
                            planningItemToDelete.isChecked = true;
                            scope.deleteSettings.plannedItemsToDelete.push(planningItemToDelete);
                        }
                        scope.deleteSettings.plannedItemsToDelete = scope.deleteSettings.plannedItemsToDelete.sort((a, b) => { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                        scope.deleteSettings.state = 'delete';
                        scope.loading = false;
                    };
                    const createWeekPlanningDeleteObjectFls = function (item) {
                        let newEntry = {
                            id: item.id,
                            objectId: item.objectId,
                            dateTo: item.dateTo,
                            dateFrom: item.dateFrom,
                            isChecked: item.isChecked,
                            type: item.type,
                            flsCase: item.flsCase,
                            title: item.title,
                            aznImputeId: item.aznImputeId,
                            aznTypeId: item.aznTypeId
                        };
                        return newEntry;
                    };
                    /////////////////// Planning items to be deleted creation ///////////////////
                    scope.deletePlannings = function () {
                        scope.loading = true;
                        //QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                        $('#weekplanner-delete-modal').modal('hide');
                        //if (data) {
                        for (const plannedItemToDelete of scope.deleteSettings.plannedItemsToDelete) {
                            if (plannedItemToDelete.type == 230000) {
                                scope.flsService.deleteWeekPlanningPlannedDoc(plannedItemToDelete.objectId).then(() => {
                                    $('#weekplannerCalendar').fullCalendar('removeEvents', plannedItemToDelete.objectId);
                                    scope.RemoveItemsFromDeleteList(plannedItemToDelete);
                                });
                            }
                            if (plannedItemToDelete.type == 425000) {
                                this.aznService.deleteAznWeekPlanning(plannedItemToDelete.id).then(() => {
                                    $('#weekplannerCalendar').fullCalendar('removeEvents', plannedItemToDelete.objectId);
                                    scope.RemoveItemsFromDeleteList(plannedItemToDelete);
                                });
                            }
                        }
                        this.$qui.notify(this.$qui.deleteNotes);
                        setTimeout(() => { scope.$state.go('weekplanner', {}, { reload: true }); }, 500);
                        //}
                        //else {
                        //  $('#weekplanner-delete-modal').modal('hide');
                        //}
                        //});
                        scope.loading = false;
                    };
                    scope.RemoveItemsFromDeleteList = function (deletedItem) {
                        for (let i = 0; i < scope.deleteSettings.plannedItemsToDelete.length; i++) {
                            if (scope.deleteSettings.plannedItemsToDelete[i].objectId === deletedItem.objectId) {
                                scope.deleteSettings.plannedItemsToDelete.splice(i, 1);
                            }
                        }
                    };
                    scope.toggleAllDelete = function (value) {
                        if (value == null || value == undefined)
                            value = scope.deleteSettings.selectAll;
                        for (const plannedItem of scope.deleteSettings.plannedItems) {
                            plannedItem.isChecked = value;
                        }
                        setTimeout(() => {
                            this.$qui.scopeApply(this.$scope);
                        }, 5);
                    };
                    scope.anythingSelected = function (arr) {
                        for (const element of arr)
                            if (element.isChecked)
                                return true;
                        return false;
                    };
                    scope.isDeleteDisabled = function () {
                        for (const plannedItemToDelete of scope.deleteSettings.plannedItemsToDelete) {
                            if (plannedItemToDelete.isChecked)
                                return false;
                        }
                        return true;
                    };
                };
                //ObjectType: FlsZeitplanungSoll
                permissionService.getPermissionsByObjectType(230007).then((data) => {
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                });
                permissionService.getPermissionsByObjectType(411010).then((data) => {
                    this.deleteAzn = data[0].delete && data[0].moduleAccess;
                    this.newAzn = data[0].new && data[0].moduleAccess;
                    this.modifyAzn = data[0].modify && data[0].moduleAccess;
                });
            }
        };
        QmWeekPlannerDeleteDirective = __decorate([
            QMC.Directive('QMC.Fachleistung', 'qmWeekplannerDelete', ['$qui', '$state', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService', 'ArbeitszeitnachweisService'])
        ], QmWeekPlannerDeleteDirective);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        class WeekplannerAznFormDirective {
            constructor(scope, userService) {
                this.scope = scope;
                this.id = '_' + Math.random().toString(36).substring(2, 10);
                this.carerMap = [];
                this.types = [];
                this.loading = { wv: false };
                this.watchers = [];
                this.$postLink = () => {
                    this.events();
                };
                this.$onDestroy = () => {
                    this.watchers.forEach(watcher => watcher());
                };
                userService.getUserSettings(['AZN.SHOWDATETO']).then((data) => {
                    this.showDateTo = data[0].value.toLowerCase() === 'true';
                });
            }
            events() {
                this.watchers.push(this.scope.$watch('vm.carer', () => {
                    var _a, _b;
                    this.carerMap = (_b = (_a = this.carer) === null || _a === void 0 ? void 0 : _a.map(x => ({ text: x.displayTitle, value: x.objectId }))) !== null && _b !== void 0 ? _b : [];
                }, true));
                this.watchers.push(this.scope.$watch('vm.form', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    //reset the form
                    this.id.$setPristine();
                    this.id.$setUntouched();
                }));
            }
            isGuidEmpty(guid) {
                return !guid || guid === QMC.Common.Constants.GUID_EMPTY;
            }
        }
        angular.module('QMC.Fachleistung').component('qmWeekplannerAznForm', {
            templateUrl: './fls/WeekplannerAznForm',
            controller: ['$scope', 'UserService', WeekplannerAznFormDirective],
            controllerAs: 'vm',
            bindings: {
                carer: '=',
                types: '=',
                form: '=?',
                isValid: '=?'
            }
        });
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        class WeekplannerFlsFormDirective {
            constructor(scope, $qui, flsService, userService) {
                this.scope = scope;
                this.$qui = $qui;
                this.flsService = flsService;
                this.id = '_' + Math.random().toString(36).substring(2, 10);
                this.cases = {};
                this.casesMap = [];
                this.carerMap = [];
                this.loading = { wv: false };
                this.watchers = [];
                this.defaultActivities = {
                    activity: QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                    careType: QMC.Common.Constants.GUID_EMPTY,
                    contactType: QMC.Common.Constants.GUID_EMPTY
                };
                // settings
                this.defaultEventLength = 60;
                this.getFutureCases = true;
                this.getPastCases = true;
                this.$postLink = () => {
                    this.events();
                    this.setForm = async (form, caseId, carerId) => {
                        var _a, _b;
                        this.watchers.forEach(watcher => watcher());
                        this.form = form !== null && form !== void 0 ? form : {
                            id: undefined,
                            objectId: undefined,
                            clientObjectId: QMC.Common.Constants.GUID_EMPTY,
                            dateFrom: moment().startOf('hour').toDate(),
                            dateTo: moment().startOf('hour').add(this.defaultEventLength, 'm').toDate(),
                            description: '',
                            documentationId: QMC.Common.Constants.GUID_EMPTY,
                            flsCaseId: QMC.Common.Constants.GUID_EMPTY,
                            serviceTypeId: QMC.Common.Constants.GUID_EMPTY,
                            carerId: ((_a = this.carer) === null || _a === void 0 ? void 0 : _a.some(x => x.objectId === $("#session").data().personId)) ? $("#session").data().personId : QMC.Common.Constants.GUID_EMPTY
                        };
                        this.isMiscontactEnabled = !this.isGuidEmpty(form === null || form === void 0 ? void 0 : form.miscontactId) && (form === null || form === void 0 ? void 0 : form.miscontactId) !== QMC.Common.Constants.FLS_NO_MISCONTACT;
                        this.internalMiscontactId = (_b = form === null || form === void 0 ? void 0 : form.miscontactId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.FLS_NO_MISCONTACT;
                        this.form.flsCaseId = caseId !== null && caseId !== void 0 ? caseId : this.form.flsCaseId;
                        this.form.carerId = carerId !== null && carerId !== void 0 ? carerId : this.form.carerId;
                        if (!this.internalMiscontactId || this.internalMiscontactId === QMC.Common.Constants.GUID_EMPTY)
                            this.internalMiscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                        await this.getWv();
                        this.events();
                        return Promise.resolve(this.form);
                    };
                };
                this.$onDestroy = () => {
                    this.watchers.forEach(watcher => watcher());
                };
                this.setCasesMap = () => {
                    var _a, _b;
                    if (!((_a = this.form) === null || _a === void 0 ? void 0 : _a.carerId))
                        return;
                    if (this.cases[this.form.carerId] === 'loading') {
                        setTimeout(this.setCasesMap, 250);
                        return;
                    }
                    let cases = (_b = this.cases[this.form.carerId]) !== null && _b !== void 0 ? _b : [];
                    if (cases === 'loading')
                        cases = [];
                    if (!this.getFutureCases) {
                        cases = cases.filter(item => moment(item.dateFrom).toDate() <= new Date());
                    }
                    if (!this.getPastCases) {
                        cases = cases.filter(item => !item.dateTo || moment(item.dateTo).endOf("day").toDate() >= new Date());
                    }
                    // if cases are fitlered by current, ensure that current selected case is always present (editing)
                    this.casesMap = cases.filter(x => { var _a; return !this.onlyCurrent || x.isCurrent || ((_a = this.form) === null || _a === void 0 ? void 0 : _a.flsCaseId) === x.objectId; }).map(x => ({ ...this.$qui.createCaseDisplayObject(x), warn: !x.isCurrent }));
                };
                this.getCases = () => {
                    var _a;
                    if (!((_a = this.form) === null || _a === void 0 ? void 0 : _a.carerId) || this.form.carerId === QMC.Common.Constants.GUID_EMPTY)
                        return;
                    this.cases[this.form.carerId] = 'loading';
                    this.flsService.getCasesList(QMC.Common.Constants.GUID_EMPTY, false, this.form.carerId).then((data) => {
                        this.cases[this.form.carerId] = data;
                    }).catch(() => this.cases[this.form.carerId] = []).finally(() => { this.setCaseDependetForm(); this.setCasesMap(); });
                };
                this.setCaseDependetForm = () => {
                    var _a, _b;
                    if (this.form && this.cases[this.form.carerId]) {
                        if (this.cases[this.form.carerId] === 'loading') {
                            setTimeout(this.setCaseDependetForm, 250);
                            return;
                        }
                        const currentCase = this.cases[this.form.carerId].filter(x => this.form.flsCaseId === x.objectId)[0];
                        this.form.clientObjectId = (_a = currentCase === null || currentCase === void 0 ? void 0 : currentCase.clientObjectId) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY;
                        this.form.serviceTypeId = (_b = currentCase === null || currentCase === void 0 ? void 0 : currentCase.serviceTypeId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY;
                    }
                };
                this.flsService.getUserConfig().then(data => {
                    this.defaultActivities.activity = data.defaultActivityType;
                    this.defaultActivities.careType = data.defaultCareType;
                    this.defaultActivities.contactType = data.defaultContactType;
                });
                userService.getUserSettings(['FLS.WEEKPLANNER.DEFAULTEVENTLENGTH', 'FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES', 'FLS.WEEKPLANNER_INCLUDE_PAST_CASES', 'FLS.SHOWDATETO']).then((data) => {
                    this.defaultEventLength = data[0].value && data[0].value.length > 0 ? parseInt(data[0].value) : this.defaultEventLength;
                    this.getFutureCases = data[1].value === "" ? this.getFutureCases : data[1].value.toLowerCase() === "true";
                    this.getPastCases = data[2].value === "" ? this.getPastCases : data[2].value.toLowerCase() === "true";
                    this.showDateTo = data[3].value.toLowerCase() === 'true';
                    this.getWv();
                });
            }
            events() {
                this.watchers.push(this.scope.$watch('vm.onlyCurrent', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.setCasesMap();
                }));
                this.watchers.push(this.scope.$watch('vm.carer', () => {
                    var _a, _b;
                    this.carerMap = (_b = (_a = this.carer) === null || _a === void 0 ? void 0 : _a.map(x => ({ text: x.displayTitle, value: x.objectId }))) !== null && _b !== void 0 ? _b : [];
                }, true));
                this.watchers.push(this.scope.$watch('vm.form.dateFrom', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
                        this.getWv();
                }));
                this.watchers.push(this.scope.$watch('vm.form.flsCaseId', (newVal, oldVal) => {
                    if (newVal !== oldVal)
                        this.getWv();
                    this.setCaseDependetForm();
                }));
                this.watchers.push(this.scope.$watch('vm.form.carerId', (newVal, oldVal) => {
                    if (newVal !== oldVal)
                        this.getWv();
                    this.getCases();
                }));
                this.watchers.push(this.scope.$watch('vm.form', (newVal, oldVal) => {
                    this.setCasesMap();
                    if (newVal === oldVal)
                        return;
                    //reset the form
                    this.id.$setPristine();
                    this.id.$setUntouched();
                }));
                this.watchers.push(this.scope.$watch('vm.internalMiscontactId', () => {
                    if (!this.form)
                        return;
                    if (this.isMiscontactEnabled)
                        if (this.internalMiscontactId === QMC.Common.Constants.FLS_NO_MISCONTACT)
                            this.form.miscontactId = QMC.Common.Constants.GUID_EMPTY;
                        else
                            this.form.miscontactId = this.internalMiscontactId;
                    else {
                        this.form.miscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    }
                }));
                this.watchers.push(this.scope.$watch('vm.isMiscontactEnabled', () => {
                    if (!this.form)
                        return;
                    if (!this.isMiscontactEnabled) {
                        this.internalMiscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                        this.form.miscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    }
                    else if (this.internalMiscontactId === QMC.Common.Constants.FLS_NO_MISCONTACT) {
                        this.form.miscontactId = QMC.Common.Constants.GUID_EMPTY;
                    }
                }));
            }
            shouldDisableActivity() {
                var _a, _b;
                return this.isGuidEmpty((_a = this.form) === null || _a === void 0 ? void 0 : _a.carerId) || this.isGuidEmpty((_b = this.form) === null || _b === void 0 ? void 0 : _b.flsCaseId) || this.loading.wv;
            }
            isGuidEmpty(guid) {
                return !guid || guid === QMC.Common.Constants.GUID_EMPTY;
            }
            getWv() {
                return new Promise((resolve) => {
                    if (this.shouldDisableActivity()) {
                        resolve();
                        return;
                    }
                    this.loading.wv = true;
                    this.flsService.getFlsDocumentationWvModel([this.form.flsCaseId], this.form.documentationId, [this.form.carerId], this.form.dateFrom)
                        .then(data => {
                        this.wvMaps = {
                            activity: data[0].documentationCarerWvModel.activityWv.map(x => ({ text: x.name, value: x.objectId })),
                            careType: data[0].documentationCarerWvModel.careTypeWv.map(x => ({ text: x.name, value: x.objectId })),
                            contactType: data[0].documentationCarerWvModel.contactTypeWv.map(x => ({ text: x.name, value: x.objectId })),
                            miscontact: data[0].documentationCarerWvModel.miscontactWv.map(x => ({ text: x.name, value: x.objectId }))
                        };
                    })
                        .catch(() => this.wvMaps = { activity: [], careType: [], contactType: [], miscontact: [] })
                        .finally(() => {
                        this.loading.wv = false;
                        this.applyDefaultWv();
                        this.setCaseDependetForm();
                        resolve();
                    });
                });
            }
            applyDefaultWv() {
                var _a, _b, _c, _d, _e, _f, _g;
                if (this.isGuidEmpty((_a = this.form) === null || _a === void 0 ? void 0 : _a.objectId)) { // do not automatically alter persisted data
                    if (this.isGuidEmpty(this.form.activityTypeId))
                        this.form.activityTypeId = this.defaultActivities.activity;
                    if (this.isGuidEmpty(this.form.careTypeId))
                        this.form.careTypeId = this.defaultActivities.careType;
                    if (this.isGuidEmpty(this.form.contactTypeId))
                        this.form.contactTypeId = this.defaultActivities.contactType;
                    this.form.activityTypeId = ((_c = (_b = this.wvMaps) === null || _b === void 0 ? void 0 : _b.activity) === null || _c === void 0 ? void 0 : _c.some(x => x.value === this.form.activityTypeId)) ? this.form.activityTypeId : QMC.Common.Constants.DEFAULT_ACTIVITY_ID;
                    this.form.careTypeId = ((_e = (_d = this.wvMaps) === null || _d === void 0 ? void 0 : _d.careType) === null || _e === void 0 ? void 0 : _e.some(x => x.value === this.form.careTypeId)) ? this.form.careTypeId : QMC.Common.Constants.GUID_EMPTY;
                    this.form.contactTypeId = ((_g = (_f = this.wvMaps) === null || _f === void 0 ? void 0 : _f.contactType) === null || _g === void 0 ? void 0 : _g.some(x => x.value === this.form.contactTypeId)) ? this.form.contactTypeId : QMC.Common.Constants.GUID_EMPTY;
                }
                this.$qui.scopeApply(this.scope);
            }
            areRequiredFieldsOkay() {
                var _a, _b;
                const isMiscontactValid = !this.isMiscontactEnabled || !this.isGuidEmpty(this.internalMiscontactId);
                return isMiscontactValid && !this.isGuidEmpty((_a = this.form) === null || _a === void 0 ? void 0 : _a.carerId) && !this.isGuidEmpty((_b = this.form) === null || _b === void 0 ? void 0 : _b.flsCaseId);
            }
        }
        angular.module('QMC.Fachleistung').component('qmWeekplannerFlsForm', {
            templateUrl: './fls/WeekplannerFlsForm',
            controller: ['$scope', '$qui', 'FachleistungService', 'UserService', WeekplannerFlsFormDirective],
            controllerAs: 'vm',
            bindings: {
                onlyCurrent: '=',
                carer: '=',
                form: '=?',
                isValid: '=?',
                setForm: '=?',
            }
        });
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsSignatureListController = class FlsSignatureListController {
            /**
             * QMC.Fachleistung.SignatureController
             * @constructor
             * @param fachleistungsService
             * @param $qui
             * @param $stateParams
             * @param klientService
             * @param $state
             * @param lng
             */
            constructor($location, $scope, fachleistungsService, $qui, $stateParams, klientService, $state, $timeout, userService, lng, permissionService) {
                this.$location = $location;
                this.$scope = $scope;
                this.fachleistungsService = fachleistungsService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.klientService = klientService;
                this.$state = $state;
                this.$timeout = $timeout;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.sliderSizeCacheName = 'SigSliderSizes';
                this.ui = new QMC.Fachleistung.UserInterface();
                this.allowTableExport = false;
                this.filterSearchText = "";
                this.signatureMode = "single";
                this.defaultSigningPerson = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGPERSON;
                this.defaultSigningReason = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGREASON;
                this.defaultSigningReasonText = "";
                this.reasonNotMandatory = false;
                this.allFlsChecked = false;
                this.blockModal = false;
                this.promptOptionsOneMore = {
                    title: "Fachleistungen",
                    yesNo: true,
                    icon: "qm-icon-clock",
                    text: this.lng.translate(20016136, 'Wollen Sie weitere Fachleistungen für den Klienten erfassen?'),
                };
                this.signingPersonClientId = QMC.Common.Constants.SIGNATURE_SIGNING_PERSON_CLIENT;
                this.maxTargetWidth = 600;
                this.maxPossibleWidth = 300;
                this.sigHeight = 150;
                this.sigWidth = 300;
                this.signatureFilterCacheName = "SignatureFilter;";
                this.signatureOnlyCurrentCases = "SignatureOnlyCurrentCases";
                $qui.init($qui.getSectionColor($location.path()), () => {
                    // signatureModal
                    $('#signatureModal').on('hidden.bs.modal', () => {
                        $("#clear-signature").click();
                    });
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.ui.signatureTable.data = [];
                //ObjectType: FlsSignatur
                permissionService.getPermissionsByObjectTypes([230009, 230000]).then((data) => {
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    this.allowTableExport = data[1].print;
                });
                if (document.getElementById("permissions").getAttribute("signature").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                this.filter = {
                    dateFrom: moment().startOf('month').toDate(),
                    dateTo: moment().endOf('month').toDate(),
                    onlyOwn: false,
                    onlyCurrentCases: false
                };
                //get Filter Cache
                this.filter.onlyOwn = JSON.parse(QMC.Common.personalLocalStorage.getItem(this.signatureFilterCacheName));
                this.filter.onlyCurrentCases = JSON.parse(QMC.Common.personalLocalStorage.getItem(this.signatureOnlyCurrentCases));
                this.$qui.getTableAutoload(this.userService).then((ltd) => {
                    this.shouldLoadTableData = ltd;
                    this.userService.getUserSettings(["FLS.SIGNATURE.BLOCK", "FLS.SIGNATURE.HIDEREPORTS", "FLS.SHOWMONTHFILTER", "FLS.MINUTESTOSIGN"]).then((data) => {
                        this.blockModal = (data[0].value.toLowerCase() === "true");
                        if (this.blockModal) {
                            $("#signatureModal").on('shown.bs.modal', () => {
                                $('div.modal-backdrop').css('opacity', 1);
                            });
                        }
                        this.ui.signatureHideReports = data[1].value.toLowerCase() === "true";
                        this.ui.showMonthFilter = data[2].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS : data[2].value.toLowerCase() === "true";
                        this.minutesToSign = data[3].value === "" ? -1 : parseFloat(data[3].value);
                        // when we are in detailmode we need to load the list to allow direct signature
                        if (this.shouldLoadTableData || this.$state.current.name === "signaturedetail") {
                            this.getData();
                        }
                        this.$qui.scopeApply(this.$scope);
                    });
                });
                this.userService.getUserSettings(["FLS.SIGNATURE.DEFAULTSIGNINGPERSON", "FLS.SIGNATURE.DEFAULTSIGNINGREASON", "FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT",
                    "FLS.SIGNATURE.REASONNOTMANDATORY"], false).then((data) => {
                    if (data[0].value !== "")
                        this.defaultSigningPerson = data[0].value;
                    if (data[1].value !== "")
                        this.defaultSigningReason = data[1].value;
                    this.defaultSigningReasonText = data[2].value;
                    this.reasonNotMandatory = data[3].value.toLowerCase() === 'true';
                });
                this.cards = false;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                this.$scope.$watch('vm.user', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    if (this.user === this.signingPersonClientId) {
                        this.reasonWv = QMC.Common.Constants.GUID_EMPTY;
                        this.notice = '';
                        return;
                    }
                    if (this.user === this.defaultSigningPerson) {
                        this.reasonWv = this.defaultSigningReason;
                    }
                });
                this.$scope.$watch('vm.reasonWv', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    if (this.reasonWv === this.defaultSigningReason && this.user !== this.signingPersonClientId) {
                        this.notice = this.defaultSigningReasonText;
                    }
                });
                this.$scope.$watch('vm.selectedMultiSignClient', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.allFlsChecked = false;
                    this.item = null;
                });
                this.$scope.$watch('vm.sigWidth', (newValue, oldValue) => {
                    if (newValue !== oldValue && newValue === 300 && (oldValue === this.maxTargetWidth || oldValue === this.maxPossibleWidth))
                        this.setSigWidth(this.getSigSliderCacheWidth());
                });
                this.$scope.$watch('vm.allFlsChecked', () => {
                    if (!this.multiSignableList || !this.multiSignableList[this.selectedMultiSignClient])
                        return;
                    for (const element of this.multiSignableList[this.selectedMultiSignClient]) {
                        element.isChecked = this.allFlsChecked;
                    }
                    this.isSomethingChecked(this.multiSignableList);
                });
                this.sigResizeWatcher();
            }
            sigResizeWatcher() {
                if (this.maxPossibleWidth !== $('#sig-pad').parent().width())
                    this.setSigWidth(this.getSigSliderCacheWidth());
                if (this.$location.path().indexOf("signature") > 0)
                    setTimeout(() => { this.sigResizeWatcher(); }, 1000);
            }
            /////////////// DISPLAY LOGIC ///////////////
            setSigSliderSizeCache() {
                if (this.maxPossibleWidth <= 0 || this.sigWidth === this.maxTargetWidth || this.sigWidth === 300)
                    return;
                let cache = JSON.parse(QMC.Common.personalLocalStorage.getItem(this.sliderSizeCacheName));
                if (!cache)
                    cache = [];
                for (const element of cache) {
                    if (element.possibleWidth === this.maxPossibleWidth) {
                        element.width = this.sigWidth;
                        QMC.Common.personalLocalStorage.setItem(this.sliderSizeCacheName, JSON.stringify(cache));
                        return;
                    }
                }
                cache.push({
                    possibleWidth: this.maxPossibleWidth,
                    width: this.sigWidth,
                });
                QMC.Common.personalLocalStorage.setItem(this.sliderSizeCacheName, JSON.stringify(cache));
            }
            getSigSliderCacheWidth() {
                let cache = JSON.parse(QMC.Common.personalLocalStorage.getItem(this.sliderSizeCacheName));
                if (!cache)
                    cache = [];
                for (const element of cache) {
                    if (element.possibleWidth === this.maxPossibleWidth) {
                        return element.width;
                    }
                }
                return this.maxTargetWidth;
            }
            setSigWidth(target) {
                this.maxPossibleWidth = $('#sig-pad').parent().width();
                this.sigWidth = this.maxPossibleWidth;
                if (this.maxTargetWidth < this.maxPossibleWidth) {
                    if (target)
                        this.sigWidth = target;
                    else
                        this.sigWidth = this.maxTargetWidth;
                }
                this.setSigHeight();
            }
            setSigHeight() {
                this.sigHeight = this.sigWidth / 2;
                this.$qui.scopeApply(this.$scope);
                this.setSigSliderSizeCache();
            }
            events() {
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.getUnsignedList();
                });
            }
            toggleShowOnlyOwnCreated() {
                QMC.Common.personalLocalStorage.setItem(this.signatureFilterCacheName, this.filter.onlyOwn);
                this.$qui.scopeApply(this.$scope);
            }
            toggleShowOnlyCurrentCases() {
                QMC.Common.personalLocalStorage.setItem(this.signatureOnlyCurrentCases, this.filter.onlyCurrentCases);
                this.$qui.scopeApply(this.$scope);
            }
            getData() {
                this.getUnsignedList();
                this.getWv();
                this.events();
            }
            /**
             * selectItem
             * @description Set the current item.
             * @param item The item selected by the view
             */
            selectItem(item) {
                this.user = this.defaultSigningPerson;
                this.reasonWv = this.defaultSigningReason;
                this.notice = this.defaultSigningReasonText;
                this.signatureMode = "single";
                this.allowedToSign = this.checkIfAllowedToSign(item);
                this.item = item;
                if (this.blockModal)
                    $("#signatureModal").modal({ backdrop: 'static', keyboard: false });
                else
                    $("#signatureModal").modal('show');
            }
            /**
             * Checks if enough time has past from the end of a fls to sign it
             * @param item
             */
            checkIfAllowedToSign(item) {
                var _a;
                if (item) {
                    const endDate = this.$qui.createDateFromString(item.dateToFls);
                    return this.minutesToSign >= 0 ? moment(Date.now()).add(this.minutesToSign, 'm').toDate() > endDate : true;
                }
                if (this.multiSignableList != null) {
                    //no item specified we iterrate through all selected fls'
                    this.allowedToSign = true;
                    for (const item of (_a = this.multiSignableList[this.selectedMultiSignClient]) !== null && _a !== void 0 ? _a : []) {
                        const endDate = this.$qui.createDateFromString(item.dateToFls);
                        this.allowedToSign = this.allowedToSign && this.minutesToSign >= 0 ? moment(Date.now()).add(this.minutesToSign, 'm').toDate() > endDate : true;
                    }
                }
                return this.allowedToSign;
            }
            /**
             * setPutObject
             * @description Set the putItem with all needed properties
             */
            createForm() {
                var _a, _b, _c, _d;
                this.form = {
                    flsDocumentationIds: [(_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.flsDocumentationId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY],
                    clientId: (_d = (_c = this.item) === null || _c === void 0 ? void 0 : _c.referenceObjectId) !== null && _d !== void 0 ? _d : QMC.Common.Constants.GUID_EMPTY,
                    signingPersonWvId: this.user,
                    reasonWvId: this.reasonWv,
                    reason: this.notice,
                    signatureBase64String: this.getSignature()
                };
                // if signing person is client, dont save reasonWv or Text DAA-426
                if (this.form.signingPersonWvId === this.signingPersonClientId) {
                    this.form.reasonWvId = QMC.Common.Constants.GUID_EMPTY;
                    this.form.reason = '';
                }
                if (this.signatureMode === "multi") {
                    this.form.flsDocumentationIds = [];
                    for (const docu of this.multiSignableList[this.selectedMultiSignClient])
                        if (docu.isChecked)
                            if (!this.checkIdInFlsDocumentationIds(docu.flsDocumentationId)) {
                                //just a measure against the "Element mit dem gleichen Schlüssel" error
                                this.form.flsDocumentationIds.push(docu.flsDocumentationId);
                            }
                    this.form.clientId = this.selectedMultiSignClient;
                    this.form.clientFullName = this.getClientName(this.selectedMultiSignClient);
                }
            }
            getClientName(id) {
                const client = this.ui.signatureTable.data.find(x => x.clientObjectId === id);
                return client ? this.$qui.createPersonDisplay(client.clientName, client.clientFirstName) : '';
            }
            checkIdInFlsDocumentationIds(flsDocumentationId) {
                for (const docu of this.form.flsDocumentationIds) {
                    if (docu === flsDocumentationId) {
                        return true;
                    }
                }
                return false;
            }
            openMultipleSignature() {
                this.loading = true;
                $('#loading-modal').modal('show');
                this.user = this.defaultSigningPerson;
                this.reasonWv = this.defaultSigningReason;
                this.notice = this.defaultSigningReasonText;
                this.allFlsChecked = false;
                this.selectedMultiSignClient = null;
                this.signatureMode = "multi";
                this.item = {};
                this.multiSignableList = {};
                this.multiSignableClients = [];
                const tmpClients = [];
                this.ui.signatureTable.data.filter(docu => docu.isMultiSignable && this.checkIfAllowedToSign(docu)).forEach(docu => {
                    if (this.multiSignableList[docu.clientObjectId] === (null || undefined))
                        this.multiSignableList[docu.clientObjectId] = [];
                    docu.isChecked = false;
                    this.multiSignableList[docu.clientObjectId].push(docu);
                });
                for (const client in this.multiSignableList) {
                    if (this.multiSignableList.hasOwnProperty(client)) {
                        tmpClients.push({ id: client, name: this.multiSignableList[client][0].clientDisplayTitle, value: client, text: this.multiSignableList[client][0].clientDisplayTitle });
                    }
                }
                tmpClients.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                this.loading = false;
                $('#loading-modal').modal('hide');
                if (this.blockModal)
                    $("#signatureModal").modal({ backdrop: 'static', keyboard: false });
                else
                    $("#signatureModal").modal('show');
                setTimeout(() => {
                    this.multiSignableClients = tmpClients;
                });
            }
            isSomethingChecked(list) {
                if (list === (null || undefined))
                    return false;
                for (const element of list) {
                    if (element.isChecked) {
                        return true;
                    }
                }
                return false;
            }
            showReportText(docu) {
                docu.isActive = !docu.isActive;
                if (docu.isActive)
                    this.item = docu;
                else
                    this.item = {};
                for (const client of this.multiSignableList[this.selectedMultiSignClient]) {
                    if (client.objectId !== docu.objectId)
                        client.isActive = false;
                }
            }
            closeSignatureModal(close, reload = true) {
                this.$state.params.id = "";
                if (close)
                    this.promptOptions = {
                        title: "Signierung",
                        icon: "qm-icon-clipboard_check_edit",
                        text: this.lng.translate(20016166, 'Wollen Sie die Signierung wirklich abbrechen?'),
                    };
                else
                    this.promptOptions = {
                        title: "Signierung",
                        icon: "qm-icon-clipboard_check_edit",
                        text: this.lng.translate(20000232, 'Sie werden zur Listenansicht weitergeleitet.'),
                        yesNo: 'okay'
                    };
                // use timeout to reload to make sure that modal backdrop has gone
                if (this.blockModal) {
                    QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                        if (data) {
                            $("#signatureModal").modal("hide");
                            if (reload)
                                setTimeout(() => {
                                    this.getUnsignedList();
                                }, 250);
                            this.showOneMore();
                        }
                    }, '#signPrompt');
                }
                else {
                    $("#signatureModal").modal("hide");
                    if (reload)
                        setTimeout(() => {
                            this.getUnsignedList();
                            this.showOneMore();
                        }, 250);
                }
                this.allFlsChecked = false;
            }
            showOneMore() {
                if (this.flsCase && this.flsCase.length > 0 && this.flsCase !== QMC.Common.Constants.GUID_EMPTY) {
                    QMC.Common.Utilities.confirm(this.promptOptionsOneMore, (data) => {
                        if (data) {
                            if (this.flsCase)
                                this.$state.go("documentationnew", { flsCaseIds: [this.flsCase] });
                            setTimeout(() => {
                                $('#prompt').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                            }, 300);
                        }
                    }, '#oneMorePrompt');
                }
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * signatureItem
             * @description Send the signature by fls Id to API
             */
            saveSignature() {
                this.createForm();
                this.closeSignatureModal(false, false);
                this.loading = true;
                this.allFlsChecked = false;
                $('#loading-modal').modal('show');
                this.fachleistungsService.postSignature(this.form).then(() => {
                    this.$qui.notify({
                        message: this.lng.translate(20016206, 'Signatur(en) erfolgreich gespeichert.'),
                        title: this.lng.translate(20016008, 'Signatur'),
                        icon: 'qm-icon-ballpen',
                        status: 'default',
                        timer: 3000,
                        delay: 1000
                    });
                }).finally(() => {
                    this.$state.params.id = "";
                    this.getUnsignedList();
                });
            }
            /**
             * getUnsignedList
             * @description Get all list of all unsigned fls documentations from API
             */
            getUnsignedList() {
                this.loading = true;
                this.$qui.functionWaiter("ui.createTable", this);
                this.$qui.scopeApply(this.$scope);
                /* Remove Listener */
                this.fachleistungsService.getUnsignedFlsDocumentationList(-1, 0, this.filter.dateFrom, this.filter.dateTo, this.filter.onlyOwn, '', this.filter.onlyCurrentCases).then((data) => {
                    this.unsigned = data;
                    data.items.forEach((x) => {
                        x.clientDisplayTitle = this.$qui.createPersonDisplay(x.clientName, x.clientFirstName, x.clientShortCaption, x.clientPersonNr);
                        x.authorDisplayTitle = this.$qui.createPersonDisplay(x.authorName, x.authorFirstName, x.authorShortCaption, x.authorPersonNr);
                    });
                    this.ui.signatureTable.data = data.items;
                    this.$qui.functionWaiter("ui.createTable", this);
                    if (this.$state.current.name === "signaturedetail") {
                        this.$timeout(() => {
                            for (const item of this.unsigned.items) {
                                if (item.objectId === this.$state.params.id) {
                                    this.selectItem(item);
                                    break;
                                }
                            }
                        });
                    }
                    // Do this to know which case was selected when a docu is directly signed
                    const docuId = this.$stateParams.id;
                    for (const docu of this.unsigned.items) {
                        if (docu.objectId === docuId)
                            this.flsCase = docu.flsCaseId;
                    }
                    this.loading = false;
                    $('#loading-modal').modal('hide');
                    this.$qui.scopeApply(this.$scope);
                }).catch(e => {
                    console.error(e);
                    this.ui.signatureTable.data = [];
                }).finally(() => {
                    this.loading = false;
                });
            }
            /**
             * getWv
             * @description Get the WV list from API
             */
            getWv() {
                this.wvLoad = true;
                this.fachleistungsService.getSignatureWv().then((data) => {
                    this.wvLoad = false;
                    this.wv = data;
                    this.signingPersons = this.getSigningPersons();
                    this.reasonsWvList = this.getReasons();
                });
            }
            getSigningPersons() {
                return this.wv.signingPersons.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
            }
            getReasons() {
                return this.wv.reasons.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
            }
        };
        FlsSignatureListController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsSignatureListController'),
            QMC.Inject('$location', '$scope', 'FachleistungService', '$qui', '$stateParams', 'KlientService', '$state', '$timeout', 'UserService', 'QmcLanguageService', 'QmcPermissionService')
        ], FlsSignatureListController);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let FlsSummaryController = class FlsSummaryController {
            constructor($location, flsService, userService, $qui, $stateParams, $scope, $state, $sce, permissionService, $timeout, lng, clientService) {
                this.$location = $location;
                this.flsService = flsService;
                this.userService = userService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.$sce = $sce;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.lng = lng;
                this.clientService = clientService;
                this.allowExport = false;
                this.referencesMap = [];
                this.maps = {
                    wvlivingAreaList: [],
                    wvmarkingsList: [],
                };
                this.filteredTextBlocks = [];
                this.filterText = "";
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.orderAscending = true;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.showTime = false;
                // pagination
                this.page = 0;
                this.pageSize = 30;
                this.filterCacheName = 'flsSummaryFilterCache';
                this.groupTags = {
                    client: this.lng.translate(21002000, 'Klient'),
                    personslist: this.lng.translate(20000237, 'Personenliste'),
                    case: this.lng.translate(20016028, 'Fall')
                };
                const previousState = JSON.parse(QMC.Common.personalLocalStorage.getItem('previousState'));
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                $qui.cachePrivateContentPermission(permissionService);
                permissionService.getPermissionsByObjectTypes([230000]).then((data) => {
                    this.allowExport = data[0].print;
                });
                this.loading = false;
                if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING) !== null) {
                    this.orderAscending = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING) === "true";
                }
                const filterCache = QMC.Common.personalLocalStorage.getItem(this.filterCacheName);
                if (filterCache && filterCache.length > 0) {
                    const cache = JSON.parse(filterCache);
                    this.dateFrom = this.$qui.createDateFromString(cache.dateFrom);
                    this.dateTo = this.$qui.createDateFromString(cache.dateTo);
                }
                else {
                    this.dateFrom = moment().startOf('month').toDate();
                    this.dateTo = moment().endOf('month').toDate();
                }
                if (previousState && previousState.controller === 'FlsDocumentationController' && QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH) !== null) {
                    this.lastSearch = JSON.parse(QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH));
                    if (this.lastSearch) {
                        this.dateFrom = this.$qui.createDateFromString(this.lastSearch.dateFrom);
                        this.dateTo = this.$qui.createDateFromString(this.lastSearch.dateTo);
                        this.filterText = this.lastSearch.searchString;
                        QMC.Common.personalLocalStorage.removeItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH);
                    }
                }
                // datefilter validation and failsafe to defaults:
                if (!(this.dateFrom instanceof Date) || isNaN(this.dateFrom))
                    this.dateFrom = moment().startOf('month').toDate();
                if (!(this.dateTo instanceof Date) || isNaN(this.dateTo))
                    this.dateTo = moment().endOf('month').toDate();
                this.userService.getUserSettings(["SHOWTIMEINSTEADOFDECIMAL", "FLS.SUMMARY.PAGESIZE", QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY]).then((data) => {
                    this.showTime = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[0].value.toLowerCase() === "true";
                    this.pageSize = data[1].value === "" ? this.pageSize : parseInt(data[1].value);
                    this.caseFilter = data[2].value === '' ? this.caseFilter : JSON.parse(data[2].value);
                    this.getCases();
                });
                this.getClients();
            }
            /////////////// DISPLAY LOGIC ///////////////
            formatTimeString(durationInHours) {
                if (this.showTime) {
                    const conv = this.$qui.convertDec(durationInHours);
                    let minutes = conv[1].toString();
                    if (conv[1] < 10)
                        minutes = "0" + minutes;
                    return conv[0] + ":" + minutes;
                }
                else {
                    return durationInHours.toFixed(2).toString().replace('.', ',');
                }
            }
            /**
             * initForm
             * @description Init the form with default values
             */
            init() {
                this.$scope.$watch('vm.page', (newValue, oldValue) => {
                    if (newValue === oldValue || this.dontTriggerPageChange)
                        return;
                    this.getData(false);
                });
                this.$qui.getTableAutoload(this.userService).then((ltd) => {
                    this.shouldLoadTableData = ltd;
                    if (this.shouldLoadTableData) {
                        this.$scope.$watch('vm.selectedReferenceId', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            this.geLivingAreaWvList();
                            this.getData();
                        });
                        this.$scope.$watch('vm.livingAreaIds', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            this.getData();
                        });
                        this.$scope.$watch('vm.markingIds', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            this.getData();
                        });
                        this.$scope.$watch('vm.dateFrom', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            if (this.dateFrom > this.dateTo)
                                this.dateTo = this.dateFrom;
                            this.getData();
                        });
                        this.$scope.$watch('vm.dateTo', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            if (this.dateTo < this.dateFrom)
                                this.dateFrom = this.dateTo;
                            this.getData();
                        });
                        this.$scope.$watch('vm.filterText', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            const lastValue = this.filterText;
                            setTimeout(() => {
                                if (this.filterText === lastValue) {
                                    this.getData();
                                }
                            }, 500);
                        });
                        this.getData();
                    }
                });
            }
            /**
             * currentFilter
             * @description Filter the content by entry.
             * @param entry The entry entered in the View
             */
            currentfilter(entry) {
                const filterActive = $('#filterActive').val();
                console.log(entry, filterActive, entry.isCurrent);
                if (filterActive === 'true')
                    return entry.isCurrent;
                else
                    return true;
            }
            async toggleShowCurrentOnly() {
                this.referencesMap = this.createReferencesMap();
                this.$qui.scopeApply(this.$scope);
                await this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] });
            }
            toggleOrderAscending() {
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING, this.orderAscending.toString());
                if (!this.shouldLoadTableData)
                    return;
                console.log('####: order changed', this.orderAscending);
                this.getData();
            }
            stripHtml(str) {
                const temp = document.createElement('DIV');
                temp.innerHTML = str;
                return temp.textContent.trim() || temp.innerText.trim();
            }
            openDocu(id) {
                this.loading = true;
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH, JSON.stringify({
                    caseId: this.selectedReferenceId,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    searchString: this.filterText,
                    scrollPos: id
                }));
                this.$qui.scopeApply(this.$scope);
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {}
                }));
                this.$state.go("documentationdetail", { id: id });
            }
            changePage(newPage) {
                this.page = newPage;
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * getCases
             * @description Get the aviable fls cases from API
             */
            getCases() {
                this.loading = true;
                this.flsService.getCasesListByViewPermission(false).then((data) => {
                    this.allCases = data;
                    this.referencesMap = this.createReferencesMap();
                    this.loading = false;
                    if (this.lastSearch) {
                        this.selectedReferenceId = this.lastSearch.caseId;
                    }
                    const filterCache = QMC.Common.personalLocalStorage.getItem(this.filterCacheName);
                    if (filterCache && filterCache.length > 0) {
                        const cache = JSON.parse(filterCache);
                        if (this.referencesMap.some(x => x.value === cache.caseId))
                            this.selectedReferenceId = cache.caseId;
                    }
                    this.geLivingAreaWvList();
                    this.$qui.scopeApply(this.$scope);
                    this.init();
                });
            }
            getClients() {
                Promise.all([this.clientService.getMinimalClientList(), this.clientService.getAllPersonLists()]).then(([data, datapl]) => {
                    this.clients = data;
                    this.personlists = datapl;
                    this.referencesMap = this.createReferencesMap();
                    this.$qui.scopeApply(this.$scope);
                });
            }
            createReferencesMap() {
                var _a, _b, _c, _d;
                const cases = ((_b = (_a = this.allCases) === null || _a === void 0 ? void 0 : _a.filter(x => x.isCurrent || !this.caseFilter.onlyCurrentCases)) !== null && _b !== void 0 ? _b : []).map(x => ({ ...this.$qui.createCaseDisplayObject(x), group: this.groupTags.case }));
                const clients = ((_c = this.clients) !== null && _c !== void 0 ? _c : []).map(x => ({ text: this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.personNumber), value: x.id, group: this.groupTags.client }));
                const lists = ((_d = this.personlists) !== null && _d !== void 0 ? _d : []).map(x => ({ text: x.name, value: x.objectId, group: this.groupTags.personslist }));
                return [...cases, ...clients, ...lists];
            }
            geLivingAreaWvList() {
                this.maps.wvlivingAreaList = [];
                this.maps.wvmarkingsList = [];
                this.flsService.getFlsDocumentationWvModel([this.selectedReferenceId], null, [$('#session').data().personId]).then((data) => {
                    if (data.length > 0) {
                        this.maps.wvlivingAreaList = data[0].documentationCarerWvModel.livingAreaWvList.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                        this.maps.wvlivingAreaList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                        this.maps.wvmarkingsList = data[0].documentationCarerWvModel.markingsWvList.map(x => ({ value: x.objectId, text: x.name, isFix: x.isFix }));
                        this.maps.wvmarkingsList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                    }
                });
            }
            /**
             * getSummary
             * @description Get the fls summary by activeCaseId and a dateRange from API
             */
            getData(resetPage = true) {
                if (!this.selectedReferenceId || this.selectedReferenceId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                // cache current filter
                QMC.Common.personalLocalStorage.setItem(this.filterCacheName, JSON.stringify({
                    caseId: this.selectedReferenceId,
                    dateFrom: this.dateFrom,
                    dateto: this.dateTo
                }));
                this.loading = true;
                this.$qui.scopeApply(this.$scope);
                if (resetPage) {
                    this.dontTriggerPageChange = true;
                    this.page = 0;
                    this.dontTriggerPageChange = false;
                }
                let paginationInfo = {
                    page: this.page,
                    pageSize: this.pageSize
                };
                let filter = null;
                filter = {
                    id: this.selectedReferenceId,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    orderAscending: this.orderAscending,
                    pagination: paginationInfo,
                    listSearch: this.filterText,
                    livingAreaIds: this.livingAreaIds,
                    markingIds: this.markingIds,
                    exclude: undefined,
                    referenceType: this.getTypeForId(this.selectedReferenceId)
                };
                this.flsService.getFlsDocumentationSummary(filter).then((data) => {
                    this.summaryItems = data.items;
                    this.paginationInfo = data.paginationInfo;
                    this.loading = false;
                    this.$qui.scopeApply(this.$scope);
                    this.$timeout(() => {
                        if (this.lastSearch) {
                            //document.getElementById('box-' + this.lastSearch.scrollPos).scrollIntoView(true);
                            const element = document.getElementById('box-' + this.lastSearch.scrollPos);
                            const elementRect = element.getBoundingClientRect();
                            const absoluteElementTop = elementRect.top + window.pageYOffset;
                            const middle = absoluteElementTop - (window.innerHeight / 2);
                            window.scrollTo(0, middle);
                        }
                    });
                });
            }
            getTypeForId(id) {
                var _a;
                const group = (_a = this.referencesMap.find(x => x.value === id)) === null || _a === void 0 ? void 0 : _a.group;
                switch (group) {
                    case this.groupTags.personslist:
                        return 190000;
                    case this.groupTags.client:
                        return 140000;
                    case this.groupTags.case:
                    default:
                        return 0;
                }
            }
            print() {
                const areas = document.getElementsByName('printableAreas');
                const winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                for (let i = 0; i < areas.length; i++) {
                    winPrint.document.write(areas[i].innerHTML);
                    if (i % 2 == 1)
                        winPrint.document.write("<br /><br />");
                }
                winPrint.document.close();
                winPrint.focus();
                winPrint.print();
                winPrint.close();
            }
        };
        FlsSummaryController = __decorate([
            QMC.Controller('QMC.Fachleistung', 'FlsSummaryController'),
            QMC.Inject('$location', 'FachleistungService', 'UserService', '$qui', '$stateParams', '$scope', '$state', '$sce', 'QmcPermissionService', '$timeout', 'QmcLanguageService', 'KlientService')
        ], FlsSummaryController);
        Fachleistung.FlsSummaryController = FlsSummaryController;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        let SummaryDirective = class SummaryDirective {
            constructor($location, $qui, $state, $sce, lng, permissionService, flsService) {
                this.$location = $location;
                this.$qui = $qui;
                this.$state = $state;
                this.$sce = $sce;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                this.restrict = 'E';
                this.templateUrl = './fls/SummaryDirective/';
                this.scope = {
                    'qmCaseId': '@',
                    'qmOrderAscending': '@',
                    'qmDateFrom': '@',
                    'qmDateTo': '@',
                    'qmPage': '@',
                    'qmPageSize': '@',
                    'qmShowTime': '@',
                    'qmExclude': '@'
                };
                this.showError = false;
                this.link = (scope) => {
                    scope.$sce = this.$sce;
                    let lastRequest = { case: null, qmDateFrom: null, qmDateTo: null, order: null, page: 0, pageSize: 0 };
                    if (scope.qmPage == (null || undefined))
                        scope.qmPage = 0;
                    if (scope.qmPageSize == (null || undefined))
                        scope.qmPageSize = -1;
                    scope.getSummary = () => {
                        const request = { case: scope.qmCaseId, qmDateFrom: scope.qmDateFrom, qmDateTo: scope.qmDateTo, order: scope.qmOrderAscending, page: scope.qmPage, pageSize: scope.qmPageSize };
                        if (!request.case ||
                            (lastRequest.case == request.case && lastRequest.qmDateFrom == request.qmDateFrom && lastRequest.qmDateTo == request.qmDateTo && request.order == lastRequest.order
                                && lastRequest.page == request.page && lastRequest.pageSize == request.pageSize))
                            return;
                        lastRequest = request;
                        scope.loading = true;
                        this.flsService.getFlsDocumentationSummary({ id: request.case, dateFrom: request.qmDateFrom, dateTo: request.qmDateTo, orderAscending: !scope.qmOrderAscending, pagination: { page: scope.qmPage, pageSize: scope.qmPageSize }, listSearch: '', livingAreaIds: [], markingIds: [], exclude: scope.qmExclude }).then((data) => {
                            scope.summaryItems = data.items;
                            scope.qmPaginationInfo = data.paginationInfo;
                            scope.loading = false;
                        });
                    };
                    scope.formatTimeString = (durationInHours) => {
                        if (scope.qmShowTime) {
                            const conv = this.$qui.convertDec(durationInHours);
                            let minutes = conv[1].toString();
                            if (conv[1] < 10)
                                minutes = "0" + minutes;
                            return conv[0] + ":" + minutes;
                        }
                        else {
                            return durationInHours.toFixed(2).toString().replace('.', ',');
                        }
                    };
                    scope.openDocu = (id) => {
                        QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                            state: this.$state.$current.name,
                            params: {}
                        }));
                        this.$state.go("documentationdetail", { id: id });
                    };
                    scope.stripHtml = (html) => {
                        const temp = document.createElement('DIV');
                        temp.innerHTML = html;
                        return temp.textContent.trim() || temp.innerText.trim();
                    };
                    scope.changePage = (newPage) => {
                        scope.qmPage = newPage;
                    };
                    scope.$watch('qmDateFrom', () => {
                        if (scope.qmDateFrom > scope.qmDateTo)
                            scope.qmDateTo = scope.qmDateFrom;
                        scope.getSummary();
                    });
                    scope.$watch('qmDateTo', () => {
                        if (scope.qmDateTo < scope.qmDateFrom)
                            scope.qmDateFrom = scope.qmDateTo;
                        scope.getSummary();
                    });
                    scope.$watch('qmOrderAscending', () => {
                        scope.getSummary();
                    });
                    scope.$watch('qmPage', () => {
                        scope.getSummary();
                    });
                    scope.$watch('qmPageSize', () => {
                        scope.getSummary();
                    });
                    scope.$watch('qmCaseId', () => {
                        scope.getSummary();
                    });
                    setTimeout(() => {
                        scope.getSummary();
                    }, 500);
                };
            }
        };
        SummaryDirective = __decorate([
            QMC.Directive('QMC.Fachleistung', 'qmFlsSummary', ['$location', '$qui', '$state', '$sce', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService'])
        ], SummaryDirective);
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        /**
         * Fachleistung UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                this.showMonthFilter = true;
                /**
                 * Fachleistung case table
                 * @memberOf UserInterface
                 */
                this.caseTable = {
                    "filter": {
                        "model": null
                    },
                    "table": {
                        //"Checkbox": {
                        //    "id": "objectId",
                        //    "selected": "isChecked",
                        //    "dType": "Checkbox",
                        //    "events": {
                        //        "onChange": "toggleChecked"
                        //    }
                        //},
                        "Bild": {
                            "label": "clientObjectId",
                            "dType": "Avatar",
                            "name": "name",
                            "forename": "forename",
                            "selectable": "true",
                            "selectableExclude": "isGroup",
                            "events": {
                                "onChange": "toggleChecked"
                            },
                            "selected": "isChecked"
                        },
                        "Name": {
                            "label": "fullName",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Leistung": {
                            "label": "internalName",
                            "dType": "string",
                            "lngTag": "20000089"
                        },
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "style": "highlightDate",
                            "lngTag": "20000045"
                        },
                        "Aktueller Fall": {
                            "label": "isCurrent",
                            "dType": "Bool",
                            "invisible": "true",
                        },
                        "Id": {
                            "label": "objectId",
                            "dType": "string",
                            "invisible": "true",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-add blue",
                                "href": "#/fls/documentation/new/{{objectId}}",
                                "label": "objectId",
                                "tooltip": "FLS eintragen",
                                "lngTag": "20016064",
                                "dType": "Button",
                            }, {
                                "icon": "qm-icon-clock orange",
                                "click": "toggleContingentModal",
                                "label": "objectId",
                                "dType": "Button",
                                "tooltip": "Kontingent anzeigen",
                                "lngTag": "20016029",
                            }, {
                                "icon": "qm-icon-dude4 green",
                                "href": "#/stammdaten/detail/{{clientObjectId}}/cover/{{clientObjectId}}",
                                "label": "clientObjectId",
                                "dType": "Button",
                                "events": {
                                    "hide": "isGroup",
                                },
                                "tooltip": "Klient Stammdaten",
                                "lngTag": "21002052",
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }],
                    }, "card": {
                        "idProperty": "objectId",
                        "avatar": {
                            "label": "clientObjectId",
                            "dType": "Avatar",
                            "name": "name",
                            "forename": "forename",
                            "selectable": "true",
                            "selectableExclude": "isGroup",
                            "events": {
                                "onChange": "toggleChecked"
                            },
                            "selected": "isChecked"
                        },
                        "text": {
                            "label": ["fullName"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "internalName",
                                "dType": "string",
                                "style": "highlightDate"
                            },
                            {
                                "label": "date",
                                "dType": "string",
                                "style": "highlightDate"
                            }
                        ],
                        "toggle": {
                            "label": "isCurrent"
                        },
                        "buttons": [{
                                "icon": "qm-icon-add blue",
                                "href": "#/fls/documentation/new/{{objectId}}",
                                "label": "objectId",
                                "tooltip": "FLS eintragen",
                                "lngTag": "20016064",
                                "dType": "Button",
                            }, {
                                "icon": "qm-icon-clock orange",
                                "click": "toggleContingentModal",
                                "label": "objectId",
                                "dType": "Button",
                                "tooltip": "Kontingent anzeigen",
                                "lngTag": "20016029",
                            }, {
                                "icon": "qm-icon-dude4 green",
                                "href": "#/stammdaten/detail/{{clientObjectId}}/cover/{{clientObjectId}}",
                                "label": "clientObjectId",
                                "dType": "Button",
                                "hide": "isGroup",
                                "events": {
                                    "hide": "isGroup",
                                },
                                "tooltip": "Klient Stammdaten",
                                "lngTag": "21002052",
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }],
                    },
                    "data": null,
                };
                /**
                 * Fachleistung documentation list table
                 * @memberOf UserInterface
                 */
                this.documentationTable = {
                    "config": {
                        "defaultSort": "dateFrom",
                        "sortReverse": "true",
                        "tableRowLink": "#/fls/documentation/{{objectId}}",
                    },
                    "filter": {
                        "model": null,
                    },
                    "table": {
                        "Klient": {
                            "label": "personReference",
                            "dType": "string",
                            "lngTag": "21002000",
                            "style": "style"
                        },
                        "Leistung": {
                            "label": "serviceName",
                            "dType": "string",
                            "lngTag": "20000089",
                            "style": "style"
                        },
                        "Zeitraum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060",
                            "style": "style"
                        },
                        "Zeitraum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061",
                            "style": "style"
                        },
                        "Dauer": {
                            "label": "duration",
                            "dType": "Time",
                            "calculate": "true",
                            "lngTag": "20000075",
                            "style": "style"
                        },
                        "Autor": {
                            "label": "authorPerson",
                            "dType": "string",
                            "lngTag": "20000062",
                            "style": "style"
                        },
                        "Erbringer": {
                            "label": "performer",
                            "dType": "string",
                            "lngTag": "20000272",
                            "style": "style"
                        },
                        "Erstellt am": {
                            "label": "createdDate",
                            "dType": "Date",
                            "lngTag": "20000063",
                            "style": "style"
                        },
                        "Signiert": {
                            "label": "isSigned",
                            "dType": "Bool",
                            "invisible": false,
                            "lngTag": "20016105",
                            "style": "style"
                        },
                        "Fahrtdauer": {
                            "label": "drivingDuration",
                            "dType": "Time",
                            "lngTag": "20016153",
                            "calculate": "true",
                            "style": "style"
                        },
                        "Fahrtstrecke": {
                            "label": "drivingDistance",
                            "dType": "Number",
                            "lngTag": "20016154",
                            "calculate": "true",
                            "style": "style"
                        }
                    },
                    "card": {
                        "avatar": {
                            "label": "referenceObjectId",
                            "dType": "Avatar",
                            "name": "personReference",
                            "forename": "personReference",
                            "href": "#/fls/documentation/{{objectId}}",
                        },
                        "text": {
                            "label": "personReference",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "serviceName",
                                "dType": "string",
                            }, {
                                "label": "dateFrom",
                                "dType": "Date",
                                "withTime": "true",
                            }, {
                                "label": "dateTo",
                                "dType": "Date",
                                "withTime": "true",
                            }
                        ],
                        "buttons": [{
                                "icon": "qm-icon-eye blue",
                                "href": "#/fls/documentation/{{objectId}}",
                                "label": "objectId",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000065",
                                "permission": "modify",
                            }]
                    },
                    "data": null,
                    "totalSums": {
                        data: null,
                        columns: {
                            "duration": "totalDuration",
                            "drivingDuration": "totalDrivingDuration",
                            "drivingDistance": "totalDrivingDistance"
                        }
                    }
                };
                this.documentationParticipantsForm = {
                    form: [
                        {
                            label: "Anzahl der Teilnehmer",
                            type: "Number",
                            model: "participantCount",
                            lngTag: 20016086,
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "!(qmScopeCallback().group.onlyNumberOfParticipants)"
                            }
                        },
                        {
                            type: "Select2",
                            model: "participants",
                            multiple: true,
                            label: "Teilnehmer",
                            lngTag: 20016084,
                            dataSource: "getParticipantsList",
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "qmScopeCallback().group.onlyNumberOfParticipants"
                            }
                        },
                        {
                            type: "Select2",
                            model: "participantEmployees",
                            multiple: true,
                            label: "Mitarbeiter",
                            lngTag: 20000235,
                            dataSource: "getParticipantEmployeesList",
                            style: {
                                class: "col-xs-12"
                            }
                        }
                    ]
                };
                this.documentationActivityForm = {
                    form: [
                        {
                            label: "...als",
                            placeholder: "Tätigkeit wählen...",
                            lngTag: 20016047,
                            type: "Select",
                            model: "activityWvId",
                            dataSource: "getActivityList",
                            disabled: true,
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "!(qmForm.isActivityFix)"
                            }
                        },
                        {
                            label: "...als",
                            placeholder: "Tätigkeit wählen...",
                            lngTag: 20016047,
                            type: "Select",
                            model: "activityWvId",
                            dataSource: "getActivityList",
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "(qmForm.isActivityFix)"
                            }
                        },
                        {
                            label: "Kontaktart",
                            placeholder: "Kontaktart wählen...",
                            lngTag: 20016049,
                            type: "Select",
                            model: "contactTypeWvId",
                            dataSource: "getContactList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Betreuungsart",
                            placeholder: "Betreuungsart wählen...",
                            lngTag: 20016051,
                            type: "Select",
                            model: "careTypeWvId",
                            dataSource: "getCareTypeList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "Checkbox",
                            model: "isMiscontactEnabled",
                            style: {
                                class: "col-xs-1"
                            },
                            events: {
                                hideExpression: "(qmForm.isMiscontactRequired)"
                            }
                        },
                        {
                            label: "Fehlkontaktart",
                            lngTag: 20016242,
                            type: "Select",
                            model: "miscontactWvId",
                            dataSource: "getMiscontactList",
                            style: {
                                class: "col-xs-11"
                            },
                            events: {
                                hideExpression: "(!qmForm.isMiscontactEnabled)"
                            }
                        },
                        {
                            label: "Fehlkontaktart",
                            lngTag: 20016242,
                            type: "Select",
                            model: "miscontactWvId",
                            disabled: true,
                            dataSource: "getMiscontactList",
                            style: {
                                class: "col-xs-11"
                            },
                            events: {
                                hideExpression: "(qmForm.isMiscontactEnabled)"
                            }
                        }
                    ]
                };
                this.documentationDrivingCostsForm = {
                    form: [
                        {
                            label: "Stunden",
                            type: "Number",
                            lngTag: 20000219,
                            maxLength: 4,
                            model: "hours",
                            style: {
                                class: "col-md-3 col-xs-6"
                            }
                        },
                        {
                            label: "Minuten",
                            type: "Number",
                            lngTag: 20000247,
                            model: "minutes",
                            style: {
                                class: "col-md-3 col-xs-6"
                            }
                        },
                        {
                            label: "Gefahrene Strecke (in km)",
                            lngTag: 20016056,
                            type: "Number",
                            model: "drivingDistance",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Fahrtkostenart",
                            placeholder: "Fahrtkostenart auswählen",
                            lngTag: 20016087,
                            type: "Select",
                            model: "drivingCostCategoryId",
                            dataSource: "getDrivingCostCategoryList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Abrechnungsart",
                            placeholder: "Abrechnungsart auswählen",
                            lngTag: 20016089,
                            type: "Select",
                            model: "chargingMethodId",
                            dataSource: "getDrivingCostCharingList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Abfahrtsort",
                            placeholder: "Anfahrtsort eingeben..",
                            lngTag: 20016113,
                            type: "Autocomplete",
                            id: "departure",
                            model: "departure",
                            style: {
                                class: "col-xs-12",
                            }
                        },
                        {
                            label: "Anfahrtsort",
                            lngTag: 20016114,
                            placeholder: "Abfahrtsort eingeben..",
                            type: "Autocomplete",
                            model: "destination",
                            id: "destination",
                            style: {
                                class: "col-xs-12"
                            }
                        }
                    ]
                };
                this.documentationTimeForm = {
                    form: [
                        {
                            placeholder: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis",
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            startDate: null,
                            endDate: null,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo",
                                durationInHours: "durationInHours"
                            },
                            style: {
                                class: "col-xs-12 col-md-12"
                            },
                            required: true,
                            config: {
                                displayDateTo: true,
                                displayTime: true,
                                dateFromNotRequired: false,
                                dateToRequired: true,
                                roundInterval: 0,
                                startRoundType: null,
                                endRoundType: null,
                                disableTime: "disableTime",
                            }
                        },
                        {
                            label: "Dauer",
                            model: "timeString",
                            lngTag: 20000075,
                            type: "String",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-clock-o"
                            },
                            events: {
                                hide: "isManualDuration"
                            }
                        },
                        {
                            label: "Stunden",
                            model: "hours",
                            type: "Number",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Minuten",
                            type: "Number",
                            model: "minutes",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Manuelle Dauer",
                            type: "Checkbox",
                            lngTag: 20000213,
                            model: "isManualDuration",
                            id: "isManualDuration",
                            style: {
                                class: "col-lg-2 col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "(!qmForm.isManualTimeAllowed || !qmForm.isManuelTimeVisible)"
                            }
                        },
                        {
                            label: "Stunden auf ausgewählte Fälle verteilen",
                            lngTag: 20016151,
                            model: "distributeHours",
                            id: "distributeHours",
                            type: "Checkbox",
                            style: {
                                class: "col-lg-4 col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "(qmScopeCallback().flsCaseIds.length < 2 || qmForm.distributeHoursFix)"
                            }
                        },
                        {
                            label: "Aufteilung",
                            lngTag: 20016193,
                            model: "splitString",
                            type: "String",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-info"
                            },
                            events: {
                                hideExpression: "!(qmForm.splitString && qmForm.splitString.length > 0)"
                            }
                        },
                    ]
                };
                /**
                 * Facheleistung signature list table
                 * @memberOf UserInterface
                 */
                this.signatureTable = {
                    "config": {
                        "defaultSort": "dateFromFls",
                        "sortReverse": "true",
                        "events": {
                            "click": "selectItem",
                        }
                    },
                    "filter": {
                        "model": null
                    },
                    "table": {
                        "Klient": {
                            "label": "clientDisplayTitle",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Fall": {
                            "label": "flsCaseName",
                            "dType": "string",
                            "lngTag": "20016028"
                        },
                        "Zeitraum von": {
                            "label": "dateFromFls",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060"
                        },
                        "Zeitraum bis": {
                            "label": "dateToFls",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061"
                        },
                        "Autor": {
                            "label": "authorDisplayTitle",
                            "dType": "string",
                            "lngTag": "20000062"
                        },
                        "Erstellt am": {
                            "label": "createdDate",
                            "dType": "Date",
                            "lngTag": "20000063"
                        },
                        "Signierungsart": {
                            "label": "signingType",
                            "dType": "string",
                            "lngTag": "20016062"
                        },
                    },
                    "card": {
                        "avatar": {
                            //"label": "referenceObjectId",
                            //"dType": "Avatar",
                            "icon": "qm-icon-print_layout_single",
                            "name": "clientName",
                            "forename": "clientFirstName"
                        },
                        "text": {
                            "label": ["clientDisplayTitle"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "reportTitle",
                                "dType": "string"
                            },
                            {
                                label: "dateFromFls",
                                dType: "Date",
                                withTime: true
                            },
                            {
                                label: "dateToFls",
                                dType: "Date",
                                withTime: true
                            }
                        ],
                        "buttons": {
                            "icon": "qm-icon-ballpen blue",
                            "click": "selectItem",
                            "label": "data",
                            "tooltip": "Signieren",
                            "lngTag": "20016063",
                            "dType": "Button",
                            "permission": "new"
                        }
                    },
                    "data": null,
                };
                this.rawDocuTable = {
                    "config": {
                        "tableRowLink": "#/fls/documentation/{{objectId}}",
                    },
                    "table": {
                        "Klient": {
                            "label": "clientName",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Leistung": {
                            "label": "caseName",
                            "dType": "string",
                            "lngTag": "20000089"
                        },
                        "Zeitraum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060"
                        },
                        "Zeitraum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061"
                        },
                        "Autor": {
                            "label": "authorName",
                            "dType": "Date",
                            "lngTag": "20000062"
                        },
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-clipboard"
                        },
                        "text": {
                            "label": ["clientName"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "caseName",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "dType": "Date"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-ballpen blue",
                            "label": "data",
                            "href": "#/fls/documentation/{{objectId}}",
                            "tooltip": "Dokumentation ansehen",
                            "dType": "Button",
                            "permission": "new"
                        }
                    },
                    "data": null,
                };
                this.planedDocuTable = {
                    "config": {
                        "events": {
                            "click": "writeFlsObjectToLocalStorage"
                        }
                    },
                    "table": {
                        "Bezeichnung": {
                            "label": "reportTitle",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                        "Klient": {
                            "label": "referencePerson",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Geplanter Erbringer": {
                            "label": "carer",
                            "dType": "string",
                            "lngTag": "20016269"
                        },
                        "Zeitraum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060"
                        },
                        "Zeitraum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061"
                        },
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-clipboard_empty"
                        },
                        "text": {
                            "label": ["reportTitle"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "referencePerson",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "dType": "Date"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-ballpen blue",
                            "label": "data",
                            "click": "writeFlsObjectToLocalStorage",
                            "href": "#/fls/documentation/new/{{flsCaseId}}?plannedDocumentationId={{objectId}}",
                            "tooltip": "Dokumentation ansehen",
                            "dType": "Button",
                            "permission": "new"
                        }
                    },
                    "data": null,
                };
            }
            /**
             * Create a new Guid
             *
             * @private
             * @returns {Guid}
             *
             * @memberof UserInterface
             */
            getNewGuid() {
                var d = new Date().getTime();
                const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    const r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }
            /**
             * Convert a decimal to hours and minutes
             * example 1.5 = 1 hour 30 minutes
             * @param {number} dec
             * @returns {number[]}
             *
             * @memberof UserInterface
             */
            //public convertDec(dec: number): number[] {
            //    if (isNaN(dec)) return [0, 0];
            //    const hours: number = Math.floor(Math.abs(dec));
            //    const minutes: number = Math.floor(Math.abs(dec) * 60 % 60);
            //    return [hours, minutes];
            //}
            convertHours(hours, minutes) {
                if (isNaN(minutes))
                    minutes = parseInt(minutes);
                if (isNaN(hours))
                    hours = parseInt(hours);
                if (isNaN(hours) || isNaN(minutes))
                    return 0;
                return moment.duration(hours + ":" + minutes).asHours();
            }
            /**
             * format the addreses to a readable format
             *
             * @param {Klient.IAddressByTypeListItem[]} data
             * @returns {*}
             *
             * @memberof UserInterface
             */
            formatAddresses(data) {
                const addresses = [];
                for (let i = 0; i < data.length; i++) {
                    let displayName = data[i].name;
                    displayName += data[i].forename.length > 0 ? ", " + data[i].forename + " (" + data[i].street : " (" + data[i].street;
                    displayName += data[i].street.length > 0 ? " " + data[i].houseNumber : data[i].houseNumber;
                    displayName += data[i].street.length > 0 || data[i].houseNumber.length > 0 ? ", " + data[i].postCode : data[i].postCode;
                    displayName += data[i].postCode.length > 0 ? " " + data[i].city : data[i].city;
                    displayName += data[i].postCode.length > 0 || data[i].city.length > 0 ? ", " + data[i].country + ")" : data[i].country + ")";
                    let value = data[i].forename;
                    value += data[i].forename.length > 0 ? " " + data[i].name : data[i].name;
                    value += data[i].street.length > 0 || data[i].houseNumber.length > 0 ? ", " + data[i].street + " " + data[i].houseNumber : "";
                    value += data[i].city.length > 0 || data[i].postCode.length > 0 ? ", " + data[i].postCode + " " + data[i].city : "";
                    value += data[i].country.length > 0 ? ", " + data[i].country : "";
                    addresses.push({
                        displayName: displayName,
                        value: value,
                        objectTypeName: data[i].objectTypeName
                    });
                }
                return addresses;
            }
        }
        Fachleistung.UserInterface = UserInterface;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Fachleistung/qmc.fachleistung.js.map
